(() => {

      var $parcel$global = globalThis;
    
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiredd45"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiredd45"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("ik8y3", function(module, exports) {

$parcel$export(module.exports, "default", () => Jn);
var t = "object" == typeof $parcel$global && $parcel$global && $parcel$global.Object === Object && $parcel$global, e = "object" == typeof self && self && self.Object === Object && self, r = t || e || Function("return this")(), n = r.Symbol, o = Object.prototype, i = o.hasOwnProperty, s = o.toString, a = n ? n.toStringTag : void 0, u = Object.prototype.toString, c = "[object Null]", f = "[object Undefined]", h = n ? n.toStringTag : void 0;
function l(t) {
    return null == t ? void 0 === t ? f : c : h && h in Object(t) ? function(t) {
        var e = i.call(t, a), r = t[a];
        try {
            t[a] = void 0;
            var n = !0;
        } catch (t) {}
        var o = s.call(t);
        return n && (e ? t[a] = r : delete t[a]), o;
    }(t) : function(t) {
        return u.call(t);
    }(t);
}
function d(t) {
    return null != t && "object" == typeof t;
}
var p = "[object Symbol]";
function w(t) {
    return "symbol" == typeof t || d(t) && l(t) == p;
}
function g(t, e) {
    for(var r = -1, n = null == t ? 0 : t.length, o = Array(n); ++r < n;)o[r] = e(t[r], r, t);
    return o;
}
var v = Array.isArray, y = 1 / 0, _ = n ? n.prototype : void 0, b = _ ? _.toString : void 0;
function m(t) {
    if ("string" == typeof t) return t;
    if (v(t)) return g(t, m) + "";
    if (w(t)) return b ? b.call(t) : "";
    var e = t + "";
    return "0" == e && 1 / t == -y ? "-0" : e;
}
function j(t) {
    var e = typeof t;
    return null != t && ("object" == e || "function" == e);
}
function S(t) {
    return t;
}
var O = "[object AsyncFunction]", x = "[object Function]", k = "[object GeneratorFunction]", A = "[object Proxy]";
function E(t) {
    if (!j(t)) return !1;
    var e = l(t);
    return e == x || e == k || e == O || e == A;
}
var z, F = r["__core-js_shared__"], P = (z = /[^.]+$/.exec(F && F.keys && F.keys.IE_PROTO || "")) ? "Symbol(src)_1." + z : "", T = Function.prototype.toString;
function I(t) {
    if (null != t) {
        try {
            return T.call(t);
        } catch (t) {}
        try {
            return t + "";
        } catch (t) {}
    }
    return "";
}
var M = /^\[object .+?Constructor\]$/, N = RegExp("^" + Function.prototype.toString.call(Object.prototype.hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
function $(t, e) {
    var r = function(t, e) {
        return null == t ? void 0 : t[e];
    }(t, e);
    return function(t) {
        var e;
        return !(!j(t) || (e = t, P && P in e)) && (E(t) ? N : M).test(I(t));
    }(r) ? r : void 0;
}
var W, C, D, V = $(r, "WeakMap"), R = Object.create, U = function() {
    function t() {}
    return function(e) {
        if (!j(e)) return {};
        if (R) return R(e);
        t.prototype = e;
        var r = new t;
        return t.prototype = void 0, r;
    };
}(), q = Date.now, L = function() {
    try {
        var t = $(Object, "defineProperty");
        return t({}, "", {}), t;
    } catch (t) {}
}(), B = L, J = B ? function(t, e) {
    var r;
    return B(t, "toString", {
        configurable: !0,
        enumerable: !1,
        value: (r = e, function() {
            return r;
        }),
        writable: !0
    });
} : S, H = (W = J, C = 0, D = 0, function() {
    var t = q(), e = 16 - (t - D);
    if (D = t, e > 0) {
        if (++C >= 800) return arguments[0];
    } else C = 0;
    return W.apply(void 0, arguments);
});
function G(t) {
    return t != t;
}
function Y(t, e) {
    return !(null == t || !t.length) && function(t, e, r) {
        return e == e ? function(t, e, r) {
            for(var n = -1, o = t.length; ++n < o;)if (t[n] === e) return n;
            return -1;
        }(t, e) : function(t, e, r, n) {
            for(var o = t.length, i = -1; ++i < o;)if (e(t[i], i, t)) return i;
            return -1;
        }(t, G);
    }(t, e) > -1;
}
var K = 9007199254740991, Q = /^(?:0|[1-9]\d*)$/;
function X(t, e) {
    var r = typeof t;
    return !!(e = null == e ? K : e) && ("number" == r || "symbol" != r && Q.test(t)) && t > -1 && t % 1 == 0 && t < e;
}
function Z(t, e, r) {
    "__proto__" == e && B ? B(t, e, {
        configurable: !0,
        enumerable: !0,
        value: r,
        writable: !0
    }) : t[e] = r;
}
function tt(t, e) {
    return t === e || t != t && e != e;
}
var et = Object.prototype.hasOwnProperty;
function rt(t, e, r) {
    var n = t[e];
    et.call(t, e) && tt(n, r) && (void 0 !== r || e in t) || Z(t, e, r);
}
function nt(t, e, r, n) {
    var o = !r;
    r || (r = {});
    for(var i = -1, s = e.length; ++i < s;){
        var a = e[i], u = n ? n(r[a], t[a], a, r, t) : void 0;
        void 0 === u && (u = t[a]), o ? Z(r, a, u) : rt(r, a, u);
    }
    return r;
}
var ot = Math.max;
function it(t, e) {
    return H(function(t, e, r) {
        return e = ot(void 0 === e ? t.length - 1 : e, 0), function() {
            for(var n = arguments, o = -1, i = ot(n.length - e, 0), s = Array(i); ++o < i;)s[o] = n[e + o];
            o = -1;
            for(var a = Array(e + 1); ++o < e;)a[o] = n[o];
            return a[e] = r(s), function(t, e, r) {
                switch(r.length){
                    case 0:
                        return t.call(e);
                    case 1:
                        return t.call(e, r[0]);
                    case 2:
                        return t.call(e, r[0], r[1]);
                    case 3:
                        return t.call(e, r[0], r[1], r[2]);
                }
                return t.apply(e, r);
            }(t, this, a);
        };
    }(t, e, S), t + "");
}
var st = 9007199254740991;
function at(t) {
    return "number" == typeof t && t > -1 && t % 1 == 0 && t <= st;
}
function ut(t) {
    return null != t && at(t.length) && !E(t);
}
function ct(t, e, r) {
    if (!j(r)) return !1;
    var n = typeof e;
    return !!("number" == n ? ut(r) && X(e, r.length) : "string" == n && e in r) && tt(r[e], t);
}
var ft = Object.prototype;
function ht(t) {
    var e = t && t.constructor;
    return t === ("function" == typeof e && e.prototype || ft);
}
function lt(t) {
    return d(t) && "[object Arguments]" == l(t);
}
var dt = Object.prototype, pt = dt.hasOwnProperty, wt = dt.propertyIsEnumerable, gt = lt(function() {
    return arguments;
}()) ? lt : function(t) {
    return d(t) && pt.call(t, "callee") && !wt.call(t, "callee");
}, vt = exports && !exports.nodeType && exports, yt = vt && true && module && !module.nodeType && module, _t = yt && yt.exports === vt ? r.Buffer : void 0, bt = (_t ? _t.isBuffer : void 0) || function() {
    return !1;
}, mt = {};
function jt(t) {
    return function(e) {
        return t(e);
    };
}
mt["[object Float32Array]"] = mt["[object Float64Array]"] = mt["[object Int8Array]"] = mt["[object Int16Array]"] = mt["[object Int32Array]"] = mt["[object Uint8Array]"] = mt["[object Uint8ClampedArray]"] = mt["[object Uint16Array]"] = mt["[object Uint32Array]"] = !0, mt["[object Arguments]"] = mt["[object Array]"] = mt["[object ArrayBuffer]"] = mt["[object Boolean]"] = mt["[object DataView]"] = mt["[object Date]"] = mt["[object Error]"] = mt["[object Function]"] = mt["[object Map]"] = mt["[object Number]"] = mt["[object Object]"] = mt["[object RegExp]"] = mt["[object Set]"] = mt["[object String]"] = mt["[object WeakMap]"] = !1;
var St = exports && !exports.nodeType && exports, Ot = St && true && module && !module.nodeType && module, xt = Ot && Ot.exports === St && t.process, kt = function() {
    try {
        return Ot && Ot.require && Ot.require("util").types || xt && xt.binding && xt.binding("util");
    } catch (t) {}
}(), At = kt && kt.isTypedArray, Et = At ? jt(At) : function(t) {
    return d(t) && at(t.length) && !!mt[l(t)];
}, zt = Object.prototype.hasOwnProperty;
function Ft(t, e) {
    var r = v(t), n = !r && gt(t), o = !r && !n && bt(t), i = !r && !n && !o && Et(t), s = r || n || o || i, a = s ? function(t, e) {
        for(var r = -1, n = Array(t); ++r < t;)n[r] = e(r);
        return n;
    }(t.length, String) : [], u = a.length;
    for(var c in t)!e && !zt.call(t, c) || s && ("length" == c || o && ("offset" == c || "parent" == c) || i && ("buffer" == c || "byteLength" == c || "byteOffset" == c) || X(c, u)) || a.push(c);
    return a;
}
function Pt(t, e) {
    return function(r) {
        return t(e(r));
    };
}
var Tt = Pt(Object.keys, Object), It = Object.prototype.hasOwnProperty;
function Mt(t) {
    return ut(t) ? Ft(t) : function(t) {
        if (!ht(t)) return Tt(t);
        var e = [];
        for(var r in Object(t))It.call(t, r) && "constructor" != r && e.push(r);
        return e;
    }(t);
}
var Nt = Object.prototype.hasOwnProperty;
function $t(t) {
    return ut(t) ? Ft(t, !0) : function(t) {
        if (!j(t)) return function(t) {
            var e = [];
            if (null != t) for(var r in Object(t))e.push(r);
            return e;
        }(t);
        var e = ht(t), r = [];
        for(var n in t)("constructor" != n || !e && Nt.call(t, n)) && r.push(n);
        return r;
    }(t);
}
var Wt = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, Ct = /^\w*$/;
function Dt(t, e) {
    if (v(t)) return !1;
    var r = typeof t;
    return !("number" != r && "symbol" != r && "boolean" != r && null != t && !w(t)) || Ct.test(t) || !Wt.test(t) || null != e && t in Object(e);
}
var Vt = $(Object, "create"), Rt = Object.prototype.hasOwnProperty, Ut = Object.prototype.hasOwnProperty;
function qt(t) {
    var e = -1, r = null == t ? 0 : t.length;
    for(this.clear(); ++e < r;){
        var n = t[e];
        this.set(n[0], n[1]);
    }
}
function Lt(t, e) {
    for(var r = t.length; r--;)if (tt(t[r][0], e)) return r;
    return -1;
}
qt.prototype.clear = function() {
    this.__data__ = Vt ? Vt(null) : {}, this.size = 0;
}, qt.prototype.delete = function(t) {
    var e = this.has(t) && delete this.__data__[t];
    return this.size -= e ? 1 : 0, e;
}, qt.prototype.get = function(t) {
    var e = this.__data__;
    if (Vt) {
        var r = e[t];
        return "__lodash_hash_undefined__" === r ? void 0 : r;
    }
    return Rt.call(e, t) ? e[t] : void 0;
}, qt.prototype.has = function(t) {
    var e = this.__data__;
    return Vt ? void 0 !== e[t] : Ut.call(e, t);
}, qt.prototype.set = function(t, e) {
    var r = this.__data__;
    return this.size += this.has(t) ? 0 : 1, r[t] = Vt && void 0 === e ? "__lodash_hash_undefined__" : e, this;
};
var Bt = Array.prototype.splice;
function Jt(t) {
    var e = -1, r = null == t ? 0 : t.length;
    for(this.clear(); ++e < r;){
        var n = t[e];
        this.set(n[0], n[1]);
    }
}
Jt.prototype.clear = function() {
    this.__data__ = [], this.size = 0;
}, Jt.prototype.delete = function(t) {
    var e = this.__data__, r = Lt(e, t);
    return !(r < 0 || (r == e.length - 1 ? e.pop() : Bt.call(e, r, 1), --this.size, 0));
}, Jt.prototype.get = function(t) {
    var e = this.__data__, r = Lt(e, t);
    return r < 0 ? void 0 : e[r][1];
}, Jt.prototype.has = function(t) {
    return Lt(this.__data__, t) > -1;
}, Jt.prototype.set = function(t, e) {
    var r = this.__data__, n = Lt(r, t);
    return n < 0 ? (++this.size, r.push([
        t,
        e
    ])) : r[n][1] = e, this;
};
var Ht = $(r, "Map");
function Gt(t, e) {
    var r, n, o = t.__data__;
    return ("string" == (n = typeof (r = e)) || "number" == n || "symbol" == n || "boolean" == n ? "__proto__" !== r : null === r) ? o["string" == typeof e ? "string" : "hash"] : o.map;
}
function Yt(t) {
    var e = -1, r = null == t ? 0 : t.length;
    for(this.clear(); ++e < r;){
        var n = t[e];
        this.set(n[0], n[1]);
    }
}
function Kt(t, e) {
    if ("function" != typeof t || null != e && "function" != typeof e) throw new TypeError("Expected a function");
    var r = function() {
        var n = arguments, o = e ? e.apply(this, n) : n[0], i = r.cache;
        if (i.has(o)) return i.get(o);
        var s = t.apply(this, n);
        return r.cache = i.set(o, s) || i, s;
    };
    return r.cache = new (Kt.Cache || Yt), r;
}
Yt.prototype.clear = function() {
    this.size = 0, this.__data__ = {
        hash: new qt,
        map: new (Ht || Jt),
        string: new qt
    };
}, Yt.prototype.delete = function(t) {
    var e = Gt(this, t).delete(t);
    return this.size -= e ? 1 : 0, e;
}, Yt.prototype.get = function(t) {
    return Gt(this, t).get(t);
}, Yt.prototype.has = function(t) {
    return Gt(this, t).has(t);
}, Yt.prototype.set = function(t, e) {
    var r = Gt(this, t), n = r.size;
    return r.set(t, e), this.size += r.size == n ? 0 : 1, this;
}, Kt.Cache = Yt;
var Qt, Xt, Zt = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, te = /\\(\\)?/g, ee = (Qt = Kt(function(t) {
    var e = [];
    return 46 === t.charCodeAt(0) && e.push(""), t.replace(Zt, function(t, r, n, o) {
        e.push(n ? o.replace(te, "$1") : r || t);
    }), e;
}, function(t) {
    return 500 === Xt.size && Xt.clear(), t;
}), Xt = Qt.cache, Qt);
function re(t, e) {
    return v(t) ? t : Dt(t, e) ? [
        t
    ] : ee(function(t) {
        return null == t ? "" : m(t);
    }(t));
}
var ne = 1 / 0;
function oe(t) {
    if ("string" == typeof t || w(t)) return t;
    var e = t + "";
    return "0" == e && 1 / t == -ne ? "-0" : e;
}
function ie(t, e) {
    for(var r = 0, n = (e = re(e, t)).length; null != t && r < n;)t = t[oe(e[r++])];
    return r && r == n ? t : void 0;
}
function se(t, e) {
    for(var r = -1, n = e.length, o = t.length; ++r < n;)t[o + r] = e[r];
    return t;
}
var ae = n ? n.isConcatSpreadable : void 0;
function ue(t) {
    return v(t) || gt(t) || !!(ae && t && t[ae]);
}
function ce(t, e, r, n, o) {
    var i = -1, s = t.length;
    for(r || (r = ue), o || (o = []); ++i < s;){
        var a = t[i];
        e > 0 && r(a) ? e > 1 ? ce(a, e - 1, r, n, o) : se(o, a) : n || (o[o.length] = a);
    }
    return o;
}
var fe = Pt(Object.getPrototypeOf, Object);
function he(t) {
    var e = this.__data__ = new Jt(t);
    this.size = e.size;
}
he.prototype.clear = function() {
    this.__data__ = new Jt, this.size = 0;
}, he.prototype.delete = function(t) {
    var e = this.__data__, r = e.delete(t);
    return this.size = e.size, r;
}, he.prototype.get = function(t) {
    return this.__data__.get(t);
}, he.prototype.has = function(t) {
    return this.__data__.has(t);
}, he.prototype.set = function(t, e) {
    var r = this.__data__;
    if (r instanceof Jt) {
        var n = r.__data__;
        if (!Ht || n.length < 199) return n.push([
            t,
            e
        ]), this.size = ++r.size, this;
        r = this.__data__ = new Yt(n);
    }
    return r.set(t, e), this.size = r.size, this;
};
var le = exports && !exports.nodeType && exports, de = le && true && module && !module.nodeType && module, pe = de && de.exports === le ? r.Buffer : void 0, we = pe ? pe.allocUnsafe : void 0;
function ge() {
    return [];
}
var ve = Object.prototype.propertyIsEnumerable, ye = Object.getOwnPropertySymbols, _e = ye ? function(t) {
    return null == t ? [] : (t = Object(t), function(e, r) {
        for(var n = -1, o = null == e ? 0 : e.length, i = 0, s = []; ++n < o;){
            var a = e[n];
            ve.call(t, a) && (s[i++] = a);
        }
        return s;
    }(ye(t)));
} : ge, be = _e, me = Object.getOwnPropertySymbols ? function(t) {
    for(var e = []; t;)se(e, be(t)), t = fe(t);
    return e;
} : ge;
function je(t, e, r) {
    var n = e(t);
    return v(t) ? n : se(n, r(t));
}
function Se(t) {
    return je(t, Mt, be);
}
function Oe(t) {
    return je(t, $t, me);
}
var xe = $(r, "DataView"), ke = $(r, "Promise"), Ae = $(r, "Set"), Ee = "[object Map]", ze = "[object Promise]", Fe = "[object Set]", Pe = "[object WeakMap]", Te = "[object DataView]", Ie = I(xe), Me = I(Ht), Ne = I(ke), $e = I(Ae), We = I(V), Ce = l;
(xe && Ce(new xe(new ArrayBuffer(1))) != Te || Ht && Ce(new Ht) != Ee || ke && Ce(ke.resolve()) != ze || Ae && Ce(new Ae) != Fe || V && Ce(new V) != Pe) && (Ce = function(t) {
    var e = l(t), r = "[object Object]" == e ? t.constructor : void 0, n = r ? I(r) : "";
    if (n) switch(n){
        case Ie:
            return Te;
        case Me:
            return Ee;
        case Ne:
            return ze;
        case $e:
            return Fe;
        case We:
            return Pe;
    }
    return e;
});
var De = Ce, Ve = Object.prototype.hasOwnProperty, Re = r.Uint8Array;
function Ue(t) {
    var e = new t.constructor(t.byteLength);
    return new Re(e).set(new Re(t)), e;
}
var qe = /\w*$/, Le = n ? n.prototype : void 0, Be = Le ? Le.valueOf : void 0, Je = "[object Boolean]", He = "[object Date]", Ge = "[object Map]", Ye = "[object Number]", Ke = "[object RegExp]", Qe = "[object Set]", Xe = "[object String]", Ze = "[object Symbol]", tr = "[object ArrayBuffer]", er = "[object DataView]", rr = "[object Float32Array]", nr = "[object Float64Array]", or = "[object Int8Array]", ir = "[object Int16Array]", sr = "[object Int32Array]", ar = "[object Uint8Array]", ur = "[object Uint8ClampedArray]", cr = "[object Uint16Array]", fr = "[object Uint32Array]", hr = kt && kt.isMap, lr = hr ? jt(hr) : function(t) {
    return d(t) && "[object Map]" == De(t);
}, dr = kt && kt.isSet, pr = dr ? jt(dr) : function(t) {
    return d(t) && "[object Set]" == De(t);
}, wr = 1, gr = 2, vr = 4, yr = "[object Arguments]", _r = "[object Function]", br = "[object GeneratorFunction]", mr = "[object Object]", jr = {};
function Sr(t, e, r, n, o, i) {
    var s, a = e & wr, u = e & gr, c = e & vr;
    if (r && (s = o ? r(t, n, o, i) : r(t)), void 0 !== s) return s;
    if (!j(t)) return t;
    var f = v(t);
    if (f) {
        if (s = function(t) {
            var e = t.length, r = new t.constructor(e);
            return e && "string" == typeof t[0] && Ve.call(t, "index") && (r.index = t.index, r.input = t.input), r;
        }(t), !a) return function(t, e) {
            var r = -1, n = t.length;
            for(e || (e = Array(n)); ++r < n;)e[r] = t[r];
            return e;
        }(t, s);
    } else {
        var h = De(t), l = h == _r || h == br;
        if (bt(t)) return function(t, e) {
            if (e) return t.slice();
            var r = t.length, n = we ? we(r) : new t.constructor(r);
            return t.copy(n), n;
        }(t, a);
        if (h == mr || h == yr || l && !o) {
            if (s = u || l ? {} : function(t) {
                return "function" != typeof t.constructor || ht(t) ? {} : U(fe(t));
            }(t), !a) return u ? function(t, e) {
                return nt(t, me(t), e);
            }(t, function(t, e) {
                return t && nt(e, $t(e), t);
            }(s, t)) : function(t, e) {
                return nt(t, be(t), e);
            }(t, function(t, e) {
                return t && nt(e, Mt(e), t);
            }(s, t));
        } else {
            if (!jr[h]) return o ? t : {};
            s = function(t, e, r) {
                var n, o, i = t.constructor;
                switch(e){
                    case tr:
                        return Ue(t);
                    case Je:
                    case He:
                        return new i(+t);
                    case er:
                        return function(t, e) {
                            var r = e ? Ue(t.buffer) : t.buffer;
                            return new t.constructor(r, t.byteOffset, t.byteLength);
                        }(t, r);
                    case rr:
                    case nr:
                    case or:
                    case ir:
                    case sr:
                    case ar:
                    case ur:
                    case cr:
                    case fr:
                        return function(t, e) {
                            var r = e ? Ue(t.buffer) : t.buffer;
                            return new t.constructor(r, t.byteOffset, t.length);
                        }(t, r);
                    case Ge:
                        return new i;
                    case Ye:
                    case Xe:
                        return new i(t);
                    case Ke:
                        return (o = new (n = t).constructor(n.source, qe.exec(n))).lastIndex = n.lastIndex, o;
                    case Qe:
                        return new i;
                    case Ze:
                        return Be ? Object(Be.call(t)) : {};
                }
            }(t, h, a);
        }
    }
    i || (i = new he);
    var d = i.get(t);
    if (d) return d;
    i.set(t, s), pr(t) ? t.forEach(function(n) {
        s.add(Sr(n, e, r, n, t, i));
    }) : lr(t) && t.forEach(function(n, o) {
        s.set(o, Sr(n, e, r, o, t, i));
    });
    var p = f ? void 0 : (c ? u ? Oe : Se : u ? $t : Mt)(t);
    return function(t, e) {
        for(var r = -1, n = null == t ? 0 : t.length; ++r < n && !1 !== e(t[r], r););
    }(p || t, function(n, o) {
        p && (n = t[o = n]), rt(s, o, Sr(n, e, r, o, t, i));
    }), s;
}
function Or(t) {
    return Sr(t, 4);
}
function xr(t) {
    var e = -1, r = null == t ? 0 : t.length;
    for(this.__data__ = new Yt; ++e < r;)this.add(t[e]);
}
function kr(t, e) {
    for(var r = -1, n = null == t ? 0 : t.length; ++r < n;)if (e(t[r], r, t)) return !0;
    return !1;
}
function Ar(t, e) {
    return t.has(e);
}
jr[yr] = jr["[object Array]"] = jr["[object ArrayBuffer]"] = jr["[object DataView]"] = jr["[object Boolean]"] = jr["[object Date]"] = jr["[object Float32Array]"] = jr["[object Float64Array]"] = jr["[object Int8Array]"] = jr["[object Int16Array]"] = jr["[object Int32Array]"] = jr["[object Map]"] = jr["[object Number]"] = jr[mr] = jr["[object RegExp]"] = jr["[object Set]"] = jr["[object String]"] = jr["[object Symbol]"] = jr["[object Uint8Array]"] = jr["[object Uint8ClampedArray]"] = jr["[object Uint16Array]"] = jr["[object Uint32Array]"] = !0, jr["[object Error]"] = jr[_r] = jr["[object WeakMap]"] = !1, xr.prototype.add = xr.prototype.push = function(t) {
    return this.__data__.set(t, "__lodash_hash_undefined__"), this;
}, xr.prototype.has = function(t) {
    return this.__data__.has(t);
};
var Er = 1, zr = 2;
function Fr(t, e, r, n, o, i) {
    var s = r & Er, a = t.length, u = e.length;
    if (a != u && !(s && u > a)) return !1;
    var c = i.get(t), f = i.get(e);
    if (c && f) return c == e && f == t;
    var h = -1, l = !0, d = r & zr ? new xr : void 0;
    for(i.set(t, e), i.set(e, t); ++h < a;){
        var p = t[h], w = e[h];
        if (n) var g = s ? n(w, p, h, e, t, i) : n(p, w, h, t, e, i);
        if (void 0 !== g) {
            if (g) continue;
            l = !1;
            break;
        }
        if (d) {
            if (!kr(e, function(t, e) {
                if (!Ar(d, e) && (p === t || o(p, t, r, n, i))) return d.push(e);
            })) {
                l = !1;
                break;
            }
        } else if (p !== w && !o(p, w, r, n, i)) {
            l = !1;
            break;
        }
    }
    return i.delete(t), i.delete(e), l;
}
function Pr(t) {
    var e = -1, r = Array(t.size);
    return t.forEach(function(t, n) {
        r[++e] = [
            n,
            t
        ];
    }), r;
}
function Tr(t) {
    var e = -1, r = Array(t.size);
    return t.forEach(function(t) {
        r[++e] = t;
    }), r;
}
var Ir = 1, Mr = 2, Nr = "[object Boolean]", $r = "[object Date]", Wr = "[object Error]", Cr = "[object Map]", Dr = "[object Number]", Vr = "[object RegExp]", Rr = "[object Set]", Ur = "[object String]", qr = "[object Symbol]", Lr = "[object ArrayBuffer]", Br = "[object DataView]", Jr = n ? n.prototype : void 0, Hr = Jr ? Jr.valueOf : void 0, Gr = 1, Yr = Object.prototype.hasOwnProperty, Kr = 1, Qr = "[object Arguments]", Xr = "[object Array]", Zr = "[object Object]", tn = Object.prototype.hasOwnProperty;
function en(t, e, r, n, o) {
    return t === e || (null == t || null == e || !d(t) && !d(e) ? t != t && e != e : function(t, e, r, n, o, i) {
        var s = v(t), a = v(e), u = s ? Xr : De(t), c = a ? Xr : De(e), f = (u = u == Qr ? Zr : u) == Zr, h = (c = c == Qr ? Zr : c) == Zr, l = u == c;
        if (l && bt(t)) {
            if (!bt(e)) return !1;
            s = !0, f = !1;
        }
        if (l && !f) return i || (i = new he), s || Et(t) ? Fr(t, e, r, n, o, i) : function(t, e, r, n, o, i, s) {
            switch(r){
                case Br:
                    if (t.byteLength != e.byteLength || t.byteOffset != e.byteOffset) return !1;
                    t = t.buffer, e = e.buffer;
                case Lr:
                    return !(t.byteLength != e.byteLength || !i(new Re(t), new Re(e)));
                case Nr:
                case $r:
                case Dr:
                    return tt(+t, +e);
                case Wr:
                    return t.name == e.name && t.message == e.message;
                case Vr:
                case Ur:
                    return t == e + "";
                case Cr:
                    var a = Pr;
                case Rr:
                    if (a || (a = Tr), t.size != e.size && !(n & Ir)) return !1;
                    var u = s.get(t);
                    if (u) return u == e;
                    n |= Mr, s.set(t, e);
                    var c = Fr(a(t), a(e), n, o, i, s);
                    return s.delete(t), c;
                case qr:
                    if (Hr) return Hr.call(t) == Hr.call(e);
            }
            return !1;
        }(t, e, u, r, n, o, i);
        if (!(r & Kr)) {
            var d = f && tn.call(t, "__wrapped__"), p = h && tn.call(e, "__wrapped__");
            if (d || p) {
                var w = d ? t.value() : t, g = p ? e.value() : e;
                return i || (i = new he), o(w, g, r, n, i);
            }
        }
        return !!l && (i || (i = new he), function(t, e, r, n, o, i) {
            var s = r & Gr, a = Se(t), u = a.length;
            if (u != Se(e).length && !s) return !1;
            for(var c = u; c--;){
                var f = a[c];
                if (!(s ? f in e : Yr.call(e, f))) return !1;
            }
            var h = i.get(t), l = i.get(e);
            if (h && l) return h == e && l == t;
            var d = !0;
            i.set(t, e), i.set(e, t);
            for(var p = s; ++c < u;){
                var w = t[f = a[c]], g = e[f];
                if (n) var v = s ? n(g, w, f, e, t, i) : n(w, g, f, t, e, i);
                if (!(void 0 === v ? w === g || o(w, g, r, n, i) : v)) {
                    d = !1;
                    break;
                }
                p || (p = "constructor" == f);
            }
            if (d && !p) {
                var y = t.constructor, _ = e.constructor;
                y == _ || !("constructor" in t) || !("constructor" in e) || "function" == typeof y && y instanceof y && "function" == typeof _ && _ instanceof _ || (d = !1);
            }
            return i.delete(t), i.delete(e), d;
        }(t, e, r, n, o, i));
    }(t, e, r, n, en, o));
}
var rn = 1, nn = 2;
function on(t) {
    return t == t && !j(t);
}
function sn(t, e) {
    return function(r) {
        return null != r && r[t] === e && (void 0 !== e || t in Object(r));
    };
}
function an(t, e) {
    return null != t && e in Object(t);
}
var un = 1, cn = 2;
function fn(t) {
    var e, r, n, o;
    return "function" == typeof t ? t : null == t ? S : "object" == typeof t ? v(t) ? function(t, e) {
        return Dt(t) && on(e) ? sn(oe(t), e) : function(r) {
            var n = function(t, e, r) {
                var n = null == t ? void 0 : ie(t, e);
                return void 0 === n ? void 0 : n;
            }(r, t);
            return void 0 === n && n === e ? function(t, e) {
                return null != t && function(t, e, r) {
                    for(var n = -1, o = (e = re(e, t)).length, i = !1; ++n < o;){
                        var s = oe(e[n]);
                        if (!(i = null != t && r(t, s))) break;
                        t = t[s];
                    }
                    return i || ++n != o ? i : !!(o = null == t ? 0 : t.length) && at(o) && X(s, o) && (v(t) || gt(t));
                }(t, e, an);
            }(r, t) : en(e, n, un | cn);
        };
    }(t[0], t[1]) : (o = function(t) {
        for(var e = Mt(t), r = e.length; r--;){
            var n = e[r], o = t[n];
            e[r] = [
                n,
                o,
                on(o)
            ];
        }
        return e;
    }(n = t), 1 == o.length && o[0][2] ? sn(o[0][0], o[0][1]) : function(t) {
        return t === n || function(t, e, r, n) {
            var o = r.length, i = o;
            if (null == t) return !i;
            for(t = Object(t); o--;){
                var s = r[o];
                if (s[2] ? s[1] !== t[s[0]] : !(s[0] in t)) return !1;
            }
            for(; ++o < i;){
                var a = (s = r[o])[0], u = t[a], c = s[1];
                if (s[2]) {
                    if (void 0 === u && !(a in t)) return !1;
                } else {
                    var f = new he;
                    if (!en(c, u, rn | nn, void 0, f)) return !1;
                }
            }
            return !0;
        }(t, 0, o);
    }) : Dt(e = t) ? (r = oe(e), function(t) {
        return null == t ? void 0 : t[r];
    }) : function(t) {
        return function(e) {
            return ie(e, t);
        };
    }(e);
}
var hn = function(t, e, r) {
    for(var n = -1, o = Object(t), i = r(t), s = i.length; s--;){
        var a = i[++n];
        if (!1 === e(o[a], a, o)) break;
    }
    return t;
};
function ln(t, e) {
    return t && hn(t, e, Mt);
}
var dn, pn = (dn = ln, function(t, e) {
    if (null == t) return t;
    if (!ut(t)) return dn(t, e);
    for(var r = t.length, n = -1, o = Object(t); ++n < r && !1 !== e(o[n], n, o););
    return t;
});
function wn(t, e) {
    var r = -1, n = ut(t) ? Array(t.length) : [];
    return pn(t, function(t, o, i) {
        n[++r] = e(t, o, i);
    }), n;
}
function gn(t, e) {
    return t > e;
}
var vn = Math.min;
function yn(t) {
    return function(t) {
        return d(t) && ut(t);
    }(t) ? t : [];
}
var _n = it(function(t) {
    var e = g(t, yn);
    return e.length && e[0] === t[0] ? function(t, e, r) {
        for(var n = Y, o = t[0].length, i = t.length, s = i, a = Array(i), u = Infinity, c = []; s--;){
            var f = t[s];
            u = vn(f.length, u), a[s] = o >= 120 && f.length >= 120 ? new xr(s && f) : void 0;
        }
        f = t[0];
        var h = -1, l = a[0];
        t: for(; ++h < o && c.length < u;){
            var d = f[h], p = d;
            if (d = 0 !== d ? d : 0, !(l ? Ar(l, p) : n(c, p, r))) {
                for(s = i; --s;){
                    var w = a[s];
                    if (!(w ? Ar(w, p) : n(t[s], p, r))) continue t;
                }
                l && l.push(p), c.push(d);
            }
        }
        return c;
    }(e) : [];
}), bn = _n;
function mn(t, e) {
    return t < e;
}
function jn(t, e) {
    var r = {};
    return e = fn(e), ln(t, function(t, n, o) {
        Z(r, n, e(t, n, o));
    }), r;
}
function Sn(t, e, r) {
    for(var n = -1, o = t.length; ++n < o;){
        var i = t[n], s = e(i);
        if (null != s && (void 0 === a ? s == s && !w(s) : r(s, a))) var a = s, u = i;
    }
    return u;
}
function On(t, e) {
    return t && t.length ? Sn(t, fn(e), gn) : void 0;
}
function xn(t, e) {
    for(var r, n = -1, o = t.length; ++n < o;){
        var i = e(t[n]);
        void 0 !== i && (r = void 0 === r ? i : r + i);
    }
    return r;
}
function kn(t, e) {
    return function(t, e) {
        var r = null == t ? 0 : t.length;
        return r ? xn(t, e) / r : NaN;
    }(t, fn(e));
}
function An(t, e) {
    if (t !== e) {
        var r = void 0 !== t, n = null === t, o = t == t, i = w(t), s = void 0 !== e, a = null === e, u = e == e, c = w(e);
        if (!a && !c && !i && t > e || i && s && u && !a && !c || n && s && u || !r && u || !o) return 1;
        if (!n && !i && !c && t < e || c && r && o && !n && !i || a && r && o || !s && o || !u) return -1;
    }
    return 0;
}
function En(t, e, r) {
    e = e.length ? g(e, function(t) {
        return v(t) ? function(e) {
            return ie(e, 1 === t.length ? t[0] : t);
        } : t;
    }) : [
        S
    ];
    var n = -1;
    return e = g(e, jt(fn)), function(t, e) {
        var n = t.length;
        for(t.sort(function(t, e) {
            return function(t, e, r) {
                for(var n = -1, o = t.criteria, i = e.criteria, s = o.length, a = r.length; ++n < s;){
                    var u = An(o[n], i[n]);
                    if (u) return n >= a ? u : u * ("desc" == r[n] ? -1 : 1);
                }
                return t.index - e.index;
            }(t, e, r);
        }); n--;)t[n] = t[n].value;
        return t;
    }(wn(t, function(t, r, o) {
        return {
            criteria: g(e, function(e) {
                return e(t);
            }),
            index: ++n,
            value: t
        };
    }));
}
function zn(t, e, r, n) {
    return null == t ? [] : (v(e) || (e = null == e ? [] : [
        e
    ]), v(r = n ? void 0 : r) || (r = null == r ? [] : [
        r
    ]), En(t, e, r));
}
var Fn = it(function(t, e) {
    if (null == t) return [];
    var r = e.length;
    return r > 1 && ct(t, e[0], e[1]) ? e = [] : r > 2 && ct(e[0], e[1], e[2]) && (e = [
        e[0]
    ]), En(t, ce(e, 1), []);
});
function Pn(t, e) {
    return t && t.length ? xn(t, fn(e)) : 0;
}
function Tn(t) {
    if (this.words = [], t) {
        if (Symbol && Symbol.iterator && void 0 !== t[Symbol.iterator]) {
            const e = t[Symbol.iterator]();
            let r = e.next();
            for(; !r.done;)this.add(r.value), r = e.next();
        } else for(let e = 0; e < t.length; e++)this.add(t[e]);
    }
}
Tn.fromWords = function(t) {
    const e = Object.create(Tn.prototype);
    return e.words = t, e;
}, Tn.prototype.add = function(t) {
    this.resize(t), this.words[t >>> 5] |= 1 << t;
}, Tn.prototype.flip = function(t) {
    this.resize(t), this.words[t >>> 5] ^= 1 << t;
}, Tn.prototype.clear = function() {
    this.words.length = 0;
}, Tn.prototype.remove = function(t) {
    this.resize(t), this.words[t >>> 5] &= ~(1 << t);
}, Tn.prototype.isEmpty = function(t) {
    const e = this.words.length;
    for(let t = 0; t < e; t++)if (0 !== this.words[t]) return !1;
    return !0;
}, Tn.prototype.has = function(t) {
    return 0 != (this.words[t >>> 5] & 1 << t);
}, Tn.prototype.checkedAdd = function(t) {
    this.resize(t);
    const e = this.words[t >>> 5], r = e | 1 << t;
    return this.words[t >>> 5] = r, (r ^ e) >>> t;
}, Tn.prototype.trim = function(t) {
    let e = this.words.length;
    for(; e > 0 && 0 === this.words[e - 1];)e--;
    this.words.length = e;
}, Tn.prototype.resize = function(t) {
    const e = t + 32 >>> 5;
    for(let t = this.words.length; t < e; t++)this.words[t] = 0;
}, Tn.prototype.hammingWeight = function(t) {
    return 16843009 * ((t = (858993459 & (t -= t >>> 1 & 1431655765)) + (t >>> 2 & 858993459)) + (t >>> 4) & 252645135) >>> 24;
}, Tn.prototype.hammingWeight4 = function(t, e, r, n) {
    return 16843009 * ((t = (t = (858993459 & (t -= t >>> 1 & 1431655765)) + (t >>> 2 & 858993459)) + (t >>> 4) & 252645135) + (e = (e = (858993459 & (e -= e >>> 1 & 1431655765)) + (e >>> 2 & 858993459)) + (e >>> 4) & 252645135) + (r = (r = (858993459 & (r -= r >>> 1 & 1431655765)) + (r >>> 2 & 858993459)) + (r >>> 4) & 252645135) + (n = (n = (858993459 & (n -= n >>> 1 & 1431655765)) + (n >>> 2 & 858993459)) + (n >>> 4) & 252645135)) >>> 24;
}, Tn.prototype.size = function() {
    let t = 0;
    const e = this.words.length, r = this.words;
    for(let n = 0; n < e; n++)t += this.hammingWeight(r[n]);
    return t;
}, Tn.prototype.array = function() {
    const t = new Array(this.size());
    let e = 0;
    const r = this.words.length;
    for(let n = 0; n < r; ++n){
        let r = this.words[n];
        for(; 0 != r;){
            const o = r & -r;
            t[e++] = (n << 5) + this.hammingWeight(o - 1 | 0), r ^= o;
        }
    }
    return t;
}, Tn.prototype.forEach = function(t) {
    const e = this.words.length;
    for(let r = 0; r < e; ++r){
        let e = this.words[r];
        for(; 0 != e;){
            const n = e & -e;
            t((r << 5) + this.hammingWeight(n - 1 | 0)), e ^= n;
        }
    }
}, Tn.prototype[Symbol.iterator] = function() {
    const t = this.words.length;
    let e = 0, r = this.words[e], n = this.hammingWeight, o = this.words;
    return {
        [Symbol.iterator] () {
            return this;
        },
        next () {
            for(; e < t;){
                if (0 !== r) {
                    const t = r & -r, o = (e << 5) + n(t - 1 | 0);
                    return r ^= t, {
                        done: !1,
                        value: o
                    };
                }
                e++, e < t && (r = o[e]);
            }
            return {
                done: !0,
                value: void 0
            };
        }
    };
}, Tn.prototype.clone = function() {
    const t = Object.create(Tn.prototype);
    return t.words = this.words.slice(), t;
}, Tn.prototype.intersects = function(t) {
    const e = Math.min(this.words.length, t.words.length);
    for(let r = 0; r < e; ++r)if (0 != (this.words[r] & t.words[r])) return !0;
    return !1;
}, Tn.prototype.intersection = function(t) {
    const e = Math.min(this.words.length, t.words.length);
    let r = 0;
    for(; r + 7 < e; r += 8)this.words[r] &= t.words[r], this.words[r + 1] &= t.words[r + 1], this.words[r + 2] &= t.words[r + 2], this.words[r + 3] &= t.words[r + 3], this.words[r + 4] &= t.words[r + 4], this.words[r + 5] &= t.words[r + 5], this.words[r + 6] &= t.words[r + 6], this.words[r + 7] &= t.words[r + 7];
    for(; r < e; ++r)this.words[r] &= t.words[r];
    const n = this.words.length;
    for(r = e; r < n; ++r)this.words[r] = 0;
    return this;
}, Tn.prototype.intersection_size = function(t) {
    const e = Math.min(this.words.length, t.words.length);
    let r = 0;
    for(let n = 0; n < e; ++n)r += this.hammingWeight(this.words[n] & t.words[n]);
    return r;
}, Tn.prototype.new_intersection = function(t) {
    const e = Object.create(Tn.prototype), r = Math.min(this.words.length, t.words.length);
    e.words = new Array(r);
    let n = 0;
    for(; n + 7 < r; n += 8)e.words[n] = this.words[n] & t.words[n], e.words[n + 1] = this.words[n + 1] & t.words[n + 1], e.words[n + 2] = this.words[n + 2] & t.words[n + 2], e.words[n + 3] = this.words[n + 3] & t.words[n + 3], e.words[n + 4] = this.words[n + 4] & t.words[n + 4], e.words[n + 5] = this.words[n + 5] & t.words[n + 5], e.words[n + 6] = this.words[n + 6] & t.words[n + 6], e.words[n + 7] = this.words[n + 7] & t.words[n + 7];
    for(; n < r; ++n)e.words[n] = this.words[n] & t.words[n];
    return e;
}, Tn.prototype.equals = function(t) {
    const e = Math.min(this.words.length, t.words.length);
    for(let r = 0; r < e; ++r)if (this.words[r] != t.words[r]) return !1;
    if (this.words.length < t.words.length) {
        const e = t.words.length;
        for(let r = this.words.length; r < e; ++r)if (0 != t.words[r]) return !1;
    } else if (t.words.length < this.words.length) {
        const e = this.words.length;
        for(let r = t.words.length; r < e; ++r)if (0 != this.words[r]) return !1;
    }
    return !0;
}, Tn.prototype.difference = function(t) {
    const e = Math.min(this.words.length, t.words.length);
    let r = 0;
    for(; r + 7 < e; r += 8)this.words[r] &= ~t.words[r], this.words[r + 1] &= ~t.words[r + 1], this.words[r + 2] &= ~t.words[r + 2], this.words[r + 3] &= ~t.words[r + 3], this.words[r + 4] &= ~t.words[r + 4], this.words[r + 5] &= ~t.words[r + 5], this.words[r + 6] &= ~t.words[r + 6], this.words[r + 7] &= ~t.words[r + 7];
    for(; r < e; ++r)this.words[r] &= ~t.words[r];
    return this;
}, Tn.prototype.new_difference = function(t) {
    return this.clone().difference(t);
}, Tn.prototype.difference2 = function(t) {
    const e = Math.min(this.words.length, t.words.length);
    let r = 0;
    for(; r + 7 < e; r += 8)t.words[r] = this.words[r] & ~t.words[r], t.words[r + 1] = this.words[r + 1] & ~t.words[r + 1], t.words[r + 2] = this.words[r + 2] & ~t.words[r + 2], t.words[r + 3] = this.words[r + 3] & ~t.words[r + 3], t.words[r + 4] = this.words[r + 4] & ~t.words[r + 4], t.words[r + 5] = this.words[r + 5] & ~t.words[r + 5], t.words[r + 6] = this.words[r + 6] & ~t.words[r + 6], t.words[r + 7] = this.words[r + 7] & ~t.words[r + 7];
    for(; r < e; ++r)t.words[r] = this.words[r] & ~t.words[r];
    for(r = this.words.length - 1; r >= e; --r)t.words[r] = this.words[r];
    return t.words.length = this.words.length, t;
}, Tn.prototype.difference_size = function(t) {
    const e = Math.min(this.words.length, t.words.length);
    let r = 0, n = 0;
    for(; n < e; ++n)r += this.hammingWeight(this.words[n] & ~t.words[n]);
    const o = this.words.length;
    for(; n < o; ++n)r += this.hammingWeight(this.words[n]);
    return r;
}, Tn.prototype.change = function(t) {
    const e = Math.min(this.words.length, t.words.length);
    let r = 0;
    for(; r + 7 < e; r += 8)this.words[r] ^= t.words[r], this.words[r + 1] ^= t.words[r + 1], this.words[r + 2] ^= t.words[r + 2], this.words[r + 3] ^= t.words[r + 3], this.words[r + 4] ^= t.words[r + 4], this.words[r + 5] ^= t.words[r + 5], this.words[r + 6] ^= t.words[r + 6], this.words[r + 7] ^= t.words[r + 7];
    for(; r < e; ++r)this.words[r] ^= t.words[r];
    for(r = t.words.length - 1; r >= e; --r)this.words[r] = t.words[r];
    return this;
}, Tn.prototype.new_change = function(t) {
    const e = Object.create(Tn.prototype), r = Math.max(this.words.length, t.words.length);
    e.words = new Array(r);
    const n = Math.min(this.words.length, t.words.length);
    let o = 0;
    for(; o + 7 < n; o += 8)e.words[o] = this.words[o] ^ t.words[o], e.words[o + 1] = this.words[o + 1] ^ t.words[o + 1], e.words[o + 2] = this.words[o + 2] ^ t.words[o + 2], e.words[o + 3] = this.words[o + 3] ^ t.words[o + 3], e.words[o + 4] = this.words[o + 4] ^ t.words[o + 4], e.words[o + 5] = this.words[o + 5] ^ t.words[o + 5], e.words[o + 6] = this.words[o + 6] ^ t.words[o + 6], e.words[o + 7] = this.words[o + 7] ^ t.words[o + 7];
    for(; o < n; ++o)e.words[o] = this.words[o] ^ t.words[o];
    const i = this.words.length;
    for(o = n; o < i; ++o)e.words[o] = this.words[o];
    const s = t.words.length;
    for(o = n; o < s; ++o)e.words[o] = t.words[o];
    return e;
}, Tn.prototype.change_size = function(t) {
    const e = Math.min(this.words.length, t.words.length);
    let r = 0, n = 0;
    for(; n < e; ++n)r += this.hammingWeight(this.words[n] ^ t.words[n]);
    const o = this.words.length > t.words.length ? this : t, i = o.words.length;
    for(; n < i; ++n)r += this.hammingWeight(o.words[n]);
    return r;
}, Tn.prototype.toString = function() {
    return "{" + this.array().join(",") + "}";
}, Tn.prototype.union = function(t) {
    const e = Math.min(this.words.length, t.words.length);
    let r = 0;
    for(; r + 7 < e; r += 8)this.words[r] |= t.words[r], this.words[r + 1] |= t.words[r + 1], this.words[r + 2] |= t.words[r + 2], this.words[r + 3] |= t.words[r + 3], this.words[r + 4] |= t.words[r + 4], this.words[r + 5] |= t.words[r + 5], this.words[r + 6] |= t.words[r + 6], this.words[r + 7] |= t.words[r + 7];
    for(; r < e; ++r)this.words[r] |= t.words[r];
    if (this.words.length < t.words.length) {
        this.resize((t.words.length << 5) - 1);
        const r = t.words.length;
        for(let n = e; n < r; ++n)this.words[n] = t.words[n];
    }
    return this;
}, Tn.prototype.new_union = function(t) {
    const e = Object.create(Tn.prototype), r = Math.max(this.words.length, t.words.length);
    e.words = new Array(r);
    const n = Math.min(this.words.length, t.words.length);
    let o = 0;
    for(; o + 7 < n; o += 8)e.words[o] = this.words[o] | t.words[o], e.words[o + 1] = this.words[o + 1] | t.words[o + 1], e.words[o + 2] = this.words[o + 2] | t.words[o + 2], e.words[o + 3] = this.words[o + 3] | t.words[o + 3], e.words[o + 4] = this.words[o + 4] | t.words[o + 4], e.words[o + 5] = this.words[o + 5] | t.words[o + 5], e.words[o + 6] = this.words[o + 6] | t.words[o + 6], e.words[o + 7] = this.words[o + 7] | t.words[o + 7];
    for(; o < n; ++o)e.words[o] = this.words[o] | t.words[o];
    const i = this.words.length;
    for(o = n; o < i; ++o)e.words[o] = this.words[o];
    const s = t.words.length;
    for(o = n; o < s; ++o)e.words[o] = t.words[o];
    return e;
}, Tn.prototype.union_size = function(t) {
    const e = Math.min(this.words.length, t.words.length);
    let r = 0;
    for(let n = 0; n < e; ++n)r += this.hammingWeight(this.words[n] | t.words[n]);
    if (this.words.length < t.words.length) {
        const e = t.words.length;
        for(let n = this.words.length; n < e; ++n)r += this.hammingWeight(0 | t.words[n]);
    } else {
        const e = this.words.length;
        for(let n = t.words.length; n < e; ++n)r += this.hammingWeight(0 | this.words[n]);
    }
    return r;
};
var In = Tn;
function Mn() {
    return Mn = Object.assign || function(t) {
        for(var e = 1; e < arguments.length; e++){
            var r = arguments[e];
            for(var n in r)Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
        }
        return t;
    }, Mn.apply(this, arguments);
}
function Nn(t, e) {
    var r = [];
    return t.forEach(function(t) {
        e.forEach(function(e) {
            r.push(t.concat(e));
        });
    }), r;
}
function $n(t) {
    return !!~t.search(/\(|\)/);
}
function Wn(t, e) {
    for(var r = e.split(" " + t + " "), n = [], o = [], i = 0; i < r.length; i++)if ($n(r[i]) || o.length > 0) {
        o.push(r[i]);
        var s = "" + o;
        (s.match(/\(/g) || []).length === (s.match(/\)/g) || []).length && (n.push(o.join(" " + t + " ")), o = []);
    } else n.push(r[i]);
    return n;
}
var Cn = function t(e) {
    var r;
    return function(t) {
        for(var e = t[0], r = 1; r < t.length; r++)e = e.concat(t[r]);
        return e;
    }(Wn("OR", (r = e = function(t) {
        if ("(" === t.charAt(0)) {
            for(var e = 0, r = 0; r < t.length; r++)if ("(" === t.charAt(r) ? e++ : ")" === t.charAt(r) && e--, 0 === e) return r !== t.length - 1 ? t : t.substring(1, t.length - 1);
        }
        return t;
    }(e), e = r.replace(/[\s]+/g, " "))).map(function(e) {
        for(var r = Wn("AND", e), n = [], o = [], i = 0; i < r.length; i++)$n(r[i]) ? n.push(t(r[i])) : o.push(r[i]);
        return n.push([
            o
        ]), function(t) {
            for(var e = [
                []
            ], r = 0; r < t.length; r++)e = Nn(e, t[r]);
            return e;
        }(n);
    }));
}, Dn = function(t) {
    try {
        return structuredClone(t);
    } catch (e) {
        try {
            return JSON.parse(JSON.stringify(t));
        } catch (e) {
            return t;
        }
    }
}, Vn = function(t, e) {
    var r = new In([]), n = 0;
    return jn(e, function(e, o) {
        e.forEach(function(e) {
            ++n, r = r.new_union(t[o][e] || new In([]));
        });
    }), 0 === n ? null : r;
}, Rn = function(t, e, r) {
    var n = 1;
    return jn(t.bits_data_temp, function(t, o) {
        var i, s, a, u, c, f, h;
        r[o] && (i = r[o].order, s = r[o].sort, a = r[o].size, u = r[o].title, c = r[o].show_facet_stats || !1, f = !1 !== r[o].chosen_filters_on_top, h = r[o].hide_zero_doc_count || !1);
        var l, d, p, w, g, y, _ = Object.entries(t).map(function(t) {
            var r = [];
            e && e.filters && e.filters[o] && (r = e.filters[o]);
            var n = t[1].array().length;
            if (!h || 0 !== n || -1 !== r.indexOf(t[0])) return {
                key: t[0],
                doc_count: n,
                selected: -1 !== r.indexOf(t[0])
            };
        }).filter(Boolean);
        return v(s) ? (l = s || [
            "key"
        ], d = i || [
            "asc"
        ]) : ("term" === s || "key" === s ? (l = [
            "key"
        ], d = [
            i || "asc"
        ]) : (l = [
            "doc_count",
            "key"
        ], d = [
            i || "desc",
            "asc"
        ]), f && (l.unshift("selected"), d.unshift("desc"))), _ = (_ = zn(_, l, d)).slice(0, a || 10), c && (p = [], Object.entries(t).forEach(function(t) {
            if (isNaN(t[0])) throw new Error("You cant use chars to calculate the facet_stats.");
            t[1].array().length > 0 && t[1].forEach(function() {
                p.push(parseInt(t[0]));
            });
        }), w = {
            min: (g = p, g && g.length ? Sn(g, fn(void 0), mn) : void 0),
            max: On(p),
            avg: kn(p),
            sum: Pn(p)
        }), Mn({
            name: o,
            title: u || (y = o, y.replace(/^[\s_]+|[\s_]+$/g, "").replace(/[_\s]+/g, " ").replace(/^[a-z]/, function(t) {
                return t.toUpperCase();
            })),
            position: n++,
            buckets: _
        }, c && {
            facet_stats: w
        });
    });
};
function Un(t, e, r, n, o) {
    e = e || Object.create(null);
    var i = parseInt(e.per_page || 12), s = parseInt(e.page || 1), a = e.is_all_filtered_items || !1;
    if (!1 === r.native_search_enabled && (e.query || e.filter)) throw new Error('"query" and "filter" options are not working once native search is disabled');
    var u, c, f, h = 0, l = (new Date).getTime(), d = o.bits_ids();
    if (e._ids) u = new In(e._ids), c = e._ids;
    else if (e.ids) c = o.internal_ids_from_ids_map(e.ids), u = new In(c);
    else if (n && (e.query || e.filter)) {
        var p = (new Date).getTime();
        c = n.search(e.query, e.filter), h = (new Date).getTime() - p, u = new In(c);
    }
    var w = (new Date).getTime(), g = o.search(e, {
        query_ids: u
    });
    w = (new Date).getTime() - w, u && (d = u), g.ids && (d = d.new_intersection(g.ids)), g.not_ids && (d = d.new_difference(g.not_ids));
    var v, y = d.array(), _ = y.map(function(t) {
        return o.get_item(t);
    }), b = !1, m = (new Date).getTime();
    e.sort ? _ = function(t, e, r) {
        return r && r[e] && (e = r[e]), e.field ? zn(t, e.field, e.order || "asc") : t;
    }(_, e.sort, r.sortings) : c && (_ = (y = c.filter(function(t) {
        return d.has(t);
    })).slice((s - 1) * i, s * i).map(function(t) {
        return o.get_item(t);
    }), b = !0), b || (f = a ? _ : null, _ = _.slice((s - 1) * i, s * i)), v = (new Date).getTime() - m;
    var j = (new Date).getTime() - l;
    return {
        pagination: {
            per_page: i,
            page: s,
            total: y.length
        },
        timings: {
            total: j,
            facets: w,
            search: h,
            sorting: v
        },
        data: {
            items: _,
            allFilteredItems: f,
            aggregations: Rn(g, e, r.aggregations)
        }
    };
}
var qn = function(t) {
    var e = {
        exports: {}
    };
    return function(t, e) {
        !function() {
            var e, r, n, o, i, s, a, u, c, f, h, l, d, p, w, g, v, y, _, b, m, j, S, O, x, k, A, E, z = function(t) {
                var e = new z.Index;
                return e.pipeline.add(z.trimmer, z.stopWordFilter, z.stemmer), t && t.call(e, e), e;
            };
            z.version = "1.0.0", z.utils = {}, z.utils.warn = function(t) {
                return function(e) {
                    t.console && console.warn && console.warn(e);
                };
            }(this), z.utils.asString = function(t) {
                return null == t ? "" : t.toString();
            }, z.EventEmitter = function() {
                this.events = {};
            }, z.EventEmitter.prototype.addListener = function() {
                var t = Array.prototype.slice.call(arguments), e = t.pop(), r = t;
                if ("function" != typeof e) throw new TypeError("last argument must be a function");
                r.forEach(function(t) {
                    this.hasHandler(t) || (this.events[t] = []), this.events[t].push(e);
                }, this);
            }, z.EventEmitter.prototype.removeListener = function(t, e) {
                if (this.hasHandler(t)) {
                    var r = this.events[t].indexOf(e);
                    this.events[t].splice(r, 1), this.events[t].length || delete this.events[t];
                }
            }, z.EventEmitter.prototype.emit = function(t) {
                if (this.hasHandler(t)) {
                    var e = Array.prototype.slice.call(arguments, 1);
                    this.events[t].forEach(function(t) {
                        t.apply(void 0, e);
                    });
                }
            }, z.EventEmitter.prototype.hasHandler = function(t) {
                return t in this.events;
            }, z.tokenizer = function(t) {
                return arguments.length && null != t && null != t ? Array.isArray(t) ? t.map(function(t) {
                    return z.utils.asString(t).toLowerCase();
                }) : t.toString().trim().toLowerCase().split(z.tokenizer.separator) : [];
            }, z.tokenizer.separator = /[\s\-]+/, z.tokenizer.load = function(t) {
                var e = this.registeredFunctions[t];
                if (!e) throw new Error("Cannot load un-registered function: " + t);
                return e;
            }, z.tokenizer.label = "default", z.tokenizer.registeredFunctions = {
                default: z.tokenizer
            }, z.tokenizer.registerFunction = function(t, e) {
                e in this.registeredFunctions && z.utils.warn("Overwriting existing tokenizer: " + e), t.label = e, this.registeredFunctions[e] = t;
            }, z.Pipeline = function() {
                this._stack = [];
            }, z.Pipeline.registeredFunctions = {}, z.Pipeline.registerFunction = function(t, e) {
                e in this.registeredFunctions && z.utils.warn("Overwriting existing registered function: " + e), t.label = e, z.Pipeline.registeredFunctions[t.label] = t;
            }, z.Pipeline.warnIfFunctionNotRegistered = function(t) {
                t.label && t.label in this.registeredFunctions || z.utils.warn("Function is not registered with pipeline. This may cause problems when serialising the index.\n", t);
            }, z.Pipeline.load = function(t) {
                var e = new z.Pipeline;
                return t.forEach(function(t) {
                    var r = z.Pipeline.registeredFunctions[t];
                    if (!r) throw new Error("Cannot load un-registered function: " + t);
                    e.add(r);
                }), e;
            }, z.Pipeline.prototype.add = function() {
                Array.prototype.slice.call(arguments).forEach(function(t) {
                    z.Pipeline.warnIfFunctionNotRegistered(t), this._stack.push(t);
                }, this);
            }, z.Pipeline.prototype.after = function(t, e) {
                z.Pipeline.warnIfFunctionNotRegistered(e);
                var r = this._stack.indexOf(t);
                if (-1 == r) throw new Error("Cannot find existingFn");
                this._stack.splice(r += 1, 0, e);
            }, z.Pipeline.prototype.before = function(t, e) {
                z.Pipeline.warnIfFunctionNotRegistered(e);
                var r = this._stack.indexOf(t);
                if (-1 == r) throw new Error("Cannot find existingFn");
                this._stack.splice(r, 0, e);
            }, z.Pipeline.prototype.remove = function(t) {
                var e = this._stack.indexOf(t);
                -1 != e && this._stack.splice(e, 1);
            }, z.Pipeline.prototype.run = function(t) {
                for(var e = [], r = t.length, n = this._stack.length, o = 0; o < r; o++){
                    for(var i = t[o], s = 0; s < n && void 0 !== (i = this._stack[s](i, o, t)) && "" !== i; s++);
                    void 0 !== i && "" !== i && e.push(i);
                }
                return e;
            }, z.Pipeline.prototype.reset = function() {
                this._stack = [];
            }, z.Pipeline.prototype.toJSON = function() {
                return this._stack.map(function(t) {
                    return z.Pipeline.warnIfFunctionNotRegistered(t), t.label;
                });
            }, z.Vector = function() {
                this._magnitude = null, this.list = void 0, this.length = 0;
            }, z.Vector.Node = function(t, e, r) {
                this.idx = t, this.val = e, this.next = r;
            }, z.Vector.prototype.insert = function(t, e) {
                this._magnitude = void 0;
                var r = this.list;
                if (!r) return this.list = new z.Vector.Node(t, e, r), this.length++;
                if (t < r.idx) return this.list = new z.Vector.Node(t, e, r), this.length++;
                for(var n = r, o = r.next; null != o;){
                    if (t < o.idx) return n.next = new z.Vector.Node(t, e, o), this.length++;
                    n = o, o = o.next;
                }
                return n.next = new z.Vector.Node(t, e, o), this.length++;
            }, z.Vector.prototype.magnitude = function() {
                if (this._magnitude) return this._magnitude;
                for(var t, e = this.list, r = 0; e;)r += (t = e.val) * t, e = e.next;
                return this._magnitude = Math.sqrt(r);
            }, z.Vector.prototype.dot = function(t) {
                for(var e = this.list, r = t.list, n = 0; e && r;)e.idx < r.idx ? e = e.next : (e.idx > r.idx || (n += e.val * r.val, e = e.next), r = r.next);
                return n;
            }, z.Vector.prototype.similarity = function(t) {
                return this.dot(t) / (this.magnitude() * t.magnitude());
            }, z.SortedSet = function() {
                this.length = 0, this.elements = [];
            }, z.SortedSet.load = function(t) {
                var e = new this;
                return e.elements = t, e.length = t.length, e;
            }, z.SortedSet.prototype.add = function() {
                var t, e;
                for(t = 0; t < arguments.length; t++)~this.indexOf(e = arguments[t]) || this.elements.splice(this.locationFor(e), 0, e);
                this.length = this.elements.length;
            }, z.SortedSet.prototype.toArray = function() {
                return this.elements.slice();
            }, z.SortedSet.prototype.map = function(t, e) {
                return this.elements.map(t, e);
            }, z.SortedSet.prototype.forEach = function(t, e) {
                return this.elements.forEach(t, e);
            }, z.SortedSet.prototype.indexOf = function(t) {
                for(var e = 0, r = this.elements.length, n = r - e, o = e + Math.floor(n / 2), i = this.elements[o]; n > 1;){
                    if (i === t) return o;
                    i < t && (e = o), i > t && (r = o), n = r - e, o = e + Math.floor(n / 2), i = this.elements[o];
                }
                return i === t ? o : -1;
            }, z.SortedSet.prototype.locationFor = function(t) {
                for(var e = 0, r = this.elements.length, n = r - e, o = e + Math.floor(n / 2), i = this.elements[o]; n > 1;)i < t && (e = o), i > t && (r = o), n = r - e, o = e + Math.floor(n / 2), i = this.elements[o];
                return i > t ? o : i < t ? o + 1 : void 0;
            }, z.SortedSet.prototype.intersect = function(t) {
                for(var e = new z.SortedSet, r = 0, n = 0, o = this.length, i = t.length, s = this.elements, a = t.elements; !(r > o - 1 || n > i - 1);)s[r] !== a[n] ? s[r] < a[n] ? r++ : s[r] > a[n] && n++ : (e.add(s[r]), r++, n++);
                return e;
            }, z.SortedSet.prototype.clone = function() {
                var t = new z.SortedSet;
                return t.elements = this.toArray(), t.length = t.elements.length, t;
            }, z.SortedSet.prototype.union = function(t) {
                var e, r, n;
                this.length >= t.length ? (e = this, r = t) : (e = t, r = this), n = e.clone();
                for(var o = 0, i = r.toArray(); o < i.length; o++)n.add(i[o]);
                return n;
            }, z.SortedSet.prototype.toJSON = function() {
                return this.toArray();
            }, z.Index = function() {
                this._fields = [], this._ref = "id", this.pipeline = new z.Pipeline, this.documentStore = new z.Store, this.tokenStore = new z.TokenStore, this.corpusTokens = new z.SortedSet, this.eventEmitter = new z.EventEmitter, this.tokenizerFn = z.tokenizer, this._idfCache = {}, this.on("add", "remove", "update", (function() {
                    this._idfCache = {};
                }).bind(this));
            }, z.Index.prototype.on = function() {
                var t = Array.prototype.slice.call(arguments);
                return this.eventEmitter.addListener.apply(this.eventEmitter, t);
            }, z.Index.prototype.off = function(t, e) {
                return this.eventEmitter.removeListener(t, e);
            }, z.Index.load = function(t) {
                t.version !== z.version && z.utils.warn("version mismatch: current " + z.version + " importing " + t.version);
                var e = new this;
                return e._fields = t.fields, e._ref = t.ref, e.tokenizer(z.tokenizer.load(t.tokenizer)), e.documentStore = z.Store.load(t.documentStore), e.tokenStore = z.TokenStore.load(t.tokenStore), e.corpusTokens = z.SortedSet.load(t.corpusTokens), e.pipeline = z.Pipeline.load(t.pipeline), e;
            }, z.Index.prototype.field = function(t, e) {
                return this._fields.push({
                    name: t,
                    boost: (e = e || {}).boost || 1
                }), this;
            }, z.Index.prototype.ref = function(t) {
                return this._ref = t, this;
            }, z.Index.prototype.tokenizer = function(t) {
                return t.label && t.label in z.tokenizer.registeredFunctions || z.utils.warn("Function is not a registered tokenizer. This may cause problems when serialising the index"), this.tokenizerFn = t, this;
            }, z.Index.prototype.add = function(t, e) {
                var r = {}, n = new z.SortedSet, o = t[this._ref];
                e = void 0 === e || e, this._fields.forEach(function(e) {
                    var o = this.pipeline.run(this.tokenizerFn(t[e.name]));
                    r[e.name] = o;
                    for(var i = 0; i < o.length; i++){
                        var s = o[i];
                        n.add(s), this.corpusTokens.add(s);
                    }
                }, this), this.documentStore.set(o, n);
                for(var i = 0; i < n.length; i++){
                    for(var s = n.elements[i], a = 0, u = 0; u < this._fields.length; u++){
                        var c = this._fields[u], f = r[c.name], h = f.length;
                        if (h) {
                            for(var l = 0, d = 0; d < h; d++)f[d] === s && l++;
                            a += l / h * c.boost;
                        }
                    }
                    this.tokenStore.add(s, {
                        ref: o,
                        tf: a
                    });
                }
                e && this.eventEmitter.emit("add", t, this);
            }, z.Index.prototype.remove = function(t, e) {
                var r = t[this._ref];
                if (e = void 0 === e || e, this.documentStore.has(r)) {
                    var n = this.documentStore.get(r);
                    this.documentStore.remove(r), n.forEach(function(t) {
                        this.tokenStore.remove(t, r);
                    }, this), e && this.eventEmitter.emit("remove", t, this);
                }
            }, z.Index.prototype.update = function(t, e) {
                e = void 0 === e || e, this.remove(t, !1), this.add(t, !1), e && this.eventEmitter.emit("update", t, this);
            }, z.Index.prototype.idf = function(t) {
                var e = "@" + t;
                if (Object.prototype.hasOwnProperty.call(this._idfCache, e)) return this._idfCache[e];
                var r = this.tokenStore.count(t), n = 1;
                return r > 0 && (n = 1 + Math.log(this.documentStore.length / r)), this._idfCache[e] = n;
            }, z.Index.prototype.search = function(t) {
                var e = this.pipeline.run(this.tokenizerFn(t)), r = new z.Vector, n = [], o = this._fields.reduce(function(t, e) {
                    return t + e.boost;
                }, 0);
                return e.some(function(t) {
                    return this.tokenStore.has(t);
                }, this) ? (e.forEach(function(t, e, i) {
                    var s = 1 / i.length * this._fields.length * o, a = this, u = this.tokenStore.expand(t).reduce(function(e, n) {
                        var o = a.corpusTokens.indexOf(n), i = a.idf(n), u = 1, c = new z.SortedSet;
                        if (n !== t) {
                            var f = Math.max(3, n.length - t.length);
                            u = 1 / Math.log(f);
                        }
                        o > -1 && r.insert(o, s * i * u);
                        for(var h = a.tokenStore.get(n), l = Object.keys(h), d = l.length, p = 0; p < d; p++)c.add(h[l[p]].ref);
                        return e.union(c);
                    }, new z.SortedSet);
                    n.push(u);
                }, this), n.reduce(function(t, e) {
                    return t.intersect(e);
                }).map(function(t) {
                    return {
                        ref: t,
                        score: r.similarity(this.documentVector(t))
                    };
                }, this).sort(function(t, e) {
                    return e.score - t.score;
                })) : [];
            }, z.Index.prototype.documentVector = function(t) {
                for(var e = this.documentStore.get(t), r = e.length, n = new z.Vector, o = 0; o < r; o++){
                    var i = e.elements[o], s = this.tokenStore.get(i)[t].tf, a = this.idf(i);
                    n.insert(this.corpusTokens.indexOf(i), s * a);
                }
                return n;
            }, z.Index.prototype.toJSON = function() {
                return {
                    version: z.version,
                    fields: this._fields,
                    ref: this._ref,
                    tokenizer: this.tokenizerFn.label,
                    documentStore: this.documentStore.toJSON(),
                    tokenStore: this.tokenStore.toJSON(),
                    corpusTokens: this.corpusTokens.toJSON(),
                    pipeline: this.pipeline.toJSON()
                };
            }, z.Index.prototype.use = function(t) {
                var e = Array.prototype.slice.call(arguments, 1);
                e.unshift(this), t.apply(this, e);
            }, z.Store = function() {
                this.store = {}, this.length = 0;
            }, z.Store.load = function(t) {
                var e = new this;
                return e.length = t.length, e.store = Object.keys(t.store).reduce(function(e, r) {
                    return e[r] = z.SortedSet.load(t.store[r]), e;
                }, {}), e;
            }, z.Store.prototype.set = function(t, e) {
                this.has(t) || this.length++, this.store[t] = e;
            }, z.Store.prototype.get = function(t) {
                return this.store[t];
            }, z.Store.prototype.has = function(t) {
                return t in this.store;
            }, z.Store.prototype.remove = function(t) {
                this.has(t) && (delete this.store[t], this.length--);
            }, z.Store.prototype.toJSON = function() {
                return {
                    store: this.store,
                    length: this.length
                };
            }, z.stemmer = (e = {
                ational: "ate",
                tional: "tion",
                enci: "ence",
                anci: "ance",
                izer: "ize",
                bli: "ble",
                alli: "al",
                entli: "ent",
                eli: "e",
                ousli: "ous",
                ization: "ize",
                ation: "ate",
                ator: "ate",
                alism: "al",
                iveness: "ive",
                fulness: "ful",
                ousness: "ous",
                aliti: "al",
                iviti: "ive",
                biliti: "ble",
                logi: "log"
            }, r = {
                icate: "ic",
                ative: "",
                alize: "al",
                iciti: "ic",
                ical: "ic",
                ful: "",
                ness: ""
            }, s = "^(" + (o = "[^aeiou][^aeiouy]*") + ")?" + (i = (n = "[aeiouy]") + "[aeiou]*") + o + "(" + i + ")?$", a = "^(" + o + ")?" + i + o + i + o, u = "^(" + o + ")?" + n, c = new RegExp("^(" + o + ")?" + i + o), f = new RegExp(a), h = new RegExp(s), l = new RegExp(u), d = /^(.+?)(ss|i)es$/, p = /^(.+?)([^s])s$/, w = /^(.+?)eed$/, g = /^(.+?)(ed|ing)$/, v = /.$/, y = /(at|bl|iz)$/, _ = new RegExp("([^aeiouylsz])\\1$"), b = new RegExp("^" + o + n + "[^aeiouwxy]$"), m = /^(.+?[^aeiou])y$/, j = /^(.+?)(ational|tional|enci|anci|izer|bli|alli|entli|eli|ousli|ization|ation|ator|alism|iveness|fulness|ousness|aliti|iviti|biliti|logi)$/, S = /^(.+?)(icate|ative|alize|iciti|ical|ful|ness)$/, O = /^(.+?)(al|ance|ence|er|ic|able|ible|ant|ement|ment|ent|ou|ism|ate|iti|ous|ive|ize)$/, x = /^(.+?)(s|t)(ion)$/, k = /^(.+?)e$/, A = /ll$/, E = new RegExp("^" + o + n + "[^aeiouwxy]$"), function(t) {
                var n, o, i, s, a, u, z;
                if (t.length < 3) return t;
                if ("y" == (i = t.substr(0, 1)) && (t = i.toUpperCase() + t.substr(1)), a = p, (s = d).test(t) ? t = t.replace(s, "$1$2") : a.test(t) && (t = t.replace(a, "$1$2")), a = g, (s = w).test(t)) {
                    var F = s.exec(t);
                    (s = c).test(F[1]) && (t = t.replace(s = v, ""));
                } else a.test(t) && (F = a.exec(t), (a = l).test(n = F[1]) && (u = _, z = b, (a = y).test(t = n) ? t += "e" : u.test(t) ? t = t.replace(s = v, "") : z.test(t) && (t += "e")));
                return (s = m).test(t) && (t = (n = (F = s.exec(t))[1]) + "i"), (s = j).test(t) && (o = (F = s.exec(t))[2], (s = c).test(n = F[1]) && (t = n + e[o])), (s = S).test(t) && (o = (F = s.exec(t))[2], (s = c).test(n = F[1]) && (t = n + r[o])), a = x, (s = O).test(t) ? (F = s.exec(t), (s = f).test(n = F[1]) && (t = n)) : a.test(t) && (F = a.exec(t), (a = f).test(n = F[1] + F[2]) && (t = n)), (s = k).test(t) && (F = s.exec(t), a = h, u = E, ((s = f).test(n = F[1]) || a.test(n) && !u.test(n)) && (t = n)), a = f, (s = A).test(t) && a.test(t) && (t = t.replace(s = v, "")), "y" == i && (t = i.toLowerCase() + t.substr(1)), t;
            }), z.Pipeline.registerFunction(z.stemmer, "stemmer"), z.generateStopWordFilter = function(t) {
                var e = t.reduce(function(t, e) {
                    return t[e] = e, t;
                }, {});
                return function(t) {
                    if (t && e[t] !== t) return t;
                };
            }, z.stopWordFilter = z.generateStopWordFilter([
                "a",
                "able",
                "about",
                "across",
                "after",
                "all",
                "almost",
                "also",
                "am",
                "among",
                "an",
                "and",
                "any",
                "are",
                "as",
                "at",
                "be",
                "because",
                "been",
                "but",
                "by",
                "can",
                "cannot",
                "could",
                "dear",
                "did",
                "do",
                "does",
                "either",
                "else",
                "ever",
                "every",
                "for",
                "from",
                "get",
                "got",
                "had",
                "has",
                "have",
                "he",
                "her",
                "hers",
                "him",
                "his",
                "how",
                "however",
                "i",
                "if",
                "in",
                "into",
                "is",
                "it",
                "its",
                "just",
                "least",
                "let",
                "like",
                "likely",
                "may",
                "me",
                "might",
                "most",
                "must",
                "my",
                "neither",
                "no",
                "nor",
                "not",
                "of",
                "off",
                "often",
                "on",
                "only",
                "or",
                "other",
                "our",
                "own",
                "rather",
                "said",
                "say",
                "says",
                "she",
                "should",
                "since",
                "so",
                "some",
                "than",
                "that",
                "the",
                "their",
                "them",
                "then",
                "there",
                "these",
                "they",
                "this",
                "tis",
                "to",
                "too",
                "twas",
                "us",
                "wants",
                "was",
                "we",
                "were",
                "what",
                "when",
                "where",
                "which",
                "while",
                "who",
                "whom",
                "why",
                "will",
                "with",
                "would",
                "yet",
                "you",
                "your"
            ]), z.Pipeline.registerFunction(z.stopWordFilter, "stopWordFilter"), z.trimmer = function(t) {
                return t.replace(/^\W+/, "").replace(/\W+$/, "");
            }, z.Pipeline.registerFunction(z.trimmer, "trimmer"), z.TokenStore = function() {
                this.root = {
                    docs: {}
                }, this.length = 0;
            }, z.TokenStore.load = function(t) {
                var e = new this;
                return e.root = t.root, e.length = t.length, e;
            }, z.TokenStore.prototype.add = function(t, e, r) {
                r = r || this.root;
                var n = t.charAt(0), o = t.slice(1);
                return n in r || (r[n] = {
                    docs: {}
                }), 0 === o.length ? (r[n].docs[e.ref] = e, void (this.length += 1)) : this.add(o, e, r[n]);
            }, z.TokenStore.prototype.has = function(t) {
                if (!t) return !1;
                for(var e = this.root, r = 0; r < t.length; r++){
                    if (!e[t.charAt(r)]) return !1;
                    e = e[t.charAt(r)];
                }
                return !0;
            }, z.TokenStore.prototype.getNode = function(t) {
                if (!t) return {};
                for(var e = this.root, r = 0; r < t.length; r++){
                    if (!e[t.charAt(r)]) return {};
                    e = e[t.charAt(r)];
                }
                return e;
            }, z.TokenStore.prototype.get = function(t, e) {
                return this.getNode(t, e).docs || {};
            }, z.TokenStore.prototype.count = function(t, e) {
                return Object.keys(this.get(t, e)).length;
            }, z.TokenStore.prototype.remove = function(t, e) {
                if (t) {
                    for(var r = this.root, n = 0; n < t.length; n++){
                        if (!(t.charAt(n) in r)) return;
                        r = r[t.charAt(n)];
                    }
                    delete r.docs[e];
                }
            }, z.TokenStore.prototype.expand = function(t, e) {
                var r = this.getNode(t);
                return e = e || [], Object.keys(r.docs || {}).length && e.push(t), Object.keys(r).forEach(function(r) {
                    "docs" !== r && e.concat(this.expand(t + r, e));
                }, this), e;
            }, z.TokenStore.prototype.toJSON = function() {
                return {
                    root: this.root,
                    length: this.length
                };
            }, t.exports = z;
        }();
    }(e), e.exports;
}(), Ln = /*#__PURE__*/ function() {
    function t(t, e) {
        var r = this;
        this.store = new Map, this.idx = qn(function() {
            var t = this;
            this.field("name", {
                boost: 10
            }), ((null == e ? void 0 : e.searchableFields) || []).forEach(function(e) {
                return t.field(e);
            }), this.ref("_id"), null != e && e.isExactSearch && (this.pipeline.remove(qn.stemmer), this.pipeline.remove(qn.stopWordFilter)), null != e && e.removeStopWordFilter && this.pipeline.remove(qn.stopWordFilter);
        });
        var n = 1;
        (t || []).map(function(t) {
            t._id = n, ++n, r.idx.add(t), r.store.set(t._id, t);
        });
    }
    var e = t.prototype;
    return e.search_full = function(t, e) {
        var r = this;
        return this.search(t, e).map(function(t) {
            return r.store.get(t);
        });
    }, e.search = function(t, e) {
        var r = this;
        return e instanceof Function ? (t ? this.idx.search(t).map(function(t) {
            return r.store.get(t.ref);
        }) : [].concat(this.store.values())).filter(e).map(function(t) {
            return t._id;
        }) : t ? this.idx.search(t).map(function(t) {
            return t.ref;
        }) : [].concat(this.store.keys());
    }, t;
}(), Bn = /*#__PURE__*/ function() {
    function t(t, e) {
        var r = this;
        (e = e || Object.create(null)).aggregations = e.aggregations || Object.create(null), this._items = t, this.config = e.aggregations, this.facets = function(t, e) {
            e = e || [];
            var r = {
                data: Object.create(null),
                bits_data: Object.create(null),
                bits_data_temp: Object.create(null)
            }, n = 1;
            return e.forEach(function(t) {
                r.data[t] = Object.create(null);
            }), t && t.map(function(t) {
                return t._id || (t._id = n, ++n), t;
            }), t && t.map(function(t) {
                return e.forEach(function(e) {
                    if (t) {
                        if (Array.isArray(t[e])) t[e].forEach(function(n) {
                            t[e] && (r.data[e][n] || (r.data[e][n] = []), r.data[e][n].push(parseInt(t._id)));
                        });
                        else if (void 0 !== t[e]) {
                            var n = t[e];
                            r.data[e][n] || (r.data[e][n] = []), r.data[e][n].push(parseInt(t._id));
                        }
                    }
                }), t;
            }), r.data = jn(r.data, function(t, e) {
                return r.bits_data[e] || (r.bits_data[e] = Object.create(null), r.bits_data_temp[e] = Object.create(null)), jn(t, function(t, n) {
                    var o = Fn(t);
                    return r.bits_data[e][n] = new In(o), o;
                });
            }), r;
        }(t, Mt(e.aggregations)), this._items_map = Object.create(null), this._ids = [];
        var n, o, i = 1;
        o = function(t) {
            r._ids.push(i), r._items_map[i] = t, t._id = i, ++i;
        }, (v(n = t) ? g : wn)(n, fn(o)), this.ids_map = Object.create(null), t && t.forEach(function(t) {
            var n = e.custom_id_field || "id";
            t[n] && t._id && (r.ids_map[t[n]] = t._id);
        }), this._bits_ids = new In(this._ids);
    }
    var e = t.prototype;
    return e.items = function() {
        return this._items;
    }, e.bits_ids = function(t) {
        return t ? new In(t) : this._bits_ids;
    }, e.internal_ids_from_ids_map = function(t) {
        var e = this;
        return t.map(function(t) {
            return e.ids_map[t];
        });
    }, e.index = function() {
        return this.facets;
    }, e.get_item = function(t) {
        return this._items_map[t];
    }, e.search = function(t, e) {
        var r = this.config;
        e = e || Object.create(null);
        var n, o = Or(this.facets);
        o.not_ids = Vn(o.bits_data, t.not_filters);
        var i, s, a = function(t, e) {
            var r = [];
            return jn(t.filters, function(t, n) {
                if (t && t.length) {
                    if (!1 !== e[n].conjunction) jn(t, function(t) {
                        r.push([
                            n,
                            t
                        ]);
                    });
                    else {
                        var o = [];
                        jn(t, function(t) {
                            o.push([
                                n,
                                t
                            ]);
                        }), r.push(o);
                    }
                }
            }), jn(t.not_filters, function(t, e) {
                t && t.length && jn(t, function(t) {
                    r.push([
                        e,
                        "-",
                        t
                    ]);
                });
            }), r;
        }(t, r);
        return n = function(t, e) {
            var r, n = Or(t);
            e = e || [], jn(n.bits_data, function(t, e) {
                jn(n.bits_data[e], function(t, r) {
                    n.bits_data_temp[e][r] = n.bits_data[e][r];
                });
            }), n.is_temp_copied = !0;
            var o = function(t, e) {
                var r = Object.create(null);
                return jn(e, function(e) {
                    if (Array.isArray(e[0])) {
                        var n = new In([]), o = [];
                        jn(e, function(e) {
                            var i = e[0], s = e[1];
                            o.push(i), n = n.new_union(t.bits_data[i][s] || new In([])), r[i] = n;
                        });
                    }
                }), r;
            }(t, e);
            return jn(e, function(t) {
                if (!Array.isArray(t[0])) {
                    var e = t[0], o = t[1];
                    r = r && n.bits_data_temp[e][o] ? n.bits_data_temp[e][o].new_intersection(r) : r && !n.bits_data_temp[e][o] ? new In([]) : n.bits_data_temp[e][o];
                }
            }), r && jn(n.bits_data_temp, function(t, e) {
                jn(n.bits_data_temp[e], function(t, o) {
                    n.bits_data_temp[e][o] = n.bits_data_temp[e][o].new_intersection(r);
                });
            }), jn(e, function(t) {
                if (3 === t.length && "-" === t[1]) {
                    var e = n.bits_data_temp[t[0]][t[2]].clone();
                    jn(n.bits_data_temp, function(t, r) {
                        jn(n.bits_data_temp[r], function(t, o) {
                            n.bits_data_temp[r][o] = n.bits_data_temp[r][o].new_difference(e);
                        });
                    });
                }
            }), jn(n.bits_data_temp, function(t, e) {
                jn(n.bits_data_temp[e], function(t, r) {
                    jn(o, function(t, o) {
                        o !== e && (n.bits_data_temp[e][r] = n.bits_data_temp[e][r].new_intersection(t));
                    });
                });
            }), n;
        }(this.facets, a), t.filters_query && (n = function(t, e) {
            var r = Or(t);
            r.is_temp_copied || jn(r.bits_data, function(t, e) {
                jn(r.bits_data[e], function(t, n) {
                    r.bits_data_temp[e][n] = r.bits_data[e][n];
                });
            });
            var n = null;
            return jn(e, function(t) {
                var e = null;
                jn(t, function(t) {
                    var n = t[0], o = t[1];
                    if (!r.bits_data_temp[n]) throw new Error("Panic. The key does not exist in facets lists.");
                    e = e && r.bits_data_temp[n][o] ? r.bits_data_temp[n][o].new_intersection(e) : e && !r.bits_data_temp[n][o] ? new In([]) : r.bits_data_temp[n][o];
                }), n = (n || new In([])).new_union(e || new In([]));
            }), null !== n && jn(r.bits_data_temp, function(t, e) {
                jn(r.bits_data_temp[e], function(t, o) {
                    r.bits_data_temp[e][o] = r.bits_data_temp[e][o].new_intersection(n);
                });
            }), r;
        }(n, Cn(t.filters_query).map(function(t) {
            return Array.isArray(t) ? t.map(function(t) {
                return Array.isArray(t) ? t.map(function(t) {
                    return t;
                }) : t.split(":");
            }) : t.split(":");
        }))), o.bits_data_temp = n.bits_data_temp, jn(o.bits_data_temp, function(t, r) {
            jn(o.bits_data_temp[r], function(t, n) {
                e.query_ids && (o.bits_data_temp[r][n] = e.query_ids.new_intersection(o.bits_data_temp[r][n])), e.test && (o.data[r][n] = o.bits_data_temp[r][n].array());
            });
        }), o.ids = t.filters_query ? (i = o.bits_data_temp, s = new In([]), jn(i, function(t, e) {
            jn(i[e], function(t, r) {
                s = s.new_union(i[e][r]);
            });
        }), s) : Vn(o.bits_data_temp, t.filters), o;
    }, t;
}();
function Jn(t, e) {
    var r;
    !1 !== (e = e || Object.create(null)).native_search_enabled && (r = new Ln(t, e));
    var n = new Bn(t, e);
    return {
        search: function(t) {
            return (t = t || Object.create(null)).aggregations = function(t, e) {
                return jn(Dn(t), function(t, r) {
                    t.field || (t.field = r);
                    var n = [];
                    e.filters && e.filters[r] && (n = e.filters[r]), t.filters = n;
                    var o = [];
                    return e.not_filters && e.not_filters[r] && (o = e.not_filters[r]), e.exclude_filters && e.exclude_filters[r] && (o = e.exclude_filters[r]), t.not_filters = o, t;
                });
            }(e.aggregations, t), Un(0, t, e, r, n);
        },
        similar: function(e, r) {
            return function(t, e, r) {
                for(var n, o = r.per_page || 10, i = r.minimum || 0, s = r.page || 1, a = 0; a < t.length; ++a)if (t[a].id == e) {
                    n = t[a];
                    break;
                }
                if (!r.field) throw new Error("Please define field in options");
                for(var u = r.field, c = [], f = 0; f < t.length; ++f)if (t[f].id !== e) {
                    var h = bn(n[u], t[f][u]);
                    h.length >= i && (c.push(t[f]), c[c.length - 1].intersection_length = h.length);
                }
                return {
                    pagination: {
                        per_page: o,
                        page: s,
                        total: (c = zn(c, [
                            "intersection_length"
                        ], [
                            "desc"
                        ])).length
                    },
                    data: {
                        items: c.slice((s - 1) * o, s * o)
                    }
                };
            }(t, e, r);
        },
        aggregation: function(t) {
            return function(t, e, r, n, o) {
                var i = e.per_page || 10, s = e.page || 1;
                if (e.name && (!r.aggregations || !r.aggregations[e.name])) throw new Error('Please define aggregation "'.concat(e.name, '" in config'));
                var a = Dn(e);
                if (a.page = 1, a.per_page = 0, !e.name) throw new Error("field name is required");
                r.aggregations[e.name].size = 1e4;
                var u = Un(0, a, r, n, o).data.aggregations[e.name].buckets;
                return {
                    pagination: {
                        per_page: i,
                        page: s,
                        total: u.length
                    },
                    data: {
                        buckets: u.slice((s - 1) * i, s * i)
                    }
                };
            }(0, t, e, r, n);
        },
        reindex: function(o) {
            r = new Ln(t = o, e), n = new Bn(t, e);
        }
    };
}

});












var $00a848b12ea3af18$exports = {};
/*
Tagify v4.34.0 - tags input component
By: Yair Even-Or <vsync.design@gmail.com>
https://github.com/yairEO/tagify

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in
all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
THE SOFTWARE.

This Software may not be rebranded and sold as a library under any other name
other than "Tagify" (by owner) or as part of another library.
*/ !function(t1, e) {
    $00a848b12ea3af18$exports = e();
}($00a848b12ea3af18$exports, function() {
    "use strict";
    var t1 = "&#8203;";
    function e(t1, e) {
        (null == e || e > t1.length) && (e = t1.length);
        for(var i = 0, n = new Array(e); i < e; i++)n[i] = t1[i];
        return n;
    }
    function i(t1) {
        return function(t1) {
            if (Array.isArray(t1)) return e(t1);
        }(t1) || function(t1) {
            if ("undefined" != typeof Symbol && null != t1[Symbol.iterator] || null != t1["@@iterator"]) return Array.from(t1);
        }(t1) || function(t1, i) {
            if (!t1) return;
            if ("string" == typeof t1) return e(t1, i);
            var n = Object.prototype.toString.call(t1).slice(8, -1);
            "Object" === n && t1.constructor && (n = t1.constructor.name);
            if ("Map" === n || "Set" === n) return Array.from(n);
            if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return e(t1, i);
        }(t1) || function() {
            throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }();
    }
    var n = {
        isEnabled: function() {
            var t1;
            return null === (t1 = window.TAGIFY_DEBUG) || void 0 === t1 || t1;
        },
        log: function() {
            for(var t1 = arguments.length, e = new Array(t1), n = 0; n < t1; n++)e[n] = arguments[n];
            var s;
            this.isEnabled() && (s = console).log.apply(s, [
                "[Tagify]:"
            ].concat(i(e)));
        },
        warn: function() {
            for(var t1 = arguments.length, e = new Array(t1), n = 0; n < t1; n++)e[n] = arguments[n];
            var s;
            this.isEnabled() && (s = console).warn.apply(s, [
                "[Tagify]:"
            ].concat(i(e)));
        }
    }, s = function(t1, e, i, n) {
        return t1 = "" + t1, e = "" + e, n && (t1 = t1.trim(), e = e.trim()), i ? t1 == e : t1.toLowerCase() == e.toLowerCase();
    }, a = function(t1, e) {
        return t1 && Array.isArray(t1) && t1.map(function(t1) {
            return o(t1, e);
        });
    };
    function o(t1, e) {
        var i, n = {};
        for(i in t1)e.indexOf(i) < 0 && (n[i] = t1[i]);
        return n;
    }
    function r(t1) {
        return (new DOMParser).parseFromString(t1.trim(), "text/html").body.firstElementChild;
    }
    function l(t1, e) {
        for(e = e || "previous"; t1 = t1[e + "Sibling"];)if (3 == t1.nodeType) return t1;
    }
    function d(t1) {
        return "string" == typeof t1 ? t1.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/`|'/g, "&#039;") : t1;
    }
    function c(t1) {
        var e = Object.prototype.toString.call(t1).split(" ")[1].slice(0, -1);
        return t1 === Object(t1) && "Array" != e && "Function" != e && "RegExp" != e && "HTMLUnknownElement" != e;
    }
    function u(t1, e, i) {
        var n, s;
        function a(t1, e) {
            for(var i in e)if (e.hasOwnProperty(i)) {
                if (c(e[i])) {
                    c(t1[i]) ? a(t1[i], e[i]) : t1[i] = Object.assign({}, e[i]);
                    continue;
                }
                if (Array.isArray(e[i])) {
                    t1[i] = Object.assign([], e[i]);
                    continue;
                }
                t1[i] = e[i];
            }
        }
        return n = t1, (null != (s = Object) && "undefined" != typeof Symbol && s[Symbol.hasInstance] ? s[Symbol.hasInstance](n) : n instanceof s) || (t1 = {}), a(t1, e), i && a(t1, i), t1;
    }
    function g() {
        var t1 = [], e = {}, i = !0, n = !1, s = void 0;
        try {
            for(var a, o = arguments[Symbol.iterator](); !(i = (a = o.next()).done); i = !0){
                var r = a.value, l = !0, d = !1, u = void 0;
                try {
                    for(var g, h = r[Symbol.iterator](); !(l = (g = h.next()).done); l = !0){
                        var p = g.value;
                        c(p) ? e[p.value] || (t1.push(p), e[p.value] = 1) : t1.includes(p) || t1.push(p);
                    }
                } catch (t1) {
                    d = !0, u = t1;
                } finally{
                    try {
                        l || null == h.return || h.return();
                    } finally{
                        if (d) throw u;
                    }
                }
            }
        } catch (t1) {
            n = !0, s = t1;
        } finally{
            try {
                i || null == o.return || o.return();
            } finally{
                if (n) throw s;
            }
        }
        return t1;
    }
    function h(t1) {
        return String.prototype.normalize ? "string" == typeof t1 ? t1.normalize("NFD").replace(/[\u0300-\u036f]/g, "") : void 0 : t1;
    }
    var p = function() {
        return /(?=.*chrome)(?=.*android)/i.test(navigator.userAgent);
    };
    function f() {
        return "10000000-1000-4000-8000-100000000000".replace(/[018]/g, function(t1) {
            return (t1 ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> t1 / 4).toString(16);
        });
    }
    function m(t1) {
        var e;
        return b.call(this, t1) && (null == t1 || null === (e = t1.classList) || void 0 === e ? void 0 : e.contains(this.settings.classNames.tag));
    }
    function v(t1) {
        return b.call(this, t1) && (null == t1 ? void 0 : t1.closest(this.settings.classNames.tagSelector));
    }
    function b(t1) {
        var e;
        return (null == t1 || null === (e = t1.closest) || void 0 === e ? void 0 : e.call(t1, this.settings.classNames.namespaceSelector)) === this.DOM.scope;
    }
    function w(t1, e) {
        var i = window.getSelection();
        return e = e || i.getRangeAt(0), "string" == typeof t1 && (t1 = document.createTextNode(t1)), e && (e.deleteContents(), e.insertNode(t1)), t1;
    }
    function y(t1, e, i) {
        return t1 ? (e && (t1.__tagifyTagData = i ? e : u({}, t1.__tagifyTagData || {}, e)), t1.__tagifyTagData) : (n.warn("tag element doesn't exist", {
            tagElm: t1,
            data: e
        }), e);
    }
    function T(t1) {
        if (t1 && t1.parentNode) {
            var e = t1, i = window.getSelection(), n = i.getRangeAt(0);
            i.rangeCount && (n.setStartAfter(e), n.collapse(!0), i.removeAllRanges(), i.addRange(n));
        }
    }
    function O(t1, e) {
        t1.forEach(function(t1) {
            if (y(t1.previousSibling) || !t1.previousSibling) {
                var i = document.createTextNode("\u200B");
                t1.before(i), e && T(i);
            }
        });
    }
    var D = {
        delimiters: ",",
        pattern: null,
        tagTextProp: "value",
        maxTags: 1 / 0,
        callbacks: {},
        addTagOnBlur: !0,
        addTagOn: [
            "blur",
            "tab",
            "enter"
        ],
        onChangeAfterBlur: !0,
        duplicates: !1,
        whitelist: [],
        blacklist: [],
        enforceWhitelist: !1,
        userInput: !0,
        focusable: !0,
        focusInputOnRemove: !0,
        keepInvalidTags: !1,
        createInvalidTags: !0,
        mixTagsAllowedAfter: /,|\.|\:|\s/,
        mixTagsInterpolator: [
            "[[",
            "]]"
        ],
        backspace: !0,
        skipInvalid: !1,
        pasteAsTags: !0,
        editTags: {
            clicks: 2,
            keepInvalid: !0
        },
        transformTag: function() {},
        trim: !0,
        a11y: {
            focusableTags: !1
        },
        mixMode: {
            insertAfterTag: "\xa0"
        },
        autoComplete: {
            enabled: !0,
            rightKey: !1,
            tabKey: !1
        },
        classNames: {
            namespace: "tagify",
            mixMode: "tagify--mix",
            selectMode: "tagify--select",
            input: "tagify__input",
            focus: "tagify--focus",
            tagNoAnimation: "tagify--noAnim",
            tagInvalid: "tagify--invalid",
            tagNotAllowed: "tagify--notAllowed",
            scopeLoading: "tagify--loading",
            hasMaxTags: "tagify--hasMaxTags",
            hasNoTags: "tagify--noTags",
            empty: "tagify--empty",
            inputInvalid: "tagify__input--invalid",
            dropdown: "tagify__dropdown",
            dropdownWrapper: "tagify__dropdown__wrapper",
            dropdownHeader: "tagify__dropdown__header",
            dropdownFooter: "tagify__dropdown__footer",
            dropdownItem: "tagify__dropdown__item",
            dropdownItemActive: "tagify__dropdown__item--active",
            dropdownItemHidden: "tagify__dropdown__item--hidden",
            dropdownItemSelected: "tagify__dropdown__item--selected",
            dropdownInital: "tagify__dropdown--initial",
            tag: "tagify__tag",
            tagText: "tagify__tag-text",
            tagX: "tagify__tag__removeBtn",
            tagLoading: "tagify__tag--loading",
            tagEditing: "tagify__tag--editable",
            tagFlash: "tagify__tag--flash",
            tagHide: "tagify__tag--hide"
        },
        dropdown: {
            classname: "",
            enabled: 2,
            maxItems: 10,
            searchKeys: [
                "value",
                "searchBy"
            ],
            fuzzySearch: !0,
            caseSensitive: !1,
            accentedSearch: !0,
            includeSelectedTags: !1,
            escapeHTML: !0,
            highlightFirst: !0,
            closeOnSelect: !0,
            clearOnSelect: !0,
            position: "all",
            appendTarget: null
        },
        hooks: {
            beforeRemoveTag: function() {
                return Promise.resolve();
            },
            beforePaste: function() {
                return Promise.resolve();
            },
            suggestionClick: function() {
                return Promise.resolve();
            },
            beforeKeyDown: function() {
                return Promise.resolve();
            }
        }
    };
    function x(t1, e, i) {
        return e in t1 ? Object.defineProperty(t1, e, {
            value: i,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : t1[e] = i, t1;
    }
    function S(t1) {
        for(var e = 1; e < arguments.length; e++){
            var i = null != arguments[e] ? arguments[e] : {}, n = Object.keys(i);
            "function" == typeof Object.getOwnPropertySymbols && (n = n.concat(Object.getOwnPropertySymbols(i).filter(function(t1) {
                return Object.getOwnPropertyDescriptor(i, t1).enumerable;
            }))), n.forEach(function(e) {
                x(t1, e, i[e]);
            });
        }
        return t1;
    }
    function I(t1, e) {
        return e = null != e ? e : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(t1, Object.getOwnPropertyDescriptors(e)) : (function(t1, e) {
            var i = Object.keys(t1);
            if (Object.getOwnPropertySymbols) {
                var n = Object.getOwnPropertySymbols(t1);
                e && (n = n.filter(function(e) {
                    return Object.getOwnPropertyDescriptor(t1, e).enumerable;
                })), i.push.apply(i, n);
            }
            return i;
        })(Object(e)).forEach(function(i) {
            Object.defineProperty(t1, i, Object.getOwnPropertyDescriptor(e, i));
        }), t1;
    }
    var M = {
        events: {
            binding: function() {
                var t1 = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0], e = this.dropdown.events.callbacks, i = this.listeners.dropdown = this.listeners.dropdown || {
                    position: this.dropdown.position.bind(this, null),
                    onKeyDown: e.onKeyDown.bind(this),
                    onMouseOver: e.onMouseOver.bind(this),
                    onMouseLeave: e.onMouseLeave.bind(this),
                    onClick: e.onClick.bind(this),
                    onScroll: e.onScroll.bind(this)
                }, n = t1 ? "addEventListener" : "removeEventListener";
                "manual" != this.settings.dropdown.position && (document[n]("scroll", i.position, !0), window[n]("resize", i.position), window[n]("keydown", i.onKeyDown)), this.DOM.dropdown[n]("mouseover", i.onMouseOver), this.DOM.dropdown[n]("mouseleave", i.onMouseLeave), this.DOM.dropdown[n]("mousedown", i.onClick), this.DOM.dropdown.content[n]("scroll", i.onScroll);
            },
            callbacks: {
                onKeyDown: function(t1) {
                    var e = this;
                    if (this.state.hasFocus && !this.state.composing) {
                        var i = this.settings, s = i.dropdown.includeSelectedTags, a = this.DOM.dropdown.querySelector(i.classNames.dropdownItemActiveSelector), o = this.dropdown.getSuggestionDataByNode(a), r = "mix" == i.mode, l = "select" == i.mode;
                        i.hooks.beforeKeyDown(t1, {
                            tagify: this
                        }).then(function(d) {
                            switch(t1.key){
                                case "ArrowDown":
                                case "ArrowUp":
                                case "Down":
                                case "Up":
                                    t1.preventDefault();
                                    var c = e.dropdown.getAllSuggestionsRefs(), u = "ArrowUp" == t1.key || "Up" == t1.key;
                                    a && (a = e.dropdown.getNextOrPrevOption(a, !u)), a && a.matches(i.classNames.dropdownItemSelector) || (a = c[u ? c.length - 1 : 0]), e.dropdown.highlightOption(a, !0);
                                    break;
                                case "PageUp":
                                case "PageDown":
                                    var g;
                                    t1.preventDefault();
                                    var h = e.dropdown.getAllSuggestionsRefs(), p = Math.floor(e.DOM.dropdown.content.clientHeight / (null === (g = h[0]) || void 0 === g ? void 0 : g.offsetHeight)) || 1, f = "PageUp" === t1.key;
                                    if (a) {
                                        var m = h.indexOf(a), v = f ? Math.max(0, m - p) : Math.min(h.length - 1, m + p);
                                        a = h[v];
                                    } else a = h[0];
                                    e.dropdown.highlightOption(a, !0);
                                    break;
                                case "Home":
                                case "End":
                                    t1.preventDefault();
                                    var b = e.dropdown.getAllSuggestionsRefs();
                                    a = b["Home" === t1.key ? 0 : b.length - 1], e.dropdown.highlightOption(a, !0);
                                    break;
                                case "Escape":
                                case "Esc":
                                    e.dropdown.hide();
                                    break;
                                case "ArrowRight":
                                    if (e.state.actions.ArrowLeft || i.autoComplete.rightKey) return;
                                case "Tab":
                                    var w = !i.autoComplete.rightKey || !i.autoComplete.tabKey;
                                    if (!r && !l && a && w && !e.state.editing && o) {
                                        t1.preventDefault();
                                        var y = e.dropdown.getMappedValue(o);
                                        return e.state.autoCompleteData = o, e.input.autocomplete.set.call(e, y), !1;
                                    }
                                    return !0;
                                case "Enter":
                                    t1.preventDefault(), e.state.actions.selectOption = !0, setTimeout(function() {
                                        return e.state.actions.selectOption = !1;
                                    }, 100), i.hooks.suggestionClick(t1, {
                                        tagify: e,
                                        tagData: o,
                                        suggestionElm: a
                                    }).then(function() {
                                        if (a) {
                                            var i = s ? a : e.dropdown.getNextOrPrevOption(a, !u);
                                            e.dropdown.selectOption(a, t1, function() {
                                                if (i) {
                                                    var t1 = i.getAttribute("value");
                                                    i = e.dropdown.getSuggestionNodeByValue(t1), e.dropdown.highlightOption(i);
                                                }
                                            });
                                        } else e.dropdown.hide(), r || e.addTags(e.state.inputText.trim(), !0);
                                    }).catch(function(t1) {
                                        return n.warn(t1);
                                    });
                                    break;
                                case "Backspace":
                                    if (r || e.state.editing.scope) return;
                                    var T = e.input.raw.call(e);
                                    "" != T && 8203 != T.charCodeAt(0) || (!0 === i.backspace ? e.removeTags() : "edit" == i.backspace && setTimeout(e.editTag.bind(e), 0));
                            }
                        });
                    }
                },
                onMouseOver: function(t1) {
                    var e = t1.target.closest(this.settings.classNames.dropdownItemSelector);
                    this.dropdown.highlightOption(e);
                },
                onMouseLeave: function(t1) {
                    this.dropdown.highlightOption();
                },
                onClick: function(t1) {
                    var e = this;
                    if (0 == t1.button && t1.target != this.DOM.dropdown && t1.target != this.DOM.dropdown.content) {
                        var i = t1.target.closest(this.settings.classNames.dropdownItemSelector), s = this.dropdown.getSuggestionDataByNode(i);
                        this.state.actions.selectOption = !0, setTimeout(function() {
                            return e.state.actions.selectOption = !1;
                        }, 100), this.settings.hooks.suggestionClick(t1, {
                            tagify: this,
                            tagData: s,
                            suggestionElm: i
                        }).then(function() {
                            i ? e.dropdown.selectOption(i, t1) : e.dropdown.hide();
                        }).catch(function(t1) {
                            return n.warn(t1);
                        });
                    }
                },
                onScroll: function(t1) {
                    var e = t1.target, i = e.scrollTop / (e.scrollHeight - e.parentNode.clientHeight) * 100;
                    this.trigger("dropdown:scroll", {
                        percentage: Math.round(i)
                    });
                }
            }
        },
        refilter: function(t1) {
            t1 = t1 || this.state.dropdown.query || "", this.suggestedListItems = this.dropdown.filterListItems(t1), this.dropdown.fill(), this.suggestedListItems.length || this.dropdown.hide(), this.trigger("dropdown:updated", this.DOM.dropdown);
        },
        getSuggestionDataByNode: function(t1) {
            for(var e, i = t1 && t1.getAttribute("value"), n = this.suggestedListItems.length; n--;){
                if (c(e = this.suggestedListItems[n]) && e.value == i) return e;
                if (e == i) return {
                    value: e
                };
            }
        },
        getSuggestionNodeByValue: function(t1) {
            return this.dropdown.getAllSuggestionsRefs().find(function(e) {
                return e.getAttribute("value") === t1;
            });
        },
        getNextOrPrevOption: function(t1) {
            var e = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1], i = this.dropdown.getAllSuggestionsRefs(), n = i.findIndex(function(e) {
                return e === t1;
            });
            return e ? i[n + 1] : i[n - 1];
        },
        highlightOption: function(t1, e) {
            var i, n = this.settings.classNames.dropdownItemActive;
            if (this.state.ddItemElm && (this.state.ddItemElm.classList.remove(n), this.state.ddItemElm.removeAttribute("aria-selected")), !t1) return this.state.ddItemData = null, this.state.ddItemElm = null, void this.input.autocomplete.suggest.call(this);
            i = this.dropdown.getSuggestionDataByNode(t1), this.state.ddItemData = i, this.state.ddItemElm = t1, t1.classList.add(n), t1.setAttribute("aria-selected", !0), e && (t1.parentNode.scrollTop = t1.clientHeight + t1.offsetTop - t1.parentNode.clientHeight), this.settings.autoComplete && (this.input.autocomplete.suggest.call(this, i), this.dropdown.position());
        },
        selectOption: function(t1, e, i) {
            var n = this, s = this.settings, a = s.dropdown.includeSelectedTags, o = s.dropdown, r = o.clearOnSelect, l = o.closeOnSelect;
            if (!t1) return this.addTags(this.state.inputText, !0), void (l && this.dropdown.hide());
            e = e || {};
            var d = t1.getAttribute("value"), c = "noMatch" == d, g = "mix" == s.mode, h = this.suggestedListItems.find(function(t1) {
                var e;
                return (null !== (e = t1.value) && void 0 !== e ? e : t1) == d;
            });
            if (this.trigger("dropdown:select", {
                data: h,
                elm: t1,
                event: e
            }), h || c) {
                if (this.state.editing) {
                    var p = this.normalizeTags([
                        h
                    ])[0];
                    h = s.transformTag.call(this, p) || p, this.onEditTagDone(null, u({
                        __isValid: !0
                    }, h));
                } else this[g ? "addMixTags" : "addTags"]([
                    h || this.input.raw.call(this)
                ], r);
                (g || this.DOM.input.parentNode) && (setTimeout(function() {
                    n.DOM.input.focus(), n.toggleFocusClass(!0);
                }), l && setTimeout(this.dropdown.hide.bind(this)), a ? i && i() : (t1.addEventListener("transitionend", function() {
                    n.dropdown.fillHeaderFooter(), setTimeout(function() {
                        t1.remove(), n.dropdown.refilter(), i && i();
                    }, 100);
                }, {
                    once: !0
                }), t1.classList.add(this.settings.classNames.dropdownItemHidden)));
            } else l && setTimeout(this.dropdown.hide.bind(this));
        },
        selectAll: function(t1) {
            this.suggestedListItems.length = 0, this.dropdown.hide(), this.dropdown.filterListItems("");
            var e = this.dropdown.filterListItems("");
            return t1 || (e = this.state.dropdown.suggestions), this.addTags(e, !0), this;
        },
        filterListItems: function(t1, e) {
            var i, n, s, a, o, r, l = function() {
                var t1, l, d = void 0, u = void 0;
                t1 = m[T], n = (null != (l = Object) && "undefined" != typeof Symbol && l[Symbol.hasInstance] ? l[Symbol.hasInstance](t1) : t1 instanceof l) ? m[T] : {
                    value: m[T]
                };
                var v, b = !Object.keys(n).some(function(t1) {
                    return y.includes(t1);
                }) ? [
                    "value"
                ] : y;
                g.fuzzySearch && !e.exact ? (a = b.reduce(function(t1, e) {
                    return t1 + " " + (n[e] || "");
                }, "").toLowerCase().trim(), g.accentedSearch && (a = h(a), r = h(r)), d = 0 == a.indexOf(r), u = a === r, v = a, s = r.toLowerCase().split(" ").every(function(t1) {
                    return v.includes(t1.toLowerCase());
                })) : (d = !0, s = b.some(function(t1) {
                    var i = "" + (n[t1] || "");
                    return g.accentedSearch && (i = h(i), r = h(r)), g.caseSensitive || (i = i.toLowerCase()), u = i === r, e.exact ? i === r : 0 == i.indexOf(r);
                })), o = !g.includeSelectedTags && i.isTagDuplicate(c(n) ? n.value : n), s && !o && (u && d ? f.push(n) : "startsWith" == g.sortby && d ? p.unshift(n) : p.push(n));
            }, d = this, u = this.settings, g = u.dropdown, p = (e = e || {}, []), f = [], m = u.whitelist, v = g.maxItems >= 0 ? g.maxItems : 1 / 0, b = g.includeSelectedTags, w = "function" == typeof g.sortby, y = g.searchKeys, T = 0;
            if (!(t1 = "select" == u.mode && this.value.length && this.value[0][u.tagTextProp] == t1 ? "" : t1) || !y.length) {
                p = b ? m : m.filter(function(t1) {
                    return !d.isTagDuplicate(c(t1) ? t1.value : t1);
                });
                var O = w ? g.sortby(p, r) : p.slice(0, v);
                return this.state.dropdown.suggestions = O, O;
            }
            for(r = g.caseSensitive ? "" + t1 : ("" + t1).toLowerCase(); T < m.length; T++)i = this, l();
            this.state.dropdown.suggestions = f.concat(p);
            O = w ? g.sortby(f.concat(p), r) : f.concat(p).slice(0, v);
            return this.state.dropdown.suggestions = O, O;
        },
        getMappedValue: function(t1) {
            var e = this.settings.dropdown.mapValueTo;
            return e ? "function" == typeof e ? e(t1) : t1[e] || t1.value : t1.value;
        },
        createListHTML: function(t1) {
            var e = this;
            return u([], t1).map(function(t1, i) {
                "string" != typeof t1 && "number" != typeof t1 || (t1 = {
                    value: t1
                });
                var n = e.dropdown.getMappedValue(t1);
                return n = "string" == typeof n && e.settings.dropdown.escapeHTML ? d(n) : n, e.settings.templates.dropdownItem.apply(e, [
                    I(S({}, t1), {
                        mappedValue: n
                    }),
                    e
                ]);
            }).join("");
        }
    };
    function E(t1, e) {
        (null == e || e > t1.length) && (e = t1.length);
        for(var i = 0, n = new Array(e); i < e; i++)n[i] = t1[i];
        return n;
    }
    function N(t1, e, i) {
        return e in t1 ? Object.defineProperty(t1, e, {
            value: i,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : t1[e] = i, t1;
    }
    function A(t1) {
        return function(t1) {
            if (Array.isArray(t1)) return E(t1);
        }(t1) || function(t1) {
            if ("undefined" != typeof Symbol && null != t1[Symbol.iterator] || null != t1["@@iterator"]) return Array.from(t1);
        }(t1) || function(t1, e) {
            if (!t1) return;
            if ("string" == typeof t1) return E(t1, e);
            var i = Object.prototype.toString.call(t1).slice(8, -1);
            "Object" === i && t1.constructor && (i = t1.constructor.name);
            if ("Map" === i || "Set" === i) return Array.from(i);
            if ("Arguments" === i || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(i)) return E(t1, e);
        }(t1) || function() {
            throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }();
    }
    function _() {
        for(var t1 in this.dropdown = {}, this._dropdown)this.dropdown[t1] = "function" == typeof this._dropdown[t1] ? this._dropdown[t1].bind(this) : this._dropdown[t1];
        this.dropdown.refs(), this.DOM.dropdown.__tagify = this;
    }
    var C, k, L = (C = function(t1) {
        for(var e = 1; e < arguments.length; e++){
            var i = null != arguments[e] ? arguments[e] : {}, n = Object.keys(i);
            "function" == typeof Object.getOwnPropertySymbols && (n = n.concat(Object.getOwnPropertySymbols(i).filter(function(t1) {
                return Object.getOwnPropertyDescriptor(i, t1).enumerable;
            }))), n.forEach(function(e) {
                N(t1, e, i[e]);
            });
        }
        return t1;
    }({}, M), k = (k = {
        refs: function() {
            this.DOM.dropdown = this.parseTemplate("dropdown", [
                this.settings
            ]), this.DOM.dropdown.content = this.DOM.dropdown.querySelector("[data-selector='tagify-suggestions-wrapper']");
        },
        getHeaderRef: function() {
            return this.DOM.dropdown.querySelector("[data-selector='tagify-suggestions-header']");
        },
        getFooterRef: function() {
            return this.DOM.dropdown.querySelector("[data-selector='tagify-suggestions-footer']");
        },
        getAllSuggestionsRefs: function() {
            return A(this.DOM.dropdown.content.querySelectorAll(this.settings.classNames.dropdownItemSelector));
        },
        show: function(t1) {
            var e, i, n, a = this, o = this.settings, r = "mix" == o.mode && !o.enforceWhitelist, l = !o.whitelist || !o.whitelist.length, d = "manual" == o.dropdown.position;
            if (t1 = void 0 === t1 ? this.state.inputText : t1, !(l && !r && !o.templates.dropdownItemNoMatch || !1 === o.dropdown.enabled || this.state.isLoading || this.settings.readonly)) {
                if (clearTimeout(this.dropdownHide__bindEventsTimeout), this.suggestedListItems = this.dropdown.filterListItems(t1), t1 && !this.suggestedListItems.length && (this.trigger("dropdown:noMatch", t1), o.templates.dropdownItemNoMatch && (n = o.templates.dropdownItemNoMatch.call(this, {
                    value: t1
                }))), !n) {
                    if (this.suggestedListItems.length) t1 && r && !this.state.editing.scope && !s(this.suggestedListItems[0].value, t1) && this.suggestedListItems.unshift({
                        value: t1
                    });
                    else {
                        if (!t1 || !r || this.state.editing.scope) return this.input.autocomplete.suggest.call(this), void this.dropdown.hide();
                        this.suggestedListItems = [
                            {
                                value: t1
                            }
                        ];
                    }
                    i = "" + (c(e = this.suggestedListItems[0]) ? e.value : e), o.autoComplete && i && 0 == i.indexOf(t1) && this.input.autocomplete.suggest.call(this, e);
                }
                this.dropdown.fill(n), o.dropdown.highlightFirst && this.dropdown.highlightOption(this.DOM.dropdown.content.querySelector(o.classNames.dropdownItemSelector)), this.state.dropdown.visible || setTimeout(this.dropdown.events.binding.bind(this)), this.state.dropdown.visible = t1 || !0, this.state.dropdown.query = t1, this.setStateSelection(), d || setTimeout(function() {
                    a.dropdown.position(), a.dropdown.render();
                }), setTimeout(function() {
                    a.trigger("dropdown:show", a.DOM.dropdown);
                });
            }
        },
        hide: function(t1) {
            var e = this, i = this.DOM, n = i.scope, s = i.dropdown, a = "manual" == this.settings.dropdown.position && !t1;
            if (s && document.body.contains(s) && !a) return window.removeEventListener("resize", this.dropdown.position), this.dropdown.events.binding.call(this, !1), n.setAttribute("aria-expanded", !1), s.parentNode.removeChild(s), setTimeout(function() {
                e.state.dropdown.visible = !1;
            }, 100), this.state.dropdown.query = this.state.ddItemData = this.state.ddItemElm = this.state.selection = null, this.state.tag && this.state.tag.value.length && (this.state.flaggedTags[this.state.tag.baseOffset] = this.state.tag), this.trigger("dropdown:hide", s), this;
        },
        toggle: function(t1) {
            this.dropdown[this.state.dropdown.visible && !t1 ? "hide" : "show"]();
        },
        getAppendTarget: function() {
            var t1 = this.settings.dropdown;
            return "function" == typeof t1.appendTarget ? t1.appendTarget() : t1.appendTarget;
        },
        render: function() {
            var t1, e, i, n = this, s = (t1 = this.DOM.dropdown, (i = t1.cloneNode(!0)).style.cssText = "position:fixed; top:-9999px; opacity:0", document.body.appendChild(i), e = i.clientHeight, i.parentNode.removeChild(i), e), a = this.settings, o = this.dropdown.getAppendTarget();
            return !1 === a.dropdown.enabled || (this.DOM.scope.setAttribute("aria-expanded", !0), document.body.contains(this.DOM.dropdown) || (this.DOM.dropdown.classList.add(a.classNames.dropdownInital), this.dropdown.position(s), o.appendChild(this.DOM.dropdown), setTimeout(function() {
                return n.DOM.dropdown.classList.remove(a.classNames.dropdownInital);
            }))), this;
        },
        fill: function(t1) {
            t1 = "string" == typeof t1 ? t1 : this.dropdown.createListHTML(t1 || this.suggestedListItems);
            var e, i = this.settings.templates.dropdownContent.call(this, t1);
            this.DOM.dropdown.content.innerHTML = (e = i) ? e.replace(/\>[\r\n ]+\</g, "><").split(/>\s+</).join("><").trim() : "";
        },
        fillHeaderFooter: function() {
            var t1 = this.dropdown.filterListItems(this.state.dropdown.query), e = this.parseTemplate("dropdownHeader", [
                t1
            ]), i = this.parseTemplate("dropdownFooter", [
                t1
            ]), n = this.dropdown.getHeaderRef(), s = this.dropdown.getFooterRef();
            e && (null == n || n.parentNode.replaceChild(e, n)), i && (null == s || s.parentNode.replaceChild(i, s));
        },
        position: function(t1) {
            var e = this.settings.dropdown, i = this.dropdown.getAppendTarget();
            if ("manual" != e.position && i) {
                var n, s, a, o, r, l, d, c, u, g, h = this.DOM.dropdown, p = e.RTL, f = i === document.body, m = i === this.DOM.scope, v = f ? window.pageYOffset : i.scrollTop, b = document.fullscreenElement || document.webkitFullscreenElement || document.documentElement, w = b.clientHeight, y = Math.max(b.clientWidth || 0, window.innerWidth || 0), T = y > 480 ? e.position : "all", O = this.DOM["input" == T ? "input" : "scope"];
                if (t1 = t1 || h.clientHeight, this.state.dropdown.visible) {
                    if ("text" == T ? (a = (n = function() {
                        var t1 = document.getSelection();
                        if (t1.rangeCount) {
                            var e, i, n = t1.getRangeAt(0), s = n.startContainer, a = n.startOffset;
                            if (a > 0) return (i = document.createRange()).setStart(s, a - 1), i.setEnd(s, a), {
                                left: (e = i.getBoundingClientRect()).right,
                                top: e.top,
                                bottom: e.bottom
                            };
                            if (s.getBoundingClientRect) return s.getBoundingClientRect();
                        }
                        return {
                            left: -9999,
                            top: -9999
                        };
                    }()).bottom, s = n.top, o = n.left, r = "auto") : (l = function(t1) {
                        var e = 0, i = 0;
                        for(t1 = t1.parentNode; t1 && t1 != b;)e += t1.offsetTop || 0, i += t1.offsetLeft || 0, t1 = t1.parentNode;
                        return {
                            top: e,
                            left: i
                        };
                    }(i), n = O.getBoundingClientRect(), s = m ? -1 : n.top - l.top, a = (m ? n.height : n.bottom - l.top) - 1, o = m ? -1 : n.left - l.left, r = n.width + "px"), !f) {
                        var D = function() {
                            for(var t1 = 0, i = e.appendTarget.parentNode; i;)t1 += i.scrollTop || 0, i = i.parentNode;
                            return t1;
                        }();
                        s += D, a += D;
                    }
                    var x;
                    s = Math.floor(s), a = Math.ceil(a), c = y - o < 120, u = ((d = null !== (x = e.placeAbove) && void 0 !== x ? x : w - n.bottom < t1) ? s : a) + v, g = o + (p && n.width || 0) + window.pageXOffset, g = "text" == T && c ? "right: 0;" : "left: ".concat(g, "px;"), h.style.cssText = "".concat(g, " top: ").concat(u, "px; min-width: ").concat(r, "; max-width: ").concat(r), h.setAttribute("placement", d ? "top" : "bottom"), h.setAttribute("position", T);
                }
            }
        }
    }, k), Object.getOwnPropertyDescriptors ? Object.defineProperties(C, Object.getOwnPropertyDescriptors(k)) : (function(t1, e) {
        var i = Object.keys(t1);
        if (Object.getOwnPropertySymbols) {
            var n = Object.getOwnPropertySymbols(t1);
            e && (n = n.filter(function(e) {
                return Object.getOwnPropertyDescriptor(t1, e).enumerable;
            })), i.push.apply(i, n);
        }
        return i;
    })(Object(k)).forEach(function(t1) {
        Object.defineProperty(C, t1, Object.getOwnPropertyDescriptor(k, t1));
    }), C), P = "@yaireo/tagify/", j = {
        empty: "empty",
        exceed: "number of tags exceeded",
        pattern: "pattern mismatch",
        duplicate: "already exists",
        notAllowed: "not allowed"
    }, V = {
        wrapper: function(e, i) {
            return '<tags class="'.concat(i.classNames.namespace, " ").concat(i.mode ? "".concat(i.classNames[i.mode + "Mode"]) : "", " ").concat(e.className, '"\n                    ').concat(i.readonly ? "readonly" : "", "\n                    ").concat(i.disabled ? "disabled" : "", "\n                    ").concat(i.required ? "required" : "", "\n                    ").concat("select" === i.mode ? "spellcheck='false'" : "", '\n                    tabIndex="-1">\n                    ').concat(this.settings.templates.input.call(this), "\n                ").concat(t1, "\n        </tags>");
        },
        input: function() {
            var e = this.settings, i = e.placeholder || t1;
            return "<span ".concat(!e.readonly && e.userInput ? "contenteditable" : "", ' tabIndex="0" data-placeholder="').concat(i, '" aria-placeholder="').concat(e.placeholder || "", '"\n                    class="').concat(e.classNames.input, '"\n                    role="textbox"\n                    autocapitalize="false"\n                    autocorrect="off"\n                    aria-autocomplete="both"\n                    aria-multiline="').concat("mix" == e.mode, '"></span>');
        },
        tag: function(t1, e) {
            var i = e.settings;
            return '<tag title="'.concat(t1.title || t1.value, "\"\n                    contenteditable='false'\n                    tabIndex=\"").concat(i.a11y.focusableTags ? 0 : -1, '"\n                    class="').concat(i.classNames.tag, " ").concat(t1.class || "", '"\n                    ').concat(this.getAttributes(t1), ">\n            <x title='' tabIndex=\"").concat(i.a11y.focusableTags ? 0 : -1, '" class="').concat(i.classNames.tagX, "\" role='button' aria-label='remove tag'></x>\n            <div>\n                <span ").concat("select" === i.mode && i.userInput ? "contenteditable='true'" : "", ' autocapitalize="false" autocorrect="off" spellcheck=\'false\' class="').concat(i.classNames.tagText, '">').concat(t1[i.tagTextProp] || t1.value, "</span>\n            </div>\n        </tag>");
        },
        dropdown: function(t1) {
            var e = t1.dropdown, i = "manual" == e.position;
            return '<div class="'.concat(i ? "" : t1.classNames.dropdown, " ").concat(e.classname, '" role="listbox" aria-labelledby="dropdown" dir="').concat(e.RTL ? "rtl" : "", "\">\n                    <div data-selector='tagify-suggestions-wrapper' class=\"").concat(t1.classNames.dropdownWrapper, '"></div>\n                </div>');
        },
        dropdownContent: function(t1) {
            var e = this.settings.templates, i = this.state.dropdown.suggestions;
            return "\n            ".concat(e.dropdownHeader.call(this, i), "\n            ").concat(t1, "\n            ").concat(e.dropdownFooter.call(this, i), "\n        ");
        },
        dropdownItem: function(t1) {
            return "<div ".concat(this.getAttributes(t1), "\n                    class='").concat(this.settings.classNames.dropdownItem, " ").concat(this.isTagDuplicate(t1.value) ? this.settings.classNames.dropdownItemSelected : "", " ").concat(t1.class || "", '\'\n                    tabindex="0"\n                    role="option">').concat(t1.mappedValue || t1.value, "</div>");
        },
        dropdownHeader: function(t1) {
            return "<header data-selector='tagify-suggestions-header' class=\"".concat(this.settings.classNames.dropdownHeader, '"></header>');
        },
        dropdownFooter: function(t1) {
            var e = t1.length - this.settings.dropdown.maxItems;
            return e > 0 ? "<footer data-selector='tagify-suggestions-footer' class=\"".concat(this.settings.classNames.dropdownFooter, '">\n                ').concat(e, " more items. Refine your search.\n            </footer>") : "";
        },
        dropdownItemNoMatch: null
    };
    function R(t1, e) {
        (null == e || e > t1.length) && (e = t1.length);
        for(var i = 0, n = new Array(e); i < e; i++)n[i] = t1[i];
        return n;
    }
    function F(t1, e) {
        return null != e && "undefined" != typeof Symbol && e[Symbol.hasInstance] ? !!e[Symbol.hasInstance](t1) : t1 instanceof e;
    }
    function H(t1, e) {
        return function(t1) {
            if (Array.isArray(t1)) return t1;
        }(t1) || function(t1, e) {
            var i = null == t1 ? null : "undefined" != typeof Symbol && t1[Symbol.iterator] || t1["@@iterator"];
            if (null != i) {
                var n, s, a = [], o = !0, r = !1;
                try {
                    for(i = i.call(t1); !(o = (n = i.next()).done) && (a.push(n.value), !e || a.length !== e); o = !0);
                } catch (t1) {
                    r = !0, s = t1;
                } finally{
                    try {
                        o || null == i.return || i.return();
                    } finally{
                        if (r) throw s;
                    }
                }
                return a;
            }
        }(t1, e) || function(t1, e) {
            if (!t1) return;
            if ("string" == typeof t1) return R(t1, e);
            var i = Object.prototype.toString.call(t1).slice(8, -1);
            "Object" === i && t1.constructor && (i = t1.constructor.name);
            if ("Map" === i || "Set" === i) return Array.from(i);
            if ("Arguments" === i || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(i)) return R(t1, e);
        }(t1, e) || function() {
            throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }();
    }
    function B(t1, e) {
        (null == e || e > t1.length) && (e = t1.length);
        for(var i = 0, n = new Array(e); i < e; i++)n[i] = t1[i];
        return n;
    }
    function W(t1, e, i) {
        return e in t1 ? Object.defineProperty(t1, e, {
            value: i,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : t1[e] = i, t1;
    }
    function q(t1, e) {
        return null != e && "undefined" != typeof Symbol && e[Symbol.hasInstance] ? !!e[Symbol.hasInstance](t1) : t1 instanceof e;
    }
    function U(t1, e) {
        return e = null != e ? e : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(t1, Object.getOwnPropertyDescriptors(e)) : (function(t1, e) {
            var i = Object.keys(t1);
            if (Object.getOwnPropertySymbols) {
                var n = Object.getOwnPropertySymbols(t1);
                e && (n = n.filter(function(e) {
                    return Object.getOwnPropertyDescriptor(t1, e).enumerable;
                })), i.push.apply(i, n);
            }
            return i;
        })(Object(e)).forEach(function(i) {
            Object.defineProperty(t1, i, Object.getOwnPropertyDescriptor(e, i));
        }), t1;
    }
    function K(t1) {
        return function(t1) {
            if (Array.isArray(t1)) return B(t1);
        }(t1) || function(t1) {
            if ("undefined" != typeof Symbol && null != t1[Symbol.iterator] || null != t1["@@iterator"]) return Array.from(t1);
        }(t1) || function(t1, e) {
            if (!t1) return;
            if ("string" == typeof t1) return B(t1, e);
            var i = Object.prototype.toString.call(t1).slice(8, -1);
            "Object" === i && t1.constructor && (i = t1.constructor.name);
            if ("Map" === i || "Set" === i) return Array.from(i);
            if ("Arguments" === i || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(i)) return B(t1, e);
        }(t1) || function() {
            throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }();
    }
    var z = {
        customBinding: function() {
            var t1 = this;
            this.customEventsList.forEach(function(e) {
                t1.on(e, t1.settings.callbacks[e]);
            });
        },
        binding: function() {
            var t1, e = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0], i = this.settings, n = this.events.callbacks, s = e ? "addEventListener" : "removeEventListener";
            if (!this.state.mainEvents || !e) {
                for(var a in this.state.mainEvents = e, e && !this.listeners.main && (this.events.bindGlobal.call(this), this.settings.isJQueryPlugin && jQuery(this.DOM.originalInput).on("tagify.removeAllTags", this.removeAllTags.bind(this))), t1 = this.listeners.main = this.listeners.main || {
                    keydown: [
                        "input",
                        n.onKeydown.bind(this)
                    ],
                    click: [
                        "scope",
                        n.onClickScope.bind(this)
                    ],
                    dblclick: "select" != i.mode && [
                        "scope",
                        n.onDoubleClickScope.bind(this)
                    ],
                    paste: [
                        "input",
                        n.onPaste.bind(this)
                    ],
                    drop: [
                        "input",
                        n.onDrop.bind(this)
                    ],
                    compositionstart: [
                        "input",
                        n.onCompositionStart.bind(this)
                    ],
                    compositionend: [
                        "input",
                        n.onCompositionEnd.bind(this)
                    ]
                })t1[a] && this.DOM[t1[a][0]][s](a, t1[a][1]);
                var o = this.listeners.main.inputMutationObserver || new MutationObserver(n.onInputDOMChange.bind(this));
                o.disconnect(), "mix" == i.mode && o.observe(this.DOM.input, {
                    childList: !0
                }), this.events.bindOriginaInputListener.call(this);
            }
        },
        bindOriginaInputListener: function(t1) {
            var e = (t1 || 0) + 500;
            this.listeners.main && (clearInterval(this.listeners.main.originalInputValueObserverInterval), this.listeners.main.originalInputValueObserverInterval = setInterval(this.events.callbacks.observeOriginalInputValue.bind(this), e));
        },
        bindGlobal: function(t1) {
            var e, i = this.events.callbacks, n = t1 ? "removeEventListener" : "addEventListener";
            if (this.listeners && (t1 || !this.listeners.global)) {
                this.listeners.global = this.listeners.global || [
                    {
                        type: this.isIE ? "keydown" : "input",
                        target: this.DOM.input,
                        cb: i[this.isIE ? "onInputIE" : "onInput"].bind(this)
                    },
                    {
                        type: "keydown",
                        target: window,
                        cb: i.onWindowKeyDown.bind(this)
                    },
                    {
                        type: "focusin",
                        target: this.DOM.scope,
                        cb: i.onFocusBlur.bind(this)
                    },
                    {
                        type: "focusout",
                        target: this.DOM.scope,
                        cb: i.onFocusBlur.bind(this)
                    },
                    {
                        type: "click",
                        target: document,
                        cb: i.onClickAnywhere.bind(this),
                        useCapture: !0
                    }
                ];
                var s = !0, a = !1, o = void 0;
                try {
                    for(var r, l = this.listeners.global[Symbol.iterator](); !(s = (r = l.next()).done); s = !0)(e = r.value).target[n](e.type, e.cb, !!e.useCapture);
                } catch (t1) {
                    a = !0, o = t1;
                } finally{
                    try {
                        s || null == l.return || l.return();
                    } finally{
                        if (a) throw o;
                    }
                }
            }
        },
        unbindGlobal: function() {
            this.events.bindGlobal.call(this, !0);
        },
        callbacks: {
            onFocusBlur: function(t1) {
                var e, i, n = this.settings, s = v.call(this, t1.relatedTarget), a = m.call(this, t1.relatedTarget), o = t1.target.classList.contains(n.classNames.tagX), r = "focusin" == t1.type, l = "focusout" == t1.type;
                o && "mix" != n.mode && n.focusInputOnRemove && this.DOM.input.focus(), s && r && !a && !o && this.toggleFocusClass(this.state.hasFocus = +new Date);
                var d = t1.target ? this.trim(this.DOM.input.textContent) : "", c = null === (i = this.value) || void 0 === i || null === (e = i[0]) || void 0 === e ? void 0 : e[n.tagTextProp], u = n.dropdown.enabled >= 0, g = {
                    relatedTarget: t1.relatedTarget
                }, h = this.state.actions.selectOption && (u || !n.dropdown.closeOnSelect), p = this.state.actions.addNew && u;
                if (l) {
                    if (t1.relatedTarget === this.DOM.scope) return this.dropdown.hide(), void this.DOM.input.focus();
                    this.postUpdate(), n.onChangeAfterBlur && this.triggerChangeEvent();
                }
                if (!(h || p || o)) {
                    if (this.state.hasFocus = !(!r && !s) && +new Date, this.toggleFocusClass(this.state.hasFocus), "mix" != n.mode) {
                        if (r) {
                            if (!n.focusable) return;
                            "select" != n.mode && this.DOM.input.focus();
                            var f = 0 === n.dropdown.enabled && !this.state.dropdown.visible, b = this.DOM.scope.querySelector(this.settings.classNames.tagTextSelector);
                            return this.trigger("focus", g), void (f && !a && (this.dropdown.show(this.value.length ? "" : void 0), "select" === n.mode && this.setRangeAtStartEnd(!1, b)));
                        }
                        if (l) {
                            if (this.trigger("blur", g), this.loading(!1), "select" == n.mode) {
                                if (this.value.length) {
                                    var w = this.getTagElms()[0];
                                    d = this.trim(w.textContent);
                                }
                                c === d && (d = "");
                            }
                            d && !this.state.actions.selectOption && n.addTagOnBlur && n.addTagOn.includes("blur") && this.addTags(d, !0);
                        }
                        s || (this.DOM.input.removeAttribute("style"), this.dropdown.hide());
                    } else r ? this.trigger("focus", g) : l && (this.trigger("blur", g), this.loading(!1), this.dropdown.hide(), this.state.dropdown.visible = void 0, this.setStateSelection());
                }
            },
            onCompositionStart: function(t1) {
                this.state.composing = !0;
            },
            onCompositionEnd: function(t1) {
                this.state.composing = !1;
            },
            onWindowKeyDown: function(t1) {
                var e, i = this.settings, n = document.activeElement, s = v.call(this, n) && this.DOM.scope.contains(n), a = n === this.DOM.input, o = s && n.hasAttribute("readonly"), r = this.DOM.scope.querySelector(this.settings.classNames.tagTextSelector), l = this.state.dropdown.visible;
                if (("Tab" === t1.key && l || this.state.hasFocus || s && !o) && !a) {
                    e = n.nextElementSibling;
                    var d = t1.target.classList.contains(i.classNames.tagX);
                    switch(t1.key){
                        case "Backspace":
                            i.readonly || this.state.editing || (this.removeTags(n), (e || this.DOM.input).focus());
                            break;
                        case "Enter":
                            if (d) return void this.removeTags(t1.target.parentNode);
                            i.a11y.focusableTags && m.call(this, n) && setTimeout(this.editTag.bind(this), 0, n);
                            break;
                        case "ArrowDown":
                            this.state.dropdown.visible || "mix" == i.mode || this.dropdown.show();
                            break;
                        case "Tab":
                            null == r || r.focus();
                    }
                }
            },
            onKeydown: function(t1) {
                var e = this, i = this.settings;
                if (!this.state.composing && i.userInput) {
                    "select" == i.mode && i.enforceWhitelist && this.value.length && "Tab" != t1.key && t1.preventDefault();
                    var n = this.trim(t1.target.textContent);
                    this.trigger("keydown", {
                        event: t1
                    }), i.hooks.beforeKeyDown(t1, {
                        tagify: this
                    }).then(function(s) {
                        if ("mix" == i.mode) {
                            switch(t1.key){
                                case "Left":
                                case "ArrowLeft":
                                    e.state.actions.ArrowLeft = !0;
                                    break;
                                case "Delete":
                                case "Backspace":
                                    if (e.state.editing) return;
                                    var a = document.getSelection(), o = "Delete" == t1.key && a.anchorOffset == (a.anchorNode.length || 0), r = a.anchorNode.previousSibling, d = 1 == a.anchorNode.nodeType || !a.anchorOffset && r && 1 == r.nodeType && a.anchorNode.previousSibling;
                                    !function(t1) {
                                        var e = document.createElement("div");
                                        t1.replace(/\&#?[0-9a-z]+;/gi, function(t1) {
                                            return e.innerHTML = t1, e.innerText;
                                        });
                                    }(e.DOM.input.innerHTML);
                                    var c, u, g, h = e.getTagElms(), f = 1 === a.anchorNode.length && a.anchorNode.nodeValue == String.fromCharCode(8203);
                                    if ("edit" == i.backspace && d) return c = 1 == a.anchorNode.nodeType ? null : a.anchorNode.previousElementSibling, setTimeout(e.editTag.bind(e), 0, c), void t1.preventDefault();
                                    if (p() && q(d, Element)) return g = l(d), d.hasAttribute("readonly") || d.remove(), e.DOM.input.focus(), void setTimeout(function() {
                                        T(g), e.DOM.input.click();
                                    });
                                    if ("BR" == a.anchorNode.nodeName) return;
                                    if ((o || d) && 1 == a.anchorNode.nodeType ? u = 0 == a.anchorOffset ? o ? h[0] : null : h[Math.min(h.length, a.anchorOffset) - 1] : o ? u = a.anchorNode.nextElementSibling : q(d, Element) && (u = d), 3 == a.anchorNode.nodeType && !a.anchorNode.nodeValue && a.anchorNode.previousElementSibling && t1.preventDefault(), (d || o) && !i.backspace) return void t1.preventDefault();
                                    if ("Range" != a.type && !a.anchorOffset && a.anchorNode == e.DOM.input && "Delete" != t1.key) return void t1.preventDefault();
                                    if ("Range" != a.type && u && u.hasAttribute("readonly")) return void T(l(u));
                                    "Delete" == t1.key && f && y(a.anchorNode.nextSibling) && e.removeTags(a.anchorNode.nextSibling);
                            }
                            return !0;
                        }
                        var m = "manual" == i.dropdown.position;
                        switch(t1.key){
                            case "Backspace":
                                "select" == i.mode && i.enforceWhitelist && e.value.length ? e.removeTags() : e.state.dropdown.visible && "manual" != i.dropdown.position || "" != t1.target.textContent && 8203 != n.charCodeAt(0) || (!0 === i.backspace ? e.removeTags() : "edit" == i.backspace && setTimeout(e.editTag.bind(e), 0));
                                break;
                            case "Esc":
                            case "Escape":
                                if (e.state.dropdown.visible) return;
                                t1.target.blur();
                                break;
                            case "Down":
                            case "ArrowDown":
                                e.state.dropdown.visible || e.dropdown.show();
                                break;
                            case "ArrowRight":
                                var v = e.state.inputSuggestion || e.state.ddItemData;
                                if (v && i.autoComplete.rightKey) return void e.addTags([
                                    v
                                ], !0);
                                break;
                            case "Tab":
                                return !0;
                            case "Enter":
                                if (e.state.dropdown.visible && !m) return;
                                t1.preventDefault();
                                var b = e.state.autoCompleteData || n;
                                setTimeout(function() {
                                    e.state.dropdown.visible && !m || e.state.actions.selectOption || !i.addTagOn.includes(t1.key.toLowerCase()) || (e.addTags([
                                        b
                                    ], !0), e.state.autoCompleteData = null);
                                });
                        }
                    }).catch(function(t1) {
                        return t1;
                    });
                }
            },
            onInput: function(t1) {
                this.postUpdate();
                var e = this.settings;
                if ("mix" == e.mode) return this.events.callbacks.onMixTagsInput.call(this, t1);
                var i = this.input.normalize.call(this, void 0, {
                    trim: !1
                }), n = i.length >= e.dropdown.enabled, s = {
                    value: i,
                    inputElm: this.DOM.input
                }, a = this.validateTag({
                    value: i
                });
                "select" == e.mode && this.toggleScopeValidation(a), s.isValid = a, this.state.inputText != i && (this.input.set.call(this, i, !1), -1 != i.search(e.delimiters) ? this.addTags(i) && this.input.set.call(this) : e.dropdown.enabled >= 0 && this.dropdown[n ? "show" : "hide"](i), this.trigger("input", s));
            },
            onMixTagsInput: function(t1) {
                var e, i, n, s, a, o, r, l, d = this, c = this.settings, g = this.value.length, h = this.getTagElms(), f = document.createDocumentFragment(), m = window.getSelection().getRangeAt(0), v = [].map.call(h, function(t1) {
                    return y(t1).value;
                });
                if ("deleteContentBackward" == t1.inputType && p() && this.events.callbacks.onKeydown.call(this, {
                    target: t1.target,
                    key: "Backspace"
                }), O(this.getTagElms()), this.value.slice().forEach(function(t1) {
                    t1.readonly && !v.includes(t1.value) && f.appendChild(d.createTagElem(t1));
                }), f.childNodes.length && (m.insertNode(f), this.setRangeAtStartEnd(!1, f.lastChild)), h.length != g) return this.value = [].map.call(this.getTagElms(), function(t1) {
                    return y(t1);
                }), void this.update({
                    withoutChangeEvent: !0
                });
                if (this.hasMaxTags()) return !0;
                if (window.getSelection && (o = window.getSelection()).rangeCount > 0 && 3 == o.anchorNode.nodeType) {
                    if ((m = o.getRangeAt(0).cloneRange()).collapse(!0), m.setStart(o.focusNode, 0), n = (e = m.toString().slice(0, m.endOffset)).split(c.pattern).length - 1, (i = e.match(c.pattern)) && (s = e.slice(e.lastIndexOf(i[i.length - 1]))), s) {
                        if (this.state.actions.ArrowLeft = !1, this.state.tag = {
                            prefix: s.match(c.pattern)[0],
                            value: s.replace(c.pattern, "")
                        }, this.state.tag.baseOffset = o.baseOffset - this.state.tag.value.length, l = this.state.tag.value.match(c.delimiters)) return this.state.tag.value = this.state.tag.value.replace(c.delimiters, ""), this.state.tag.delimiters = l[0], this.addTags(this.state.tag.value, c.dropdown.clearOnSelect), void this.dropdown.hide();
                        a = this.state.tag.value.length >= c.dropdown.enabled;
                        try {
                            r = (r = this.state.flaggedTags[this.state.tag.baseOffset]).prefix == this.state.tag.prefix && r.value[0] == this.state.tag.value[0], this.state.flaggedTags[this.state.tag.baseOffset] && !this.state.tag.value && delete this.state.flaggedTags[this.state.tag.baseOffset];
                        } catch (t1) {}
                        (r || n < this.state.mixMode.matchedPatternCount) && (a = !1);
                    } else this.state.flaggedTags = {};
                    this.state.mixMode.matchedPatternCount = n;
                }
                setTimeout(function() {
                    d.update({
                        withoutChangeEvent: !0
                    }), d.trigger("input", u({}, d.state.tag, {
                        textContent: d.DOM.input.textContent
                    })), d.state.tag && d.dropdown[a ? "show" : "hide"](d.state.tag.value);
                }, 10);
            },
            onInputIE: function(t1) {
                var e = this;
                setTimeout(function() {
                    e.events.callbacks.onInput.call(e, t1);
                });
            },
            observeOriginalInputValue: function() {
                this.DOM.originalInput.parentNode || this.destroy(), this.DOM.originalInput.value != this.DOM.originalInput.tagifyValue && this.loadOriginalValues();
            },
            onClickAnywhere: function(t1) {
                if (t1.target != this.DOM.scope && !this.DOM.scope.contains(t1.target)) {
                    this.toggleFocusClass(!1), this.state.hasFocus = !1;
                    var e = t1.target.closest(this.settings.classNames.dropdownSelector);
                    (null == e ? void 0 : e.__tagify) != this && this.dropdown.hide();
                }
            },
            onClickScope: function(t1) {
                var e = this.settings, i = t1.target.closest("." + e.classNames.tag);
                t1.target, this.DOM.scope;
                var n = +new Date - this.state.hasFocus;
                if (!t1.target.classList.contains(e.classNames.tagX)) return i && !this.state.editing ? (this.trigger("click", {
                    tag: i,
                    index: this.getNodeIndex(i),
                    data: y(i),
                    event: t1
                }), void (1 !== e.editTags && 1 !== e.editTags.clicks && "select" != e.mode || this.events.callbacks.onDoubleClickScope.call(this, t1))) : void (t1.target == this.DOM.input && ("mix" == e.mode && this.fixFirefoxLastTagNoCaret(), n > 500 || !e.focusable) ? this.state.dropdown.visible ? this.dropdown.hide() : 0 === e.dropdown.enabled && "mix" != e.mode && this.dropdown.show(this.value.length ? "" : void 0) : "select" != e.mode || 0 !== e.dropdown.enabled || this.state.dropdown.visible || (this.events.callbacks.onDoubleClickScope.call(this, U(function(t1) {
                    for(var e = 1; e < arguments.length; e++){
                        var i = null != arguments[e] ? arguments[e] : {}, n = Object.keys(i);
                        "function" == typeof Object.getOwnPropertySymbols && (n = n.concat(Object.getOwnPropertySymbols(i).filter(function(t1) {
                            return Object.getOwnPropertyDescriptor(i, t1).enumerable;
                        }))), n.forEach(function(e) {
                            W(t1, e, i[e]);
                        });
                    }
                    return t1;
                }({}, t1), {
                    target: this.getTagElms()[0]
                })), !e.userInput && this.dropdown.show()));
                this.removeTags(t1.target.parentNode);
            },
            onPaste: function(t1) {
                var e = this;
                t1.preventDefault();
                var i, n, s, a = this.settings;
                if (!a.userInput) return !1;
                a.readonly || (n = t1.clipboardData || window.clipboardData, s = n.getData("Text"), a.hooks.beforePaste(t1, {
                    tagify: this,
                    pastedText: s,
                    clipboardData: n
                }).then(function(a) {
                    void 0 === a && (a = s), a && (e.injectAtCaret(a, window.getSelection().getRangeAt(0)), "mix" == e.settings.mode ? e.events.callbacks.onMixTagsInput.call(e, t1) : e.settings.pasteAsTags ? i = e.addTags(e.state.inputText + a, !0) : (e.state.inputText = a, e.dropdown.show(a))), e.trigger("paste", {
                        event: t1,
                        pastedText: s,
                        clipboardData: n,
                        tagsElems: i
                    });
                }).catch(function(t1) {
                    return t1;
                }));
            },
            onDrop: function(t1) {
                t1.preventDefault();
            },
            onEditTagInput: function(t1, e) {
                var i, n = t1.closest("." + this.settings.classNames.tag), s = this.getNodeIndex(n), a = y(n), o = this.input.normalize.call(this, t1), r = (W(i = {}, this.settings.tagTextProp, o), W(i, "__tagId", a.__tagId), i), l = this.validateTag(r);
                this.editTagChangeDetected(u(a, r)) || !0 !== t1.originalIsValid || (l = !0), n.classList.toggle(this.settings.classNames.tagInvalid, !0 !== l), a.__isValid = l, n.title = !0 === l ? a.title || a.value : l, o.length >= this.settings.dropdown.enabled && (this.state.editing && (this.state.editing.value = o), this.dropdown.show(o)), this.trigger("edit:input", {
                    tag: n,
                    index: s,
                    data: u({}, this.value[s], {
                        newValue: o
                    }),
                    event: e
                });
            },
            onEditTagPaste: function(t1, e) {
                var i = (e.clipboardData || window.clipboardData).getData("Text");
                e.preventDefault();
                var n = w(i);
                this.setRangeAtStartEnd(!1, n);
            },
            onEditTagClick: function(t1, e) {
                this.events.callbacks.onClickScope.call(this, e);
            },
            onEditTagFocus: function(t1) {
                this.state.editing = {
                    scope: t1,
                    input: t1.querySelector("[contenteditable]")
                };
            },
            onEditTagBlur: function(t1, e) {
                var i = m.call(this, e.relatedTarget);
                if ("select" == this.settings.mode && i && e.relatedTarget.contains(e.target)) this.dropdown.hide();
                else if (this.state.editing && (this.state.hasFocus || this.toggleFocusClass(), this.DOM.scope.contains(document.activeElement) || this.trigger("blur", {}), this.DOM.scope.contains(t1))) {
                    var n, s, a, o = this.settings, r = t1.closest("." + o.classNames.tag), l = y(r), d = this.input.normalize.call(this, t1), c = (W(n = {}, o.tagTextProp, d), W(n, "__tagId", l.__tagId), n), g = l.__originalData, h = this.editTagChangeDetected(u(l, c)), p = this.validateTag(c);
                    if (d) {
                        if (h) {
                            var f;
                            if (s = this.hasMaxTags(), a = u({}, g, (W(f = {}, o.tagTextProp, this.trim(d)), W(f, "__isValid", p), f)), o.transformTag.call(this, a, g), !0 !== (p = (!s || !0 === g.__isValid) && this.validateTag(a))) {
                                if (this.trigger("invalid", {
                                    data: a,
                                    tag: r,
                                    message: p
                                }), o.editTags.keepInvalid) return;
                                o.keepInvalidTags ? a.__isValid = p : a = g;
                            } else o.keepInvalidTags && (delete a.title, delete a["aria-invalid"], delete a.class);
                            this.onEditTagDone(r, a);
                        } else this.onEditTagDone(r, g);
                    } else this.onEditTagDone(r);
                }
            },
            onEditTagkeydown: function(t1, e) {
                if (!this.state.composing) switch(this.trigger("edit:keydown", {
                    event: t1
                }), t1.key){
                    case "Esc":
                    case "Escape":
                        this.state.editing = !1, !!e.__tagifyTagData.__originalData.value ? e.parentNode.replaceChild(e.__tagifyTagData.__originalHTML, e) : e.remove();
                        break;
                    case "Enter":
                    case "Tab":
                        t1.preventDefault();
                        setTimeout(function() {
                            return t1.target.blur();
                        }, 0);
                }
            },
            onDoubleClickScope: function(t1) {
                var e = t1.target.closest("." + this.settings.classNames.tag);
                if (e) {
                    var i, n, s = y(e), a = this.settings;
                    !1 !== (null == s ? void 0 : s.editable) && (i = e.classList.contains(this.settings.classNames.tagEditing), n = e.hasAttribute("readonly"), a.readonly || i || n || !this.settings.editTags || !a.userInput || (this.events.callbacks.onEditTagFocus.call(this, e), this.editTag(e)), this.toggleFocusClass(!0), "select" != a.mode && this.trigger("dblclick", {
                        tag: e,
                        index: this.getNodeIndex(e),
                        data: y(e)
                    }));
                }
            },
            onInputDOMChange: function(t1) {
                var e = this;
                t1.forEach(function(t1) {
                    t1.addedNodes.forEach(function(t1) {
                        if ("<div><br></div>" == t1.outerHTML) t1.replaceWith(document.createElement("br"));
                        else if (1 == t1.nodeType && t1.querySelector(e.settings.classNames.tagSelector)) {
                            var i, n = document.createTextNode("");
                            3 == t1.childNodes[0].nodeType && "BR" != t1.previousSibling.nodeName && (n = document.createTextNode("\n")), (i = t1).replaceWith.apply(i, K([
                                n
                            ].concat(K(K(t1.childNodes).slice(0, -1))))), T(n);
                        } else if (m.call(e, t1)) {
                            var s;
                            if (3 != (null === (s = t1.previousSibling) || void 0 === s ? void 0 : s.nodeType) || t1.previousSibling.textContent || t1.previousSibling.remove(), t1.previousSibling && "BR" == t1.previousSibling.nodeName) {
                                t1.previousSibling.replaceWith("\n\u200B");
                                for(var a = t1.nextSibling, o = ""; a;)o += a.textContent, a = a.nextSibling;
                                o.trim() && T(t1.previousSibling);
                            } else t1.previousSibling && !y(t1.previousSibling) || t1.before("\u200B");
                        }
                    }), t1.removedNodes.forEach(function(t1) {
                        t1 && "BR" == t1.nodeName && m.call(e, i) && (e.removeTags(i), e.fixFirefoxLastTagNoCaret());
                    });
                });
                var i = this.DOM.input.lastChild;
                i && "" == i.nodeValue && i.remove(), i && "BR" == i.nodeName || this.DOM.input.appendChild(document.createElement("br"));
            }
        }
    };
    function X(t1, e) {
        (null == e || e > t1.length) && (e = t1.length);
        for(var i = 0, n = new Array(e); i < e; i++)n[i] = t1[i];
        return n;
    }
    function J(t1, e, i) {
        return e in t1 ? Object.defineProperty(t1, e, {
            value: i,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : t1[e] = i, t1;
    }
    function G(t1, e) {
        return null != e && "undefined" != typeof Symbol && e[Symbol.hasInstance] ? !!e[Symbol.hasInstance](t1) : t1 instanceof e;
    }
    function $(t1) {
        for(var e = 1; e < arguments.length; e++){
            var i = null != arguments[e] ? arguments[e] : {}, n = Object.keys(i);
            "function" == typeof Object.getOwnPropertySymbols && (n = n.concat(Object.getOwnPropertySymbols(i).filter(function(t1) {
                return Object.getOwnPropertyDescriptor(i, t1).enumerable;
            }))), n.forEach(function(e) {
                J(t1, e, i[e]);
            });
        }
        return t1;
    }
    function Q(t1) {
        return function(t1) {
            if (Array.isArray(t1)) return X(t1);
        }(t1) || function(t1) {
            if ("undefined" != typeof Symbol && null != t1[Symbol.iterator] || null != t1["@@iterator"]) return Array.from(t1);
        }(t1) || function(t1, e) {
            if (!t1) return;
            if ("string" == typeof t1) return X(t1, e);
            var i = Object.prototype.toString.call(t1).slice(8, -1);
            "Object" === i && t1.constructor && (i = t1.constructor.name);
            if ("Map" === i || "Set" === i) return Array.from(i);
            if ("Arguments" === i || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(i)) return X(t1, e);
        }(t1) || function() {
            throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }();
    }
    function Y(t1, e) {
        if (!t1) {
            n.warn("input element not found", t1);
            var i = new Proxy(this, {
                get: function() {
                    return function() {
                        return i;
                    };
                }
            });
            return i;
        }
        if (t1.__tagify) return n.warn("input element is already Tagified - Same instance is returned.", t1), t1.__tagify;
        var s;
        u(this, function(t1) {
            var e = document.createTextNode(""), i = {};
            function s(t1, i, n) {
                n && i.split(/\s+/g).forEach(function(i) {
                    return e[t1 + "EventListener"].call(e, i, n);
                });
            }
            return {
                removeAllCustomListeners: function() {
                    Object.entries(i).forEach(function(t1) {
                        var e = H(t1, 2), i = e[0];
                        e[1].forEach(function(t1) {
                            return s("remove", i, t1);
                        });
                    }), i = {};
                },
                off: function(t1, e) {
                    return t1 && (e ? s("remove", t1, e) : t1.split(/\s+/g).forEach(function(t1) {
                        var e;
                        null === (e = i[t1]) || void 0 === e || e.forEach(function(e) {
                            return s("remove", t1, e);
                        }), delete i[t1];
                    })), this;
                },
                on: function(t1, e) {
                    return e && "function" == typeof e && (t1.split(/\s+/g).forEach(function(t1) {
                        Array.isArray(i[t1]) ? i[t1].push(e) : i[t1] = [
                            e
                        ];
                    }), s("add", t1, e)), this;
                },
                trigger: function(i, s, a) {
                    var o;
                    if (a = a || {
                        cloneData: !0
                    }, i) {
                        if (t1.settings.isJQueryPlugin) "remove" == i && (i = "removeTag"), jQuery(t1.DOM.originalInput).triggerHandler(i, [
                            s
                        ]);
                        else {
                            try {
                                var r = "object" == typeof s ? s : {
                                    value: s
                                };
                                if ((r = a.cloneData ? u({}, r) : r).tagify = this, s.event && (r.event = this.cloneEvent(s.event)), F(s, Object)) for(var l in s)F(s[l], HTMLElement) && (r[l] = s[l]);
                                o = new CustomEvent(i, {
                                    detail: r
                                });
                            } catch (t1) {
                                n.warn(t1);
                            }
                            e.dispatchEvent(o);
                        }
                    }
                }
            };
        }(this)), this.isFirefox = /firefox|fxios/i.test(navigator.userAgent) && !/seamonkey/i.test(navigator.userAgent), this.isIE = window.document.documentMode, e = e || {}, this.getPersistedData = (s = e.id, function(t1) {
            var e;
            if (s) {
                var i, n = "/" + t1;
                if (1 === (null === (e = localStorage) || void 0 === e ? void 0 : e.getItem(P + s + "/v"))) try {
                    i = JSON.parse(localStorage[P + s + n]);
                } catch (t1) {}
                return i;
            }
        }), this.setPersistedData = function(t1) {
            var e;
            return t1 ? (null === (e = localStorage) || void 0 === e || e.setItem(P + t1 + "/v", 1), function(e, i) {
                var n, s = "/" + i, a = JSON.stringify(e);
                e && i && (null === (n = localStorage) || void 0 === n || n.setItem(P + t1 + s, a), dispatchEvent(new Event("storage")));
            }) : function() {};
        }(e.id), this.clearPersistedData = function(t1) {
            return function(e) {
                var i = P + "/" + t1 + "/";
                if (e) localStorage.removeItem(i + e);
                else for(var n in localStorage)n.includes(i) && localStorage.removeItem(n);
            };
        }(e.id), this.applySettings(t1, e), this.state = {
            inputText: "",
            editing: !1,
            composing: !1,
            actions: {},
            mixMode: {},
            dropdown: {},
            flaggedTags: {}
        }, this.value = [], this.listeners = {}, this.DOM = {}, this.build(t1), _.call(this), this.getCSSVars(), this.loadOriginalValues(), this.events.customBinding.call(this), this.events.binding.call(this), t1.autofocus && this.DOM.input.focus(), t1.__tagify = this;
    }
    return Y.prototype = {
        _dropdown: L,
        placeCaretAfterNode: T,
        getSetTagData: y,
        helpers: {
            sameStr: s,
            removeCollectionProp: a,
            omit: o,
            isObject: c,
            parseHTML: r,
            escapeHTML: d,
            extend: u,
            concatWithoutDups: g,
            getUID: f,
            isNodeTag: m
        },
        customEventsList: [
            "change",
            "add",
            "remove",
            "invalid",
            "input",
            "paste",
            "click",
            "keydown",
            "focus",
            "blur",
            "edit:input",
            "edit:beforeUpdate",
            "edit:updated",
            "edit:start",
            "edit:keydown",
            "dropdown:show",
            "dropdown:hide",
            "dropdown:select",
            "dropdown:updated",
            "dropdown:noMatch",
            "dropdown:scroll"
        ],
        dataProps: [
            "__isValid",
            "__removed",
            "__originalData",
            "__originalHTML",
            "__tagId"
        ],
        trim: function(t1) {
            return this.settings.trim && t1 && "string" == typeof t1 ? t1.trim() : t1;
        },
        parseHTML: r,
        templates: V,
        parseTemplate: function(t1, e) {
            return r((t1 = this.settings.templates[t1] || t1).apply(this, e));
        },
        set whitelist (t){
            var e1 = t && Array.isArray(t);
            this.settings.whitelist = e1 ? t : [], this.setPersistedData(e1 ? t : [], "whitelist");
        },
        get whitelist () {
            return this.settings.whitelist;
        },
        set userInput (t){
            this.settings.userInput = !!t, this.setContentEditable(!!t);
        },
        get userInput () {
            return this.settings.userInput;
        },
        generateClassSelectors: function(t1) {
            var e = function(e) {
                var i = e;
                Object.defineProperty(t1, i + "Selector", {
                    get: function() {
                        return "." + this[i].split(" ")[0];
                    }
                });
            };
            for(var i in t1)e(i);
        },
        applySettings: function(t1, e) {
            var i, n;
            D.templates = this.templates;
            var s = u({}, D, "mix" == e.mode ? {
                dropdown: {
                    position: "text"
                }
            } : {}), a = this.settings = u({}, s, e);
            if (a.disabled = t1.hasAttribute("disabled"), a.readonly = a.readonly || t1.hasAttribute("readonly"), a.placeholder = d(t1.getAttribute("placeholder") || a.placeholder || ""), a.required = t1.hasAttribute("required"), this.generateClassSelectors(a.classNames), this.isIE && (a.autoComplete = !1), [
                "whitelist",
                "blacklist"
            ].forEach(function(e) {
                var i = t1.getAttribute("data-" + e);
                i && G(i = i.split(a.delimiters), Array) && (a[e] = i);
            }), "autoComplete" in e && !c(e.autoComplete) && (a.autoComplete = D.autoComplete, a.autoComplete.enabled = e.autoComplete), "mix" == a.mode && (a.pattern = a.pattern || /@/, a.autoComplete.rightKey = !0, a.delimiters = e.delimiters || null, a.tagTextProp && !a.dropdown.searchKeys.includes(a.tagTextProp) && a.dropdown.searchKeys.push(a.tagTextProp)), t1.pattern) try {
                a.pattern = new RegExp(t1.pattern);
            } catch (t1) {}
            if (a.delimiters) {
                a._delimiters = a.delimiters;
                try {
                    a.delimiters = new RegExp(this.settings.delimiters, "g");
                } catch (t1) {}
            }
            a.disabled && (a.userInput = !1), this.TEXTS = $({}, j, a.texts || {}), "select" == a.mode && (a.dropdown.includeSelectedTags = !0), ("select" != a.mode || (null === (i = e.dropdown) || void 0 === i ? void 0 : i.enabled)) && a.userInput || (a.dropdown.enabled = 0), a.dropdown.appendTarget = (null === (n = e.dropdown) || void 0 === n ? void 0 : n.appendTarget) || document.body, void 0 === a.dropdown.includeSelectedTags && (a.dropdown.includeSelectedTags = a.duplicates);
            var o = this.getPersistedData("whitelist");
            Array.isArray(o) && (this.whitelist = Array.isArray(a.whitelist) ? g(a.whitelist, o) : o);
        },
        getAttributes: function(t1) {
            var e, i = this.getCustomAttributes(t1), n = "";
            for(e in i)n += " " + e + (void 0 !== t1[e] ? '="'.concat(i[e], '"') : "");
            return n;
        },
        getCustomAttributes: function(t1) {
            if (!c(t1)) return "";
            var e, i = {};
            for(e in t1)"__" != e.slice(0, 2) && "class" != e && t1.hasOwnProperty(e) && void 0 !== t1[e] && (i[e] = d(t1[e]));
            return i;
        },
        setStateSelection: function() {
            var t1 = window.getSelection(), e = {
                anchorOffset: t1.anchorOffset,
                anchorNode: t1.anchorNode,
                range: t1.getRangeAt && t1.rangeCount && t1.getRangeAt(0)
            };
            return this.state.selection = e, e;
        },
        getCSSVars: function() {
            var t1, e, i, n = getComputedStyle(this.DOM.scope, null);
            this.CSSVars = {
                tagHideTransition: (t1 = function(t1) {
                    if (!t1) return {};
                    var e = (t1 = t1.trim().split(" ")[0]).split(/\d+/g).filter(function(t1) {
                        return t1;
                    }).pop().trim();
                    return {
                        value: +t1.split(e).filter(function(t1) {
                            return t1;
                        })[0].trim(),
                        unit: e
                    };
                }((i = "tag-hide-transition", n.getPropertyValue("--" + i))), e = t1.value, "s" == t1.unit ? 1e3 * e : e)
            };
        },
        build: function(t1) {
            var e = this.DOM, i = t1.closest("label");
            this.settings.mixMode.integrated ? (e.originalInput = null, e.scope = t1, e.input = t1) : (e.originalInput = t1, e.originalInput_tabIndex = t1.tabIndex, e.scope = this.parseTemplate("wrapper", [
                t1,
                this.settings
            ]), e.input = e.scope.querySelector(this.settings.classNames.inputSelector), t1.parentNode.insertBefore(e.scope, t1), t1.tabIndex = -1), i && i.setAttribute("for", "");
        },
        destroy: function() {
            var t1;
            this.events.unbindGlobal.call(this), null === (t1 = this.DOM.scope.parentNode) || void 0 === t1 || t1.removeChild(this.DOM.scope), this.DOM.originalInput.tabIndex = this.DOM.originalInput_tabIndex, delete this.DOM.originalInput.__tagify, this.dropdown.hide(!0), this.removeAllCustomListeners(), clearTimeout(this.dropdownHide__bindEventsTimeout), clearInterval(this.listeners.main.originalInputValueObserverInterval);
        },
        loadOriginalValues: function(t1) {
            var e, i = this.settings;
            if (this.state.blockChangeEvent = !0, void 0 === t1) {
                var n = this.getPersistedData("value");
                t1 = n && !this.DOM.originalInput.value ? n : i.mixMode.integrated ? this.DOM.input.textContent : this.DOM.originalInput.value;
            }
            if (this.removeAllTags(), t1) {
                if ("mix" == i.mode) this.parseMixTags(t1), (e = this.DOM.input.lastChild) && "BR" == e.tagName || this.DOM.input.insertAdjacentHTML("beforeend", "<br>");
                else {
                    try {
                        G(JSON.parse(t1), Array) && (t1 = JSON.parse(t1));
                    } catch (t1) {}
                    this.addTags(t1, !0).forEach(function(t1) {
                        return t1 && t1.classList.add(i.classNames.tagNoAnimation);
                    });
                }
            } else this.postUpdate();
            this.state.lastOriginalValueReported = i.mixMode.integrated ? "" : this.DOM.originalInput.value;
        },
        cloneEvent: function(t1) {
            var e = {};
            for(var i in t1)"path" != i && (e[i] = t1[i]);
            return e;
        },
        loading: function(t1) {
            return this.state.isLoading = t1, this.DOM.scope.classList[t1 ? "add" : "remove"](this.settings.classNames.scopeLoading), this;
        },
        tagLoading: function(t1, e) {
            return t1 && t1.classList[e ? "add" : "remove"](this.settings.classNames.tagLoading), this;
        },
        toggleClass: function(t1, e) {
            "string" == typeof t1 && this.DOM.scope.classList.toggle(t1, e);
        },
        toggleScopeValidation: function(t1) {
            var e = !0 === t1 || void 0 === t1;
            !this.settings.required && t1 && t1 === this.TEXTS.empty && (e = !0), this.toggleClass(this.settings.classNames.tagInvalid, !e), this.DOM.scope.title = e ? "" : t1;
        },
        toggleFocusClass: function(t1) {
            this.toggleClass(this.settings.classNames.focus, !!t1);
        },
        setPlaceholder: function(t1) {
            var e = this;
            [
                "data",
                "aria"
            ].forEach(function(i) {
                return e.DOM.input.setAttribute("".concat(i, "-placeholder"), t1);
            });
        },
        triggerChangeEvent: function() {
            if (!this.settings.mixMode.integrated) {
                var t1 = this.DOM.originalInput, e = this.state.lastOriginalValueReported !== t1.value, i = new CustomEvent("change", {
                    bubbles: !0
                });
                e && (this.state.lastOriginalValueReported = t1.value, i.simulated = !0, t1._valueTracker && t1._valueTracker.setValue(Math.random()), t1.dispatchEvent(i), this.trigger("change", this.state.lastOriginalValueReported), t1.value = this.state.lastOriginalValueReported);
            }
        },
        events: z,
        fixFirefoxLastTagNoCaret: function() {},
        setRangeAtStartEnd: function(t1, e) {
            if (e) {
                t1 = "number" == typeof t1 ? t1 : !!t1, e = e.lastChild || e;
                var i = document.getSelection();
                if (G(i.focusNode, Element) && !this.DOM.input.contains(i.focusNode)) return !0;
                try {
                    i.rangeCount >= 1 && [
                        "Start",
                        "End"
                    ].forEach(function(n) {
                        return i.getRangeAt(0)["set" + n](e, t1 || e.length);
                    });
                } catch (t1) {
                    console.warn(t1);
                }
            }
        },
        insertAfterTag: function(t1, e) {
            if (e = e || this.settings.mixMode.insertAfterTag, t1 && t1.parentNode && e) return e = "string" == typeof e ? document.createTextNode(e) : e, t1.parentNode.insertBefore(e, t1.nextSibling), e;
        },
        editTagChangeDetected: function(t1) {
            var e = t1.__originalData;
            for(var i in e)if (!this.dataProps.includes(i) && t1[i] != e[i]) return !0;
            return !1;
        },
        getTagTextNode: function(t1) {
            return t1.querySelector(this.settings.classNames.tagTextSelector);
        },
        setTagTextNode: function(t1, e) {
            this.getTagTextNode(t1).innerHTML = d(e);
        },
        editTag: function(t1, e) {
            var i = this;
            t1 = t1 || this.getLastTag(), e = e || {};
            var s = this.settings, a = this.getTagTextNode(t1), o = this.getNodeIndex(t1), r = y(t1), l = this.events.callbacks, d = !0, c = "select" == s.mode;
            if (!c && this.dropdown.hide(), a) {
                if (!G(r, Object) || !("editable" in r) || r.editable) return r = y(t1, {
                    __originalData: u({}, r),
                    __originalHTML: t1.cloneNode(!0)
                }), y(r.__originalHTML, r.__originalData), a.setAttribute("contenteditable", !0), t1.classList.add(s.classNames.tagEditing), this.events.callbacks.onEditTagFocus.call(this, t1), a.addEventListener("click", l.onEditTagClick.bind(this, t1)), a.addEventListener("blur", l.onEditTagBlur.bind(this, this.getTagTextNode(t1))), a.addEventListener("input", l.onEditTagInput.bind(this, a)), a.addEventListener("paste", l.onEditTagPaste.bind(this, a)), a.addEventListener("keydown", function(e) {
                    return l.onEditTagkeydown.call(i, e, t1);
                }), a.addEventListener("compositionstart", l.onCompositionStart.bind(this)), a.addEventListener("compositionend", l.onCompositionEnd.bind(this)), e.skipValidation || (d = this.editTagToggleValidity(t1)), a.originalIsValid = d, this.trigger("edit:start", {
                    tag: t1,
                    index: o,
                    data: r,
                    isValid: d
                }), a.focus(), !c && this.setRangeAtStartEnd(!1, a), 0 === s.dropdown.enabled && !c && this.dropdown.show(), this.state.hasFocus = !0, this;
            } else n.warn("Cannot find element in Tag template: .", s.classNames.tagTextSelector);
        },
        editTagToggleValidity: function(t1, e) {
            var i;
            if (e = e || y(t1)) return (i = !("__isValid" in e) || !0 === e.__isValid) || this.removeTagsFromValue(t1), this.update(), t1.classList.toggle(this.settings.classNames.tagNotAllowed, !i), e.__isValid = i, e.__isValid;
            n.warn("tag has no data: ", t1, e);
        },
        onEditTagDone: function(t1, e) {
            t1 = t1 || this.state.editing.scope, e = e || {};
            var i, n, s = this.settings, a = {
                tag: t1,
                index: this.getNodeIndex(t1),
                previousData: y(t1),
                data: e
            };
            this.trigger("edit:beforeUpdate", a, {
                cloneData: !1
            }), this.state.editing = !1, delete e.__originalData, delete e.__originalHTML, t1 && t1.parentNode && ((void 0 !== (n = e[s.tagTextProp]) ? null === (i = (n += "").trim) || void 0 === i ? void 0 : i.call(n) : s.tagTextProp in e ? void 0 : e.value) ? (t1 = this.replaceTag(t1, e), this.editTagToggleValidity(t1, e), s.a11y.focusableTags ? t1.focus() : "select" != s.mode && T(t1)) : this.removeTags(t1)), this.trigger("edit:updated", a), s.dropdown.closeOnSelect && this.dropdown.hide(), this.settings.keepInvalidTags && this.reCheckInvalidTags();
        },
        replaceTag: function(t1, e) {
            e && "" !== e.value && void 0 !== e.value || (e = t1.__tagifyTagData), e.__isValid && 1 != e.__isValid && u(e, this.getInvalidTagAttrs(e, e.__isValid));
            var i = this.createTagElem(e);
            return t1.parentNode.replaceChild(i, t1), this.updateValueByDOMTags(), i;
        },
        updateValueByDOMTags: function() {
            var t1 = this;
            this.value.length = 0;
            var e = this.settings.classNames, i = [
                e.tagNotAllowed.split(" ")[0],
                e.tagHide
            ];
            [].forEach.call(this.getTagElms(), function(e) {
                Q(e.classList).some(function(t1) {
                    return i.includes(t1);
                }) || t1.value.push(y(e));
            }), this.update(), this.dropdown.refilter();
        },
        injectAtCaret: function(t1, e) {
            var i;
            if (e = e || (null === (i = this.state.selection) || void 0 === i ? void 0 : i.range), "string" == typeof t1 && (t1 = document.createTextNode(t1)), !e && t1) return this.appendMixTags(t1), this;
            var n = w(t1, e);
            return this.setRangeAtStartEnd(!1, n), this.updateValueByDOMTags(), this.update(), this;
        },
        input: {
            set: function() {
                var t1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "", e = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1], i = this.settings, n = i.dropdown.closeOnSelect;
                this.state.inputText = t1, e && (this.DOM.input.innerHTML = d("" + t1), t1 && this.toggleClass(i.classNames.empty, !this.DOM.input.innerHTML)), !t1 && n && this.dropdown.hide.bind(this), this.input.autocomplete.suggest.call(this), this.input.validate.call(this);
            },
            raw: function() {
                return this.DOM.input.textContent;
            },
            validate: function() {
                var t1 = !this.state.inputText || !0 === this.validateTag({
                    value: this.state.inputText
                });
                return this.DOM.input.classList.toggle(this.settings.classNames.inputInvalid, !t1), t1;
            },
            normalize: function(t1, e) {
                var i = t1 || this.DOM.input, n = [];
                i.childNodes.forEach(function(t1) {
                    return 3 == t1.nodeType && n.push(t1.nodeValue);
                }), n = n.join("\n");
                try {
                    n = n.replace(/(?:\r\n|\r|\n)/g, this.settings.delimiters.source.charAt(0));
                } catch (t1) {}
                return n = n.replace(/\s/g, " "), (null == e ? void 0 : e.trim) ? this.trim(n) : n;
            },
            autocomplete: {
                suggest: function(t1) {
                    if (this.settings.autoComplete.enabled) {
                        "object" != typeof (t1 = t1 || {
                            value: ""
                        }) && (t1 = {
                            value: t1
                        });
                        var e = this.dropdown.getMappedValue(t1);
                        if ("number" != typeof e) {
                            var i = this.state.inputText.toLowerCase(), n = e.substr(0, this.state.inputText.length).toLowerCase(), s = e.substring(this.state.inputText.length);
                            e && this.state.inputText && n == i ? (this.DOM.input.setAttribute("data-suggest", s), this.state.inputSuggestion = t1) : (this.DOM.input.removeAttribute("data-suggest"), delete this.state.inputSuggestion);
                        }
                    }
                },
                set: function(t1) {
                    var e = this.DOM.input.getAttribute("data-suggest"), i = t1 || (e ? this.state.inputText + e : null);
                    return !!i && ("mix" == this.settings.mode ? this.replaceTextWithNode(document.createTextNode(this.state.tag.prefix + i)) : (this.input.set.call(this, i), this.setRangeAtStartEnd(!1, this.DOM.input)), this.input.autocomplete.suggest.call(this), this.dropdown.hide(), !0);
                }
            }
        },
        getTagIdx: function(t1) {
            return this.value.findIndex(function(e) {
                return e.__tagId == (t1 || {}).__tagId;
            });
        },
        getNodeIndex: function(t1) {
            var e = 0;
            if (t1) for(; t1 = t1.previousElementSibling;)e++;
            return e;
        },
        getTagElms: function() {
            for(var t1 = arguments.length, e = new Array(t1), i = 0; i < t1; i++)e[i] = arguments[i];
            var n = "." + Q(this.settings.classNames.tag.split(" ")).concat(Q(e)).join(".");
            return [].slice.call(this.DOM.scope.querySelectorAll(n));
        },
        getLastTag: function() {
            var t1 = this.settings.classNames, e = this.DOM.scope.querySelectorAll("".concat(t1.tagSelector, ":not(.").concat(t1.tagHide, "):not([readonly])"));
            return e[e.length - 1];
        },
        isTagDuplicate: function(t1, e, i) {
            var n = 0, a = !0, o = !1, r = void 0;
            try {
                for(var l, d = this.value[Symbol.iterator](); !(a = (l = d.next()).done); a = !0){
                    var c = l.value;
                    s(this.trim("" + t1), c.value, e) && i != c.__tagId && n++;
                }
            } catch (t1) {
                o = !0, r = t1;
            } finally{
                try {
                    a || null == d.return || d.return();
                } finally{
                    if (o) throw r;
                }
            }
            return n;
        },
        getTagIndexByValue: function(t1) {
            var e = this, i = [], n = this.settings.dropdown.caseSensitive;
            return this.getTagElms().forEach(function(a, o) {
                a.__tagifyTagData && s(e.trim(a.__tagifyTagData.value), t1, n) && i.push(o);
            }), i;
        },
        getTagElmByValue: function(t1) {
            var e = this.getTagIndexByValue(t1)[0];
            return this.getTagElms()[e];
        },
        flashTag: function(t1) {
            var e = this;
            t1 && (t1.classList.add(this.settings.classNames.tagFlash), setTimeout(function() {
                t1.classList.remove(e.settings.classNames.tagFlash);
            }, 100));
        },
        isTagBlacklisted: function(t1) {
            return t1 = this.trim(t1.toLowerCase()), this.settings.blacklist.filter(function(e) {
                return ("" + e).toLowerCase() == t1;
            }).length;
        },
        isTagWhitelisted: function(t1) {
            return !!this.getWhitelistItem(t1);
        },
        getWhitelistItem: function(t1, e, i) {
            e = e || "value";
            var n, a = this.settings;
            return (i = i || a.whitelist).some(function(i) {
                var o = "object" == typeof i ? i[e] || i.value : i;
                if (s(o, t1, a.dropdown.caseSensitive, a.trim)) return n = "object" == typeof i ? i : {
                    value: i
                }, !0;
            }), n || "value" != e || "value" == a.tagTextProp || (n = this.getWhitelistItem(t1, a.tagTextProp, i)), n;
        },
        validateTag: function(t1) {
            var e = this.settings, i = "value" in t1 ? "value" : e.tagTextProp, n = this.trim(t1[i] + "");
            return (t1[i] + "").trim() ? "mix" != e.mode && e.pattern && G(e.pattern, RegExp) && !e.pattern.test(n) ? this.TEXTS.pattern : !e.duplicates && this.isTagDuplicate(n, e.dropdown.caseSensitive, t1.__tagId) ? this.TEXTS.duplicate : this.isTagBlacklisted(n) || e.enforceWhitelist && !this.isTagWhitelisted(n) ? this.TEXTS.notAllowed : !e.validate || e.validate(t1) : this.TEXTS.empty;
        },
        getInvalidTagAttrs: function(t1, e) {
            return {
                "aria-invalid": !0,
                class: "".concat(t1.class || "", " ").concat(this.settings.classNames.tagNotAllowed).trim(),
                title: e
            };
        },
        hasMaxTags: function() {
            return this.value.length >= this.settings.maxTags && this.TEXTS.exceed;
        },
        setReadonly: function(t1, e) {
            var i = this.settings;
            this.DOM.scope.contains(document.activeElement) && document.activeElement.blur(), i[e || "readonly"] = t1, this.DOM.scope[(t1 ? "set" : "remove") + "Attribute"](e || "readonly", !0), this.settings.userInput = !0, this.setContentEditable(!t1);
        },
        setContentEditable: function(t1) {
            this.DOM.scope.querySelectorAll("[contenteditable]").forEach(function(e) {
                e.contentEditable = t1, e.tabIndex = t1 ? 0 : -1;
            });
        },
        setDisabled: function(t1) {
            this.setReadonly(t1, "disabled");
        },
        normalizeTags: function(t1) {
            var e = this, i = this.settings, n = i.whitelist, s = i.delimiters, a = i.mode, o = i.tagTextProp, r = [], l = !!n && G(n[0], Object), d = Array.isArray(t1), g = d && t1[0].value, h = function(t1) {
                return (t1 + "").split(s).reduce(function(t1, i) {
                    var n, s = e.trim(i);
                    return s && t1.push((J(n = {}, o, s), J(n, "value", s), n)), t1;
                }, []);
            };
            if ("number" == typeof t1 && (t1 = t1.toString()), "string" == typeof t1) {
                if (!t1.trim()) return [];
                t1 = h(t1);
            } else d && (t1 = t1.reduce(function(t1, i) {
                if (c(i)) {
                    var n = u({}, i);
                    o in n || (o = "value"), n[o] = e.trim(n[o]), (n[o] || 0 === n[o]) && t1.push(n);
                } else if (null != i && "" !== i && void 0 !== i) {
                    var s;
                    (s = t1).push.apply(s, Q(h(i)));
                }
                return t1;
            }, []));
            return l && !g && (t1.forEach(function(t1) {
                var i = r.map(function(t1) {
                    return t1.value;
                }), n = e.dropdown.filterListItems.call(e, t1[o], {
                    exact: !0
                });
                e.settings.duplicates || (n = n.filter(function(t1) {
                    return !i.includes(t1.value);
                }));
                var s = n.length > 1 ? e.getWhitelistItem(t1[o], o, n) : n[0];
                s && G(s, Object) ? r.push(s) : "mix" != a && (null == t1.value && (t1.value = t1[o]), r.push(t1));
            }), r.length && (t1 = r)), t1;
        },
        parseMixTags: function(t1) {
            var e = this, i = this.settings, n = i.mixTagsInterpolator, s = i.duplicates, a = i.transformTag, o = i.enforceWhitelist, r = i.maxTags, l = i.tagTextProp, d = [];
            t1 = t1.split(n[0]).map(function(t1, i) {
                var c, u, g, h = t1.split(n[1]), p = h[0], f = d.length == r;
                try {
                    if (p == +p) throw Error;
                    u = JSON.parse(p);
                } catch (t1) {
                    u = e.normalizeTags(p)[0] || {
                        value: p
                    };
                }
                if (a.call(e, u), f || !(h.length > 1) || o && !e.isTagWhitelisted(u.value) || !s && e.isTagDuplicate(u.value)) {
                    if (t1) return i ? n[0] + t1 : t1;
                } else u[c = u[l] ? l : "value"] = e.trim(u[c]), g = e.createTagElem(u), d.push(u), g.classList.add(e.settings.classNames.tagNoAnimation), h[0] = g.outerHTML, e.value.push(u);
                return h.join("");
            }).join(""), this.DOM.input.innerHTML = t1, this.DOM.input.appendChild(document.createTextNode("")), this.DOM.input.normalize();
            var c = this.getTagElms();
            return c.forEach(function(t1, e) {
                return y(t1, d[e]);
            }), this.update({
                withoutChangeEvent: !0
            }), O(c, this.state.hasFocus), t1;
        },
        replaceTextWithNode: function(t1, e) {
            if (this.state.tag || e) {
                e = e || this.state.tag.prefix + this.state.tag.value;
                var i, n, s = this.state.selection || window.getSelection(), a = s.anchorNode, o = this.state.tag.delimiters ? this.state.tag.delimiters.length : 0;
                return a.splitText(s.anchorOffset - o), -1 == (i = a.nodeValue.lastIndexOf(e)) ? !0 : (n = a.splitText(i), t1 && a.parentNode.replaceChild(t1, n), !0);
            }
        },
        prepareNewTagNode: function(t1, e) {
            e = e || {};
            var i = this.settings, n = [], s = {}, a = Object.assign({}, t1, {
                value: t1.value + ""
            });
            if (t1 = Object.assign({}, a), i.transformTag.call(this, t1), t1.__isValid = this.hasMaxTags() || this.validateTag(t1), !0 !== t1.__isValid) {
                if (e.skipInvalid) return;
                if (u(s, this.getInvalidTagAttrs(t1, t1.__isValid), {
                    __preInvalidData: a
                }), t1.__isValid == this.TEXTS.duplicate && this.flashTag(this.getTagElmByValue(t1.value)), !i.createInvalidTags) return void n.push(t1.value);
            }
            return "readonly" in t1 && (t1.readonly ? s["aria-readonly"] = !0 : delete t1.readonly), {
                tagElm: this.createTagElem(t1, s),
                tagData: t1,
                aggregatedInvalidInput: n
            };
        },
        postProcessNewTagNode: function(t1, e) {
            var i = this, n = this.settings, s = e.__isValid;
            s && !0 === s ? this.value.push(e) : (this.trigger("invalid", {
                data: e,
                index: this.value.length,
                tag: t1,
                message: s
            }), n.keepInvalidTags || setTimeout(function() {
                return i.removeTags(t1, !0);
            }, 1e3)), this.dropdown.position();
        },
        selectTag: function(t1, e) {
            var i = this;
            if (!this.settings.enforceWhitelist || this.isTagWhitelisted(e.value)) {
                this.state.actions.selectOption && setTimeout(function() {
                    return i.setRangeAtStartEnd(!1, i.DOM.input);
                });
                var n = this.getLastTag();
                return n ? this.replaceTag(n, e) : this.appendTag(t1), this.value[0] = e, this.update(), this.trigger("add", {
                    tag: t1,
                    data: e
                }), [
                    t1
                ];
            }
        },
        addEmptyTag: function(t1) {
            var e = u({
                value: ""
            }, t1 || {}), i = this.createTagElem(e);
            y(i, e), this.appendTag(i), this.editTag(i, {
                skipValidation: !0
            }), this.toggleFocusClass(!0);
        },
        addTags: function(t1, e, i) {
            var n = this, s = [], a = this.settings, o = [], r = document.createDocumentFragment(), l = [];
            if (!t1 || 0 == t1.length) return s;
            switch(t1 = this.normalizeTags(t1), a.mode){
                case "mix":
                    return this.addMixTags(t1);
                case "select":
                    e = !1, this.removeAllTags();
            }
            return this.DOM.input.removeAttribute("style"), t1.forEach(function(t1) {
                var e = n.prepareNewTagNode(t1, {
                    skipInvalid: i || a.skipInvalid
                });
                if (e) {
                    var d = e.tagElm;
                    if (t1 = e.tagData, o = e.aggregatedInvalidInput, s.push(d), "select" == a.mode) return n.selectTag(d, t1);
                    r.appendChild(d), n.postProcessNewTagNode(d, t1), l.push({
                        tagElm: d,
                        tagData: t1
                    });
                }
            }), this.appendTag(r), l.forEach(function(t1) {
                var e = t1.tagElm, i = t1.tagData;
                return n.trigger("add", {
                    tag: e,
                    index: n.getTagIdx(i),
                    data: i
                });
            }), this.update(), t1.length && e && (this.input.set.call(this, a.createInvalidTags ? "" : o.join(a._delimiters)), this.setRangeAtStartEnd(!1, this.DOM.input)), this.dropdown.refilter(), s;
        },
        addMixTags: function(t1) {
            var e = this;
            if ((t1 = this.normalizeTags(t1))[0].prefix || this.state.tag) return this.prefixedTextToTag(t1[0]);
            var i = document.createDocumentFragment();
            return t1.forEach(function(t1) {
                var n = e.prepareNewTagNode(t1);
                i.appendChild(n.tagElm), e.insertAfterTag(n.tagElm), e.postProcessNewTagNode(n.tagElm, n.tagData);
            }), this.appendMixTags(i), i.children;
        },
        appendMixTags: function(t1) {
            var e = !!this.state.selection;
            e ? this.injectAtCaret(t1) : (this.DOM.input.focus(), (e = this.setStateSelection()).range.setStart(this.DOM.input, e.range.endOffset), e.range.setEnd(this.DOM.input, e.range.endOffset), this.DOM.input.appendChild(t1), this.updateValueByDOMTags(), this.update());
        },
        prefixedTextToTag: function(t1) {
            var e, i, n, s = this, a = this.settings, o = null === (e = this.state.tag) || void 0 === e ? void 0 : e.delimiters;
            if (t1.prefix = t1.prefix || this.state.tag ? this.state.tag.prefix : (a.pattern.source || a.pattern)[0], n = this.prepareNewTagNode(t1), i = n.tagElm, this.replaceTextWithNode(i) || this.DOM.input.appendChild(i), setTimeout(function() {
                return i.classList.add(s.settings.classNames.tagNoAnimation);
            }, 300), this.update(), !o) {
                var r = this.insertAfterTag(i) || i;
                setTimeout(T, 0, r);
            }
            return this.state.tag = null, this.postProcessNewTagNode(i, n.tagData), i;
        },
        appendTag: function(t1) {
            var e = this.DOM, i = e.input;
            e.scope.insertBefore(t1, i);
        },
        createTagElem: function(t1, e) {
            t1.__tagId = f();
            var i, n = u({}, t1, $({
                value: d(t1.value + "")
            }, e));
            return function(t1) {
                for(var e, i = document.createNodeIterator(t1, NodeFilter.SHOW_TEXT, null, !1); e = i.nextNode();)e.textContent.trim() || e.parentNode.removeChild(e);
            }(i = this.parseTemplate("tag", [
                n,
                this
            ])), y(i, t1), i;
        },
        reCheckInvalidTags: function() {
            var t1 = this, e = this.settings;
            this.getTagElms(e.classNames.tagNotAllowed).forEach(function(i, n) {
                var s = y(i), a = t1.hasMaxTags(), o = t1.validateTag(s), r = !0 === o && !a;
                if ("select" == e.mode && t1.toggleScopeValidation(o), r) return s = s.__preInvalidData ? s.__preInvalidData : {
                    value: s.value
                }, t1.replaceTag(i, s);
                i.title = a || o;
            });
        },
        removeTags: function(t1, e, i) {
            var n, s = this, a = this.settings;
            if (t1 = t1 && G(t1, HTMLElement) ? [
                t1
            ] : G(t1, Array) ? t1 : t1 ? [
                t1
            ] : [
                this.getLastTag()
            ].filter(function(t1) {
                return t1;
            }), n = t1.reduce(function(t1, e) {
                e && "string" == typeof e && (e = s.getTagElmByValue(e));
                var i = y(e);
                return e && i && !i.readonly && t1.push({
                    node: e,
                    idx: s.getTagIdx(i),
                    data: y(e, {
                        __removed: !0
                    })
                }), t1;
            }, []), i = "number" == typeof i ? i : this.CSSVars.tagHideTransition, "select" == a.mode && (i = 0, this.input.set.call(this)), 1 == n.length && "select" != a.mode && n[0].node.classList.contains(a.classNames.tagNotAllowed) && (e = !0), n.length) return a.hooks.beforeRemoveTag(n, {
                tagify: this
            }).then(function() {
                var t1 = function(t1) {
                    t1.node.parentNode && (t1.node.parentNode.removeChild(t1.node), e ? a.keepInvalidTags && this.trigger("remove", {
                        tag: t1.node,
                        index: t1.idx
                    }) : (this.trigger("remove", {
                        tag: t1.node,
                        index: t1.idx,
                        data: t1.data
                    }), this.dropdown.refilter(), this.dropdown.position(), this.DOM.input.normalize(), a.keepInvalidTags && this.reCheckInvalidTags()));
                };
                i && i > 10 && 1 == n.length ? (function(e) {
                    e.node.style.width = parseFloat(window.getComputedStyle(e.node).width) + "px", document.body.clientTop, e.node.classList.add(a.classNames.tagHide), setTimeout(t1.bind(this), i, e);
                }).call(s, n[0]) : n.forEach(t1.bind(s)), e || (s.removeTagsFromValue(n.map(function(t1) {
                    return t1.node;
                })), s.update(), "select" == a.mode && a.userInput && s.setContentEditable(!0));
            }).catch(function(t1) {});
        },
        removeTagsFromDOM: function() {
            this.getTagElms().forEach(function(t1) {
                return t1.remove();
            });
        },
        removeTagsFromValue: function(t1) {
            var e = this;
            (t1 = Array.isArray(t1) ? t1 : [
                t1
            ]).forEach(function(t1) {
                var i = y(t1), n = e.getTagIdx(i);
                n > -1 && e.value.splice(n, 1);
            });
        },
        removeAllTags: function(t1) {
            var e = this;
            t1 = t1 || {}, this.value = [], "mix" == this.settings.mode ? this.DOM.input.innerHTML = "" : this.removeTagsFromDOM(), this.dropdown.refilter(), this.dropdown.position(), this.state.dropdown.visible && setTimeout(function() {
                e.DOM.input.focus();
            }), "select" == this.settings.mode && (this.input.set.call(this), this.settings.userInput && this.setContentEditable(!0)), this.update(t1);
        },
        postUpdate: function() {
            this.state.blockChangeEvent = !1;
            var t1, e, i = this.settings, n = i.classNames, s = "mix" == i.mode ? i.mixMode.integrated ? this.DOM.input.textContent : this.DOM.originalInput.value.trim() : this.value.length + this.input.raw.call(this).length;
            (this.toggleClass(n.hasMaxTags, this.value.length >= i.maxTags), this.toggleClass(n.hasNoTags, !this.value.length), this.toggleClass(n.empty, !s), "select" == i.mode) && this.toggleScopeValidation(null === (e = this.value) || void 0 === e || null === (t1 = e[0]) || void 0 === t1 ? void 0 : t1.__isValid);
        },
        setOriginalInputValue: function(t1) {
            var e = this.DOM.originalInput;
            this.settings.mixMode.integrated || (e.value = t1, e.tagifyValue = e.value, this.setPersistedData(t1, "value"));
        },
        update: function(t1) {
            clearTimeout(this.debouncedUpdateTimeout), this.debouncedUpdateTimeout = setTimeout((function() {
                var e = this.getInputValue();
                this.setOriginalInputValue(e), this.settings.onChangeAfterBlur && (t1 || {}).withoutChangeEvent || this.state.blockChangeEvent || this.triggerChangeEvent();
                this.postUpdate();
            }).bind(this), 100), this.events.bindOriginaInputListener.call(this, 100);
        },
        getInputValue: function() {
            var t1 = this.getCleanValue();
            return "mix" == this.settings.mode ? this.getMixedTagsAsString(t1) : t1.length ? this.settings.originalInputValueFormat ? this.settings.originalInputValueFormat(t1) : JSON.stringify(t1) : "";
        },
        getCleanValue: function(t1) {
            return a(t1 || this.value, this.dataProps);
        },
        getMixedTagsAsString: function() {
            var t1 = "", e = this, i = this.settings, n = i.originalInputValueFormat || JSON.stringify, s = i.mixTagsInterpolator;
            return function i(a) {
                a.childNodes.forEach(function(a) {
                    if (1 == a.nodeType) {
                        var r = y(a);
                        if ("BR" == a.tagName && (t1 += "\r\n"), r && m.call(e, a)) {
                            if (r.__removed) return;
                            t1 += s[0] + n(o(r, e.dataProps)) + s[1];
                        } else a.getAttribute("style") || [
                            "B",
                            "I",
                            "U"
                        ].includes(a.tagName) ? t1 += a.textContent : "DIV" != a.tagName && "P" != a.tagName || (t1 += "\r\n", i(a));
                    } else t1 += a.textContent;
                });
            }(this.DOM.input), t1;
        }
    }, Y.prototype.removeTag = Y.prototype.removeTags, Y;
});



var $ik8y3 = parcelRequire("ik8y3");
document.querySelectorAll(".event-list").forEach((eventList)=>{
    // Collect all events
    const events = [];
    const teasers = eventList.querySelectorAll(".event-teaser");
    teasers.forEach((element)=>{
        events.push(JSON.parse(element.dataset.searchObject));
    });
    const itemsJsInstance = (0, $ik8y3.default)(events, {
        aggregations: {
            types: {
                size: 50
            },
            genres: {
                size: 50,
                conjunction: false
            },
            city: {
                size: 50,
                conjunction: false
            },
            country: {
                size: 50,
                conjunction: false
            },
            month: {
                size: 50
            },
            priceRanges: {
                size: 50
            }
        }
    });
    // Initialize the filters
    const filters = {};
    let filtered = itemsJsInstance.search({
        filters: filters,
        per_page: 1000
    });
    const doFilter = function(e) {
        filtered = itemsJsInstance.search({
            filters: filters,
            per_page: 1000
        });
        // Hide filtered teasers
        teasers.forEach((element)=>{
            const id = element.dataset.id;
            if (filtered.data.items.some((item)=>item.id === id)) element.classList.remove("hidden");
            else element.classList.add("hidden");
        });
        // Hide empty groups
        eventList.querySelectorAll(".event-list__group-title").forEach((groupTitle)=>{
            // Get the first sibling that doesn't match '.event-teaser.hidden'
            let nextElement = groupTitle.nextElementSibling;
            while(nextElement && nextElement.matches(".event-teaser.hidden, .event-list__no-results"))nextElement = nextElement.nextElementSibling;
            if (!nextElement || nextElement.matches(".event-list__group-title")) groupTitle.classList.add("hidden");
            else groupTitle.classList.remove("hidden");
        });
        // Show message if no results
        const noResults = eventList.querySelector(".event-list__no-results");
        if (filtered.data.items.length === 0) noResults.classList.remove("hidden");
        else noResults.classList.add("hidden");
    };
    eventList.querySelectorAll(".list-filters__filter").forEach((filterElement)=>{
        const key = filterElement.dataset.key;
        const usedOptions = filtered.data.aggregations[key].buckets.map((item)=>item.key);
        const allOptions = JSON.parse(filterElement.dataset.options);
        const options = usedOptions.map((option)=>allOptions.find((item)=>item.value === option)).filter((item)=>item !== undefined);
        if (key === "month") options.sort((a, b)=>a.value - b.value);
        if (key === "priceRanges") options.sort((a, b)=>a.min - b.min);
        if (options.length < 2) {
            filterElement.classList.add("hidden");
            return;
        }
        const inputElement = filterElement.querySelector("input");
        const tagify = new (0, (/*@__PURE__*/$parcel$interopDefault($00a848b12ea3af18$exports)))(inputElement, {
            enforceWhitelist: true,
            tagTextProp: "label",
            whitelist: options,
            dropdown: {
                enabled: 0,
                searchKeys: [
                    "label",
                    "searchBy"
                ],
                mapValueTo: "label",
                maxItems: 15
            }
        });
        filters[key] = tagify.value.map((item)=>item.value);
        tagify.on("add", function(e) {
            const value = e.detail.data.value;
            const key = filterElement.dataset.key;
            filters[key].push(value);
            doFilter();
            // Track event
            plausible("Event filter", {
                props: {
                    "Title": document.querySelector('meta[property="og:title"]').content,
                    "Appeared on": window.location.href,
                    "Filter name": key,
                    "Filter value": e.detail.data.hasOwnProperty("label") ? e.detail.data.label : e.detail.data.value
                }
            });
        });
        tagify.on("remove", function(e) {
            const value = e.detail.data.value;
            const key = filterElement.dataset.key;
            filters[key] = filters[key].filter((item)=>item !== value);
            doFilter();
        });
    });
    doFilter();
    // Show the filters
    eventList.querySelector(".list-filters").classList.remove("hidden");
});












function $d9399ec0c8779f73$var$_toConsumableArray(arr) {
    if (Array.isArray(arr)) {
        for(var i = 0, arr2 = Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
        return arr2;
    } else return Array.from(arr);
}
// Older browsers don't support event options, feature detect it.
// Adopted and modified solution from Bohdan Didukh (2017)
// https://stackoverflow.com/questions/41594997/ios-10-safari-prevent-scrolling-behind-a-fixed-overlay-and-maintain-scroll-posi
var $d9399ec0c8779f73$var$hasPassiveEvents = false;
if (typeof window !== "undefined") {
    var $d9399ec0c8779f73$var$passiveTestOptions = {
        get passive () {
            $d9399ec0c8779f73$var$hasPassiveEvents = true;
            return undefined;
        }
    };
    window.addEventListener("testPassive", null, $d9399ec0c8779f73$var$passiveTestOptions);
    window.removeEventListener("testPassive", null, $d9399ec0c8779f73$var$passiveTestOptions);
}
var $d9399ec0c8779f73$var$isIosDevice = typeof window !== "undefined" && window.navigator && window.navigator.platform && (/iP(ad|hone|od)/.test(window.navigator.platform) || window.navigator.platform === "MacIntel" && window.navigator.maxTouchPoints > 1);
var $d9399ec0c8779f73$var$locks = [];
var $d9399ec0c8779f73$var$documentListenerAdded = false;
var $d9399ec0c8779f73$var$initialClientY = -1;
var $d9399ec0c8779f73$var$previousBodyOverflowSetting = void 0;
var $d9399ec0c8779f73$var$previousBodyPaddingRight = void 0;
// returns true if `el` should be allowed to receive touchmove events.
var $d9399ec0c8779f73$var$allowTouchMove = function allowTouchMove(el) {
    return $d9399ec0c8779f73$var$locks.some(function(lock) {
        if (lock.options.allowTouchMove && lock.options.allowTouchMove(el)) return true;
        return false;
    });
};
var $d9399ec0c8779f73$var$preventDefault = function preventDefault(rawEvent) {
    var e = rawEvent || window.event;
    // For the case whereby consumers adds a touchmove event listener to document.
    // Recall that we do document.addEventListener('touchmove', preventDefault, { passive: false })
    // in disableBodyScroll - so if we provide this opportunity to allowTouchMove, then
    // the touchmove event on document will break.
    if ($d9399ec0c8779f73$var$allowTouchMove(e.target)) return true;
    // Do not prevent if the event has more than one touch (usually meaning this is a multi touch gesture like pinch to zoom).
    if (e.touches.length > 1) return true;
    if (e.preventDefault) e.preventDefault();
    return false;
};
var $d9399ec0c8779f73$var$setOverflowHidden = function setOverflowHidden(options) {
    // If previousBodyPaddingRight is already set, don't set it again.
    if ($d9399ec0c8779f73$var$previousBodyPaddingRight === undefined) {
        var _reserveScrollBarGap = !!options && options.reserveScrollBarGap === true;
        var scrollBarGap = window.innerWidth - document.documentElement.clientWidth;
        if (_reserveScrollBarGap && scrollBarGap > 0) {
            $d9399ec0c8779f73$var$previousBodyPaddingRight = document.body.style.paddingRight;
            document.body.style.paddingRight = scrollBarGap + "px";
        }
    }
    // If previousBodyOverflowSetting is already set, don't set it again.
    if ($d9399ec0c8779f73$var$previousBodyOverflowSetting === undefined) {
        $d9399ec0c8779f73$var$previousBodyOverflowSetting = document.body.style.overflow;
        document.body.style.overflow = "hidden";
    }
};
var $d9399ec0c8779f73$var$restoreOverflowSetting = function restoreOverflowSetting() {
    if ($d9399ec0c8779f73$var$previousBodyPaddingRight !== undefined) {
        document.body.style.paddingRight = $d9399ec0c8779f73$var$previousBodyPaddingRight;
        // Restore previousBodyPaddingRight to undefined so setOverflowHidden knows it
        // can be set again.
        $d9399ec0c8779f73$var$previousBodyPaddingRight = undefined;
    }
    if ($d9399ec0c8779f73$var$previousBodyOverflowSetting !== undefined) {
        document.body.style.overflow = $d9399ec0c8779f73$var$previousBodyOverflowSetting;
        // Restore previousBodyOverflowSetting to undefined
        // so setOverflowHidden knows it can be set again.
        $d9399ec0c8779f73$var$previousBodyOverflowSetting = undefined;
    }
};
// https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollHeight#Problems_and_solutions
var $d9399ec0c8779f73$var$isTargetElementTotallyScrolled = function isTargetElementTotallyScrolled(targetElement) {
    return targetElement ? targetElement.scrollHeight - targetElement.scrollTop <= targetElement.clientHeight : false;
};
var $d9399ec0c8779f73$var$handleScroll = function handleScroll(event, targetElement) {
    var clientY = event.targetTouches[0].clientY - $d9399ec0c8779f73$var$initialClientY;
    if ($d9399ec0c8779f73$var$allowTouchMove(event.target)) return false;
    if (targetElement && targetElement.scrollTop === 0 && clientY > 0) // element is at the top of its scroll.
    return $d9399ec0c8779f73$var$preventDefault(event);
    if ($d9399ec0c8779f73$var$isTargetElementTotallyScrolled(targetElement) && clientY < 0) // element is at the bottom of its scroll.
    return $d9399ec0c8779f73$var$preventDefault(event);
    event.stopPropagation();
    return true;
};
var $d9399ec0c8779f73$export$24fdf68abf432c44 = function disableBodyScroll(targetElement, options) {
    // targetElement must be provided
    if (!targetElement) {
        // eslint-disable-next-line no-console
        console.error("disableBodyScroll unsuccessful - targetElement must be provided when calling disableBodyScroll on IOS devices.");
        return;
    }
    // disableBodyScroll must not have been called on this targetElement before
    if ($d9399ec0c8779f73$var$locks.some(function(lock) {
        return lock.targetElement === targetElement;
    })) return;
    var lock = {
        targetElement: targetElement,
        options: options || {}
    };
    $d9399ec0c8779f73$var$locks = [].concat($d9399ec0c8779f73$var$_toConsumableArray($d9399ec0c8779f73$var$locks), [
        lock
    ]);
    if ($d9399ec0c8779f73$var$isIosDevice) {
        targetElement.ontouchstart = function(event) {
            if (event.targetTouches.length === 1) // detect single touch.
            $d9399ec0c8779f73$var$initialClientY = event.targetTouches[0].clientY;
        };
        targetElement.ontouchmove = function(event) {
            if (event.targetTouches.length === 1) // detect single touch.
            $d9399ec0c8779f73$var$handleScroll(event, targetElement);
        };
        if (!$d9399ec0c8779f73$var$documentListenerAdded) {
            document.addEventListener("touchmove", $d9399ec0c8779f73$var$preventDefault, $d9399ec0c8779f73$var$hasPassiveEvents ? {
                passive: false
            } : undefined);
            $d9399ec0c8779f73$var$documentListenerAdded = true;
        }
    } else $d9399ec0c8779f73$var$setOverflowHidden(options);
};
var $d9399ec0c8779f73$export$45a3ef215b2a5866 = function clearAllBodyScrollLocks() {
    if ($d9399ec0c8779f73$var$isIosDevice) {
        // Clear all locks ontouchstart/ontouchmove handlers, and the references.
        $d9399ec0c8779f73$var$locks.forEach(function(lock) {
            lock.targetElement.ontouchstart = null;
            lock.targetElement.ontouchmove = null;
        });
        if ($d9399ec0c8779f73$var$documentListenerAdded) {
            document.removeEventListener("touchmove", $d9399ec0c8779f73$var$preventDefault, $d9399ec0c8779f73$var$hasPassiveEvents ? {
                passive: false
            } : undefined);
            $d9399ec0c8779f73$var$documentListenerAdded = false;
        }
        // Reset initial clientY.
        $d9399ec0c8779f73$var$initialClientY = -1;
    } else $d9399ec0c8779f73$var$restoreOverflowSetting();
    $d9399ec0c8779f73$var$locks = [];
};
var $d9399ec0c8779f73$export$e5d0524c3725571e = function enableBodyScroll(targetElement) {
    if (!targetElement) {
        // eslint-disable-next-line no-console
        console.error("enableBodyScroll unsuccessful - targetElement must be provided when calling enableBodyScroll on IOS devices.");
        return;
    }
    $d9399ec0c8779f73$var$locks = $d9399ec0c8779f73$var$locks.filter(function(lock) {
        return lock.targetElement !== targetElement;
    });
    if ($d9399ec0c8779f73$var$isIosDevice) {
        targetElement.ontouchstart = null;
        targetElement.ontouchmove = null;
        if ($d9399ec0c8779f73$var$documentListenerAdded && $d9399ec0c8779f73$var$locks.length === 0) {
            document.removeEventListener("touchmove", $d9399ec0c8779f73$var$preventDefault, $d9399ec0c8779f73$var$hasPassiveEvents ? {
                passive: false
            } : undefined);
            $d9399ec0c8779f73$var$documentListenerAdded = false;
        }
    } else if (!$d9399ec0c8779f73$var$locks.length) $d9399ec0c8779f73$var$restoreOverflowSetting();
};


const $9d130cbb697e8193$var$mobileToggle = document.querySelector("[data-mobile-toggle]");
const $9d130cbb697e8193$var$mobileNav = document.querySelector("[data-mobile-navigation]");
const $9d130cbb697e8193$var$mobileBg = document.querySelector("[data-mobile-navigation-bg]");
const $9d130cbb697e8193$var$mobileClose = document.querySelector("[data-mobile-navigation-close]");
let $9d130cbb697e8193$var$isOpen = false;
const $9d130cbb697e8193$var$open = ()=>{
    $9d130cbb697e8193$var$isOpen = true;
    $9d130cbb697e8193$var$mobileNav.classList.add("is-active");
    $9d130cbb697e8193$var$mobileToggle.classList.add("is-active");
    $9d130cbb697e8193$var$mobileToggle.setAttribute("aria-expanded", "true");
    (0, $d9399ec0c8779f73$export$24fdf68abf432c44)($9d130cbb697e8193$var$mobileNav);
};
const $9d130cbb697e8193$var$close = ()=>{
    $9d130cbb697e8193$var$isOpen = false;
    $9d130cbb697e8193$var$mobileNav.classList.remove("is-active");
    $9d130cbb697e8193$var$mobileToggle.classList.remove("is-active");
    $9d130cbb697e8193$var$mobileToggle.setAttribute("aria-expanded", "false");
    (0, $d9399ec0c8779f73$export$e5d0524c3725571e)($9d130cbb697e8193$var$mobileNav);
};
const $9d130cbb697e8193$var$toggle = ()=>{
    ($9d130cbb697e8193$var$isOpen ? $9d130cbb697e8193$var$close : $9d130cbb697e8193$var$open)();
};
const $9d130cbb697e8193$var$onKeyDown = (event)=>{
    const { keyCode: keyCode, which: which } = event;
    const key = which || keyCode;
    switch(key){
        case 27:
            $9d130cbb697e8193$var$close();
            break;
        default:
    }
};
const $9d130cbb697e8193$var$init = ()=>{
    if ($9d130cbb697e8193$var$mobileToggle && $9d130cbb697e8193$var$mobileNav) $9d130cbb697e8193$var$mobileToggle.addEventListener("click", $9d130cbb697e8193$var$toggle);
    if ($9d130cbb697e8193$var$mobileBg) $9d130cbb697e8193$var$mobileBg.addEventListener("click", $9d130cbb697e8193$var$close);
    if ($9d130cbb697e8193$var$mobileClose) $9d130cbb697e8193$var$mobileClose.addEventListener("click", $9d130cbb697e8193$var$close);
    window.addEventListener("keydown", $9d130cbb697e8193$var$onKeyDown);
};
$9d130cbb697e8193$var$init();










var $ik8y3 = parcelRequire("ik8y3");
document.querySelectorAll(".release-list").forEach((releaseList)=>{
    // Collect all releases
    const releases = [];
    const teasers = releaseList.querySelectorAll(".release-teaser");
    teasers.forEach((element)=>{
        releases.push(JSON.parse(element.dataset.searchObject));
    });
    const itemsJsInstance = (0, $ik8y3.default)(releases, {
        aggregations: {
            format: {
                size: 50
            },
            genres: {
                size: 50,
                conjunction: false
            }
        }
    });
    // Initialize the filters
    const filters = {};
    let filtered = itemsJsInstance.search({
        filters: filters,
        per_page: 1000
    });
    const doFilter = function(e) {
        filtered = itemsJsInstance.search({
            filters: filters,
            per_page: 1000
        });
        // Hide filtered teasers
        teasers.forEach((element)=>{
            const id = element.dataset.id;
            if (filtered.data.items.some((item)=>item.id === id)) element.classList.remove("hidden");
            else element.classList.add("hidden");
        });
        // Show message if no results
        const noResults = releaseList.querySelector(".release-list__no-results");
        if (filtered.data.items.length === 0) noResults.classList.remove("hidden");
        else noResults.classList.add("hidden");
    };
    releaseList.querySelectorAll(".list-filters__filter").forEach((filterElement)=>{
        const key = filterElement.dataset.key;
        const usedOptions = filtered.data.aggregations[key].buckets.map((item)=>item.key);
        const allOptions = JSON.parse(filterElement.dataset.options);
        const options = usedOptions.map((option)=>allOptions.find((item)=>item.value === option)).filter((item)=>item !== undefined);
        if (options.length < 2) {
            filterElement.classList.add("hidden");
            return;
        }
        const inputElement = filterElement.querySelector("input");
        const tagify = new (0, (/*@__PURE__*/$parcel$interopDefault($00a848b12ea3af18$exports)))(inputElement, {
            enforceWhitelist: true,
            tagTextProp: "label",
            whitelist: options,
            dropdown: {
                enabled: 0,
                searchKeys: [
                    "label",
                    "searchBy"
                ],
                mapValueTo: "label",
                maxItems: 15
            }
        });
        filters[key] = tagify.value.map((item)=>item.value);
        tagify.on("add", function(e) {
            const value = e.detail.data.value;
            const key = filterElement.dataset.key;
            filters[key].push(value);
            doFilter();
            // Track event
            plausible("Release filter", {
                props: {
                    "Title": document.querySelector('meta[property="og:title"]').content,
                    "Appeared on": window.location.href,
                    "Filter name": key,
                    "Filter value": e.detail.data.hasOwnProperty("label") ? e.detail.data.label : e.detail.data.value
                }
            });
        });
        tagify.on("remove", function(e) {
            const value = e.detail.data.value;
            const key = filterElement.dataset.key;
            filters[key] = filters[key].filter((item)=>item !== value);
            doFilter();
        });
    });
    doFilter();
    // Show the filters
    releaseList.querySelector(".list-filters").classList.remove("hidden");
});





















var $b3734b9019fd8119$exports = {};
/*! npm.im/object-fit-images 3.2.4 */ "use strict";
var $b3734b9019fd8119$var$OFI = "bfred-it:object-fit-images";
var $b3734b9019fd8119$var$propRegex = /(object-fit|object-position)\s*:\s*([-.\w\s%]+)/g;
var $b3734b9019fd8119$var$testImg = typeof Image === "undefined" ? {
    style: {
        "object-position": 1
    }
} : new Image();
var $b3734b9019fd8119$var$supportsObjectFit = "object-fit" in $b3734b9019fd8119$var$testImg.style;
var $b3734b9019fd8119$var$supportsObjectPosition = "object-position" in $b3734b9019fd8119$var$testImg.style;
var $b3734b9019fd8119$var$supportsOFI = "background-size" in $b3734b9019fd8119$var$testImg.style;
var $b3734b9019fd8119$var$supportsCurrentSrc = typeof $b3734b9019fd8119$var$testImg.currentSrc === "string";
var $b3734b9019fd8119$var$nativeGetAttribute = $b3734b9019fd8119$var$testImg.getAttribute;
var $b3734b9019fd8119$var$nativeSetAttribute = $b3734b9019fd8119$var$testImg.setAttribute;
var $b3734b9019fd8119$var$autoModeEnabled = false;
function $b3734b9019fd8119$var$createPlaceholder(w, h) {
    return "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='" + w + "' height='" + h + "'%3E%3C/svg%3E";
}
function $b3734b9019fd8119$var$polyfillCurrentSrc(el) {
    if (el.srcset && !$b3734b9019fd8119$var$supportsCurrentSrc && window.picturefill) {
        var pf = window.picturefill._;
        // parse srcset with picturefill where currentSrc isn't available
        if (!el[pf.ns] || !el[pf.ns].evaled) // force synchronous srcset parsing
        pf.fillImg(el, {
            reselect: true
        });
        if (!el[pf.ns].curSrc) {
            // force picturefill to parse srcset
            el[pf.ns].supported = false;
            pf.fillImg(el, {
                reselect: true
            });
        }
        // retrieve parsed currentSrc, if any
        el.currentSrc = el[pf.ns].curSrc || el.src;
    }
}
function $b3734b9019fd8119$var$getStyle(el) {
    var style = getComputedStyle(el).fontFamily;
    var parsed;
    var props = {};
    while((parsed = $b3734b9019fd8119$var$propRegex.exec(style)) !== null)props[parsed[1]] = parsed[2];
    return props;
}
function $b3734b9019fd8119$var$setPlaceholder(img, width, height) {
    // Default: fill width, no height
    var placeholder = $b3734b9019fd8119$var$createPlaceholder(width || 1, height || 0);
    // Only set placeholder if it's different
    if ($b3734b9019fd8119$var$nativeGetAttribute.call(img, "src") !== placeholder) $b3734b9019fd8119$var$nativeSetAttribute.call(img, "src", placeholder);
}
function $b3734b9019fd8119$var$onImageReady(img, callback) {
    // naturalWidth is only available when the image headers are loaded,
    // this loop will poll it every 100ms.
    if (img.naturalWidth) callback(img);
    else setTimeout($b3734b9019fd8119$var$onImageReady, 100, img, callback);
}
function $b3734b9019fd8119$var$fixOne(el) {
    var style = $b3734b9019fd8119$var$getStyle(el);
    var ofi = el[$b3734b9019fd8119$var$OFI];
    style["object-fit"] = style["object-fit"] || "fill"; // default value
    // Avoid running where unnecessary, unless OFI had already done its deed
    if (!ofi.img) {
        // fill is the default behavior so no action is necessary
        if (style["object-fit"] === "fill") return;
        // Where object-fit is supported and object-position isn't (Safari < 10)
        if (!ofi.skipTest && // unless user wants to apply regardless of browser support
        $b3734b9019fd8119$var$supportsObjectFit && // if browser already supports object-fit
        !style["object-position"] // unless object-position is used
        ) return;
    }
    // keep a clone in memory while resetting the original to a blank
    if (!ofi.img) {
        ofi.img = new Image(el.width, el.height);
        ofi.img.srcset = $b3734b9019fd8119$var$nativeGetAttribute.call(el, "data-ofi-srcset") || el.srcset;
        ofi.img.src = $b3734b9019fd8119$var$nativeGetAttribute.call(el, "data-ofi-src") || el.src;
        // preserve for any future cloneNode calls
        // https://github.com/bfred-it/object-fit-images/issues/53
        $b3734b9019fd8119$var$nativeSetAttribute.call(el, "data-ofi-src", el.src);
        if (el.srcset) $b3734b9019fd8119$var$nativeSetAttribute.call(el, "data-ofi-srcset", el.srcset);
        $b3734b9019fd8119$var$setPlaceholder(el, el.naturalWidth || el.width, el.naturalHeight || el.height);
        // remove srcset because it overrides src
        if (el.srcset) el.srcset = "";
        try {
            $b3734b9019fd8119$var$keepSrcUsable(el);
        } catch (err) {
            if (window.console) console.warn("https://bit.ly/ofi-old-browser");
        }
    }
    $b3734b9019fd8119$var$polyfillCurrentSrc(ofi.img);
    el.style.backgroundImage = 'url("' + (ofi.img.currentSrc || ofi.img.src).replace(/"/g, '\\"') + '")';
    el.style.backgroundPosition = style["object-position"] || "center";
    el.style.backgroundRepeat = "no-repeat";
    el.style.backgroundOrigin = "content-box";
    if (/scale-down/.test(style["object-fit"])) $b3734b9019fd8119$var$onImageReady(ofi.img, function() {
        if (ofi.img.naturalWidth > el.width || ofi.img.naturalHeight > el.height) el.style.backgroundSize = "contain";
        else el.style.backgroundSize = "auto";
    });
    else el.style.backgroundSize = style["object-fit"].replace("none", "auto").replace("fill", "100% 100%");
    $b3734b9019fd8119$var$onImageReady(ofi.img, function(img) {
        $b3734b9019fd8119$var$setPlaceholder(el, img.naturalWidth, img.naturalHeight);
    });
}
function $b3734b9019fd8119$var$keepSrcUsable(el) {
    var descriptors = {
        get: function get(prop) {
            return el[$b3734b9019fd8119$var$OFI].img[prop ? prop : "src"];
        },
        set: function set(value, prop) {
            el[$b3734b9019fd8119$var$OFI].img[prop ? prop : "src"] = value;
            $b3734b9019fd8119$var$nativeSetAttribute.call(el, "data-ofi-" + prop, value); // preserve for any future cloneNode
            $b3734b9019fd8119$var$fixOne(el);
            return value;
        }
    };
    Object.defineProperty(el, "src", descriptors);
    Object.defineProperty(el, "currentSrc", {
        get: function() {
            return descriptors.get("currentSrc");
        }
    });
    Object.defineProperty(el, "srcset", {
        get: function() {
            return descriptors.get("srcset");
        },
        set: function(ss) {
            return descriptors.set(ss, "srcset");
        }
    });
}
function $b3734b9019fd8119$var$hijackAttributes() {
    function getOfiImageMaybe(el, name) {
        return el[$b3734b9019fd8119$var$OFI] && el[$b3734b9019fd8119$var$OFI].img && (name === "src" || name === "srcset") ? el[$b3734b9019fd8119$var$OFI].img : el;
    }
    if (!$b3734b9019fd8119$var$supportsObjectPosition) {
        HTMLImageElement.prototype.getAttribute = function(name) {
            return $b3734b9019fd8119$var$nativeGetAttribute.call(getOfiImageMaybe(this, name), name);
        };
        HTMLImageElement.prototype.setAttribute = function(name, value) {
            return $b3734b9019fd8119$var$nativeSetAttribute.call(getOfiImageMaybe(this, name), name, String(value));
        };
    }
}
function $b3734b9019fd8119$var$fix(imgs, opts) {
    var startAutoMode = !$b3734b9019fd8119$var$autoModeEnabled && !imgs;
    opts = opts || {};
    imgs = imgs || "img";
    if ($b3734b9019fd8119$var$supportsObjectPosition && !opts.skipTest || !$b3734b9019fd8119$var$supportsOFI) return false;
    // use imgs as a selector or just select all images
    if (imgs === "img") imgs = document.getElementsByTagName("img");
    else if (typeof imgs === "string") imgs = document.querySelectorAll(imgs);
    else if (!("length" in imgs)) imgs = [
        imgs
    ];
    // apply fix to all
    for(var i = 0; i < imgs.length; i++){
        imgs[i][$b3734b9019fd8119$var$OFI] = imgs[i][$b3734b9019fd8119$var$OFI] || {
            skipTest: opts.skipTest
        };
        $b3734b9019fd8119$var$fixOne(imgs[i]);
    }
    if (startAutoMode) {
        document.body.addEventListener("load", function(e) {
            if (e.target.tagName === "IMG") $b3734b9019fd8119$var$fix(e.target, {
                skipTest: opts.skipTest
            });
        }, true);
        $b3734b9019fd8119$var$autoModeEnabled = true;
        imgs = "img"; // reset to a generic selector for watchMQ
    }
    // if requested, watch media queries for object-fit change
    if (opts.watchMQ) window.addEventListener("resize", $b3734b9019fd8119$var$fix.bind(null, imgs, {
        skipTest: opts.skipTest
    }));
}
$b3734b9019fd8119$var$fix.supportsObjectFit = $b3734b9019fd8119$var$supportsObjectFit;
$b3734b9019fd8119$var$fix.supportsObjectPosition = $b3734b9019fd8119$var$supportsObjectPosition;
$b3734b9019fd8119$var$hijackAttributes();
$b3734b9019fd8119$exports = $b3734b9019fd8119$var$fix;


(0, (/*@__PURE__*/$parcel$interopDefault($b3734b9019fd8119$exports)))();




})();
//# sourceMappingURL=global.js.map
